var TAGS = {
  "wealthdesk": {
    "HomeController": [
      {
        "metaName": "title",
        "metaValue": "WealthDesk: Equity & ETF Portfolios from top Advisors",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "India's first Open Investment platform on top of broking that powers advisory, broking, wealth management, portfolio management to retail investors at scale.Our platform and products ecosystem impacts all the incumbents and new players in investment and Wealth Management space in the entire vlaue chain from ideation, research, to manufacturing to productization to distribution to execution in the client account.",
        "metaType": "default"
      }
    ],
    "FundDiscoveryController": [
      {
        "metaName": "title",
        "metaValue": "WealthBaskets on WealthDesk: Top Performing Stock & ETF Portfolios",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "India's first Open Investment platform on top of broking that powers advisory, broking, wealth management, portfolio management to retail investors at scale.Our platform and products ecosystem impacts all the incumbents and new players in investment and Wealth Management space in the entire vlaue chain from ideation, research, to manufacturing to productization to distribution to execution in the client account.",
        "metaType": "default"
      }
    ],
    "blog": [
      {
        "metaName": "title",
        "metaValue": "WealthDesk Blogs & Updates",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "India's first Open Investment platform on top of broking that powers advisory, broking, wealth management, portfolio management to retail investors at scale.Our platform and products ecosystem impacts all the incumbents and new players in investment and Wealth Management space in the entire vlaue chain from ideation, research, to manufacturing to productization to distribution to execution in the client account.",
        "metaType": "default"
      }
    ],
    "business": [
      {
        "metaName": "title",
        "metaValue": "WealthDesk Business: B2B Platform for Brokers, Advisors, PMS, AMC, MF Platforms",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "WeathDesk Business is a B2B SaaS investment technology platform that powers advisory, broking, wealth management & portfolio management to retail investors at scale.",
        "metaType": "default"
      }
    ],
    "full_service_broker": [
      {
        "metaName": "title",
        "metaValue": "Value Added Broking Platform for Full Service Brokers: WealthDesk Business",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "WealthDesk Business' investment technology platform scales advisory & broking business fees. Create & distribute WealthBasket equity & ETF portfolios from in house researchers & top advisors.",
        "metaType": "default"
      }
    ],
    "discount_brokers": [
      {
        "metaName": "title",
        "metaValue": "Value Added Broking Platform for Discount Brokers: WealthDesk Business",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "WealthDesk Business' investment technology platform scales advisory & broking business fees.Distribute WealthBasket equity & ETF portfolios from top advisors.",
        "metaType": "default"
      }
    ],
    "advisor": [
      {
        "metaName": "title",
        "metaValue": "Scale your Advisory and Research Brand With WealthDesk Business",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "WealthDesk Business is an investment technology platform for SEBI-registered Investment Advisors & Research Analysts. Create & distribute stock & ETF portfolio WealthBaskets.",
        "metaType": "default"
      }
    ],
    "ContactUsController": [
      {
        "metaName": "title",
        "metaValue": "WealthDesk Support: Contact Us Page",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Contact us for any support on WealthDesk and WealthDesk Business platform.",
        "metaType": "default"
      }
    ],
    "FAQController": [
      {
        "metaName": "title",
        "metaValue": "WealthDesk FAQs Page",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Frequently asked questions on the WealthDesk platform and their answers can be found here.",
        "metaType": "default"
      }
    ],
    "LoginController": [
      {
        "metaName": "title",
        "metaValue": "WealthDesk Login | Register",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Login or register to start investing in well researched, managed and automated portfolio wealthbaskets from WealthDesk.",
        "metaType": "default"
      }
    ],
    "DisclosureController": [
      {
        "metaName": "title",
        "metaValue": "N/A",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "India's first Open Investment platform on top of broking that powers advisory, broking, wealth management, portfolio management to retail investors at scale.Our platform and products ecosystem impacts all the incumbents and new players in investment and Wealth Management space in the entire vlaue chain from ideation, research, to manufacturing to productization to distribution to execution in the client account.",
        "metaType": "default"
      }
    ]
  },
  "openq": {
    "HomeController": [
      {
        "metaName": "title",
        "metaValue": "OpenQ: Sebi Registered Investment Advisor | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ is Sebi Registered Investment Advisor that offers smart beta portfolios and other investment tools like portfolio scanner and optimiser.",
        "metaType": "default"
      }
    ],
    "FundDiscoveryController": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Smart Beta WealthBaskets: Stock & ETF SmartBeta Portfolios",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ Smart Beta WealthBaskets are Stock and ETF portfolios based on Value, Size, Quality, Momentum, Dividend Yield and Volatility.",
        "metaType": "default"
      }
    ],
    "ContactUsController": [
      {
        "metaName": "title",
        "metaValue": "WealthDesk Support: Contact Us Page | OpenQ | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Contact us for any support on WealthDesk and WealthDesk Business platform.",
        "metaType": "default"
      }
    ],
    "FAQController": [
      {
        "metaName": "title",
        "metaValue": "OpenQ WealthBaskets FAQs Page",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Frequently asked questions on the OpenQ Smart Beta WealthBaskets platform and their answers can be found here.",
        "metaType": "default"
      }
    ],
    "OpenQHybridEquity": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Balanced HyBrid Equity Portfolio | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ Balanced HyBrid Equity WealthBasket dynamically switches between equity, debt and gold, depending upon the market situation.",
        "metaType": "default"
      }
    ],
    "OpenQMakeInIndia": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Make in India Manufacturing Portfolio | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ Make in India WealthBasket identifies stocks that may benefit from the long term theme of promoting manufacturing in India.",
        "metaType": "default"
      }
    ],
    "OpenQPharmaTop500New": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Pharma Stocks Portfolio | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ Pharma WealthBasket invests in Pharma stocks selected from the top 500 market cap stocks through proprietary algorithm that has given consistent returns.",
        "metaType": "default"
      }
    ],
    "OpenQIndiaConsumptionTop500New": [
      {
        "metaName": "title",
        "metaValue": "OpenQ India Consumption Portfolio | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ India Consumption WealthBasket invests in top performing cyclical/non cyclical consumer stocks which are selected based on a proprietary algorithm.",
        "metaType": "default"
      }
    ],
    "OpenQChemicalBasketTop500New": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Chemicals Stocks Portfolio | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "The OpenQ Chemicals WealthBasket invests in chemical stocks selected using a proprietary algorithm that has produced consistent returns over the past 20 years.",
        "metaType": "default"
      }
    ],
    "OpenQDefensiveMomentumTop500New": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Defensive Momentum Portfolio | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ Defensive Momentum WealthBasket captures the risk premium from Momentum by using a proprietary algorithm over 2 business cycle of beta neutral performance.",
        "metaType": "default"
      }
    ],
    "QuantechDigitalIndiaNew": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Digital India IT Stocks Portfolio | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ Digital India WealthBasket invests in stocks that will benefit the most due to digital India initiatives. Stocks are selected based on proprietary algorithm.",
        "metaType": "default"
      }
    ],
    "QuantechBankingServiceTop500New": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Banking & Investment Services Portfolio | WelathDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ Banking & Investment Services WealthBasket invests in banking services sector companies using a proprietary algorithms",
        "metaType": "default"
      }
    ],
    "QuantechMNCNew": [
      {
        "metaName": "title",
        "metaValue": "OpenQ MNC Stocks Portfolio | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ MNC WealthBasket is selected from a pool of listed MNCs' top 500 stocks and have shown to generate consistent returns over long term.",
        "metaType": "default"
      }
    ],
    "OpenQInfrastructureRealEstateTop500": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Infra & Realty Portfolio | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Invest in the infrastructure and realty companies that can benefit from infrastructure push by the government with the OpenQ Infra and Realty WealthBasket",
        "metaType": "default"
      }
    ]
  },
  "sapient": {
    "HomeController": [
      {
        "metaName": "title",
        "metaValue": "Sapient Wealth Advisors & Brokers | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Sapient Wealth Advisory's diversified portfolio combines a mixture of stocks or ETFs that combine to produce better performance through research.",
        "metaType": "default"
      }
    ],
    "FundDiscoveryController": [
      {
        "metaName": "title",
        "metaValue": "Invest in Smart Beta Portfolios | Sapient Wealth Advisors | WealthBaskets",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Sapient Wealth Advisors | Invest in WealthBaskets which reflects a theme, investment strategy, or idea with stocks and ETFs weighted according to a rigorous investment process.",
        "metaType": "default"
      }
    ],
    "ContactUsController": [
      {
        "metaName": "title",
        "metaValue": "WealthDesk Support: Contact Us Page | Sapient | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Our support team will assist with questions regarding WealthBaskets (Asset Management), Transactions, Portfolio, Rebalance and more",
        "metaType": "default"
      }
    ],
    "FAQController": [
      {
        "metaName": "title",
        "metaValue": "FAQs | Sapient Wealth Advisors | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Find answers to frequently asked questions (FAQs) about Sapient WealthDesk, How to invest in WealthBaskets, Pricing, and more.",
        "metaType": "default"
      }
    ],
    "DisclosureController": [
      {
        "metaName": "title",
        "metaValue": "Disclosure | Sapient Wealth Advisors | WealthDesk ",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Privacy Policies, Terms & Conditions, and disclaimers affiliated with WealthBaskets",
        "metaType": "default"
      }
    ],
    "TamoharaTruffle": [
      {
        "metaName": "title",
        "metaValue": "Tamohara Truffle Flexi Cap Strategy Portfolio | Sapient Wealth Advisors | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Truffle Flexi Cap Strategy WealthBasket objective is to deliver absolute wealth creation through a concentrated, long only, public equities portfolio.",
        "metaType": "default"
      }
    ],
    "TLES": [
      {
        "metaName": "title",
        "metaValue": "Tamohara Long Term Equity Strategy Portfolio | Sapient Wealth | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Tamohara Long Term Equity WealthBasket invests in not more than 20 high-quality businesses that will take advantage of the growth potential of India's economy",
        "metaType": "default"
      }
    ],
    "SIPTruffle": [
      {
        "metaName": "title",
        "metaValue": "Tamohara Stock SIP Portfolio | Sapient Wealth Advisors | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Tamohara Stock SIP WealthBasket is a direct equity SIP consists of seven handpicked stocks, which have a structural opportunity to grow in India over the next decade",
        "metaType": "default"
      }
    ],
    "TamoharaVip": [
      {
        "metaName": "title",
        "metaValue": "Tamohara Vaccinate India Portfolio Strategy | Sapient Wealth | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Tamohara Vaccinate India Portfolio Strategy WealthBasket is a Multi Cap Equity Portfolio that invests in quality stocks",
        "metaType": "default"
      }
    ],
    "TamoharaAgile": [
      {
        "metaName": "title",
        "metaValue": "Tamohara Agile Strategy Portfolio | Sapient Wealth Advisors | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Tamohara Agile Strategy is a long only equity WealthBasket of the top 25 Stocks selected through a “Multi Factor Process” from the BSE200 Universe",
        "metaType": "default"
      }
    ],
    "ETF": [
      {
        "metaName": "title",
        "metaValue": "Tamohara Multi Asset Strategy Portfolio | Sapient Wealth | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Tamohara Multi Asset Strategy WealthBasket offers investors exposure to a broader range of Assets ,Sectors & Strategies providing opportunity for growth while carefully managing risk",
        "metaType": "default"
      }
    ],
    "TIOS": [
      {
        "metaName": "title",
        "metaValue": "Tamohara India Opportunities Strategy | Sapient Wealth | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Tamohara India Opportunities Strategy WealthBasket focuses on 15-18 high-quality businesses that have a proven business model that is proven to succeed.",
        "metaType": "default"
      }
    ]
  },
  "finnovators": {
    "HomeController": [
      {
        "metaName": "title",
        "metaValue": "Finnovators Solutions Pvt Ltd | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Finnovators is a financial solutions company that focuses on protecting and growing investor capital by managing all aspects of investments.",
        "metaType": "default"
      }
    ],
    "FundDiscoveryController": [
      {
        "metaName": "title",
        "metaValue": "Invest in Smart Beta Stock & ETF Portfolios | Finnovators | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Finnovators | Invest in WealthBaskets which reflects a theme, investment strategy, or idea with stocks and ETFs weighted according to a rigorous investment process.",
        "metaType": "default"
      }
    ],
    "FAQController": [
      {
        "metaName": "title",
        "metaValue": "FAQs | Finnovators Solutions Pvt Ltd | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Find answers to frequently asked questions (FAQs) about Finnovators, How to invest in WealthBaskets, Pricing, and more.",
        "metaType": "default"
      }
    ],
    "ContactUsController": [
      {
        "metaName": "title",
        "metaValue": "WealthDesk Support: Contact Us Page | Finnovators | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Our support team will assist with questions regarding WealthBaskets (Asset Management), Transactions, Portfolio, Rebalance and more",
        "metaType": "default"
      }
    ],
    "DisclosureController": [
      {
        "metaName": "title",
        "metaValue": "Disclosure | Finnovators Solutions Pvt Ltd | WealthDesk ",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Privacy Policies, Terms & Conditions, and disclaimers affiliated with Finnovators WealthBaskets",
        "metaType": "default"
      }
    ],
    "TamoharaTruffle": [
      {
        "metaName": "title",
        "metaValue": "Tamohara Truffle Flexi Cap Strategy Portfolio | Finnovators | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Truffle Flexi Cap Strategy WealthBasket objective is to deliver absolute wealth creation through a concentrated, long only, public equities portfolio.",
        "metaType": "default"
      }
    ],
    "Q": [
      {
        "metaName": "title",
        "metaValue": "Tamohara Q Portfolio | Finnovators | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "The Tamohara Q WealthBasket strategy chooses stocks based on company ranking factors: integrity (45% weight), quality of business (25% weight), growth (20% weight), valuation and momentum (5% weight).",
        "metaType": "default"
      }
    ],
    "TLES": [
      {
        "metaName": "title",
        "metaValue": "Tamohara Long Term Equity Strategy Portfolio | Finnovators | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Tamohara Long Term Equity WealthBasket invests in not more than 20 high-quality businesses that will take advantage of the growth potential of India's economy",
        "metaType": "default"
      }
    ],
    "SIPTruffle": [
      {
        "metaName": "title",
        "metaValue": "Tamohara Stock SIP Portfolio | Finnovators | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Tamohara Stock SIP WealthBasket is a direct equity SIP consists of seven handpicked stocks, which have a structural opportunity to grow in India over the next decade",
        "metaType": "default"
      }
    ],
    "TamoharaVip": [
      {
        "metaName": "title",
        "metaValue": "Tamohara Vaccinate India Portfolio Strategy Portfolio | Finnovators | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Tamohara Vaccinate India Portfolio Strategy WealthBasket is a Multi Cap Equity Portfolio that invests in quality stocks",
        "metaType": "default"
      }
    ],
    "TamoharaAgile": [
      {
        "metaName": "title",
        "metaValue": "Tamohara Agile Strategy Portfolio | Finnovators | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Tamohara Agile Strategy is a long only equity WealthBasket of the top 25 Stocks selected through a “Multi Factor Process” from the BSE200 Universe",
        "metaType": "default"
      }
    ],
    "TIOS": [
      {
        "metaName": "title",
        "metaValue": "Tamohara India Opportunities Strategy Portfolio | Finnovators | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Tamohara India Opportunities Strategy WealthBasket focuses on 15-18 high-quality businesses that have a proven business model that is proven to succeed.",
        "metaType": "default"
      }
    ]
  },
  "tamohara": {
    "HomeController": [
      {
        "metaName": "title",
        "metaValue": "Tamohara Portfolio Management Services WealthBaskets | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Tamohara Portfolio Management Services offers select stocks and ETFs from medium and small cap companies that are safe, have high returns, and flexibility.",
        "metaType": "default"
      }
    ],
    "FundDiscoveryController": [
      {
        "metaName": "title",
        "metaValue": "Tamohara Investment Advisory Services Portfolios | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Invest in Tamohara Investment Advisory WealthBaskets which  stands on a foundation of time-tested investment principles, focusing on long-term value creation",
        "metaType": "default"
      }
    ],
    "FAQController": [
      {
        "metaName": "title",
        "metaValue": "FAQs Tamohara  WealthBaskets | WealthDesk ",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Find answers to frequently asked questions (FAQs) about Tamohara , How to invest in WealthBaskets, Pricing, and more.",
        "metaType": "default"
      }
    ],
    "ContactUsController": [
      {
        "metaName": "title",
        "metaValue": "WealthDesk Support: Contact Us Page | Tamohara | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Our support team will assist with questions regarding WealthBaskets (Asset Management), Transactions, Portfolio, Rebalance and more",
        "metaType": "default"
      }
    ],
    "DisclosureController": [
      {
        "metaName": "title",
        "metaValue": "Disclosure | Tamohara Investment Managers WealthDesk ",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Privacy Policies, Terms & Conditions, and disclaimers affiliated with Tamohara WealthBaskets",
        "metaType": "default"
      }
    ],
    "TamoharaTruffle": [
      {
        "metaName": "title",
        "metaValue": "Tamohara Truffle Flexi Cap Strategy Portfolio | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Truffle Flexi Cap Strategy WealthBasket objective is to deliver absolute wealth creation through a concentrated, long only, public equities portfolio.",
        "metaType": "default"
      }
    ],
    "TLES": [
      {
        "metaName": "title",
        "metaValue": "Tamohara Long Term Equity Strategy Portfolio | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Tamohara Long Term Equity WealthBasket invests in not more than 20 high-quality businesses that will take advantage of the growth potential of India's economy",
        "metaType": "default"
      }
    ],
    "SIPTruffle": [
      {
        "metaName": "title",
        "metaValue": "Tamohara Stock SIP Portfolio| WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Tamohara Stock SIP WealthBasket is a direct equity SIP consists of seven handpicked stocks, which have a structural opportunity to grow in India over the next decade",
        "metaType": "default"
      }
    ],
    "TamoharaVip": [
      {
        "metaName": "title",
        "metaValue": "Tamohara Vaccinate India Portfolio Strategy | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Tamohara Vaccinate India Portfolio Strategy WealthBasket is a Multi Cap Equity Portfolio that invests in quality stocks",
        "metaType": "default"
      }
    ],
    "TamoharaAgile": [
      {
        "metaName": "title",
        "metaValue": "Tamohara Agile Strategy Portfolio | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Tamohara Agile Strategy is a long only equity WealthBasket of the top 25 Stocks selected through a “Multi Factor Process” from the BSE200 Universe",
        "metaType": "default"
      }
    ],
    "TIOS": [
      {
        "metaName": "title",
        "metaValue": "Tamohara India Opportunities Strategy Portfolio | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Tamohara India Opportunities Strategy WealthBasket focuses on 15-18 high-quality businesses that have a proven business model that is proven to succeed.",
        "metaType": "default"
      }
    ],
    "Q": [
      {
        "metaName": "title",
        "metaValue": "Tamohara Q Portfolio | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "The Tamohara Q WealthBasket strategy chooses stocks based on company ranking factors: integrity (45% weight), quality of business (25% weight), growth (20% weight), valuation and momentum (5% weight).",
        "metaType": "default"
      }
    ]
  },
  "sushilfinance": {
    "HomeController": [
      {
        "metaName": "title",
        "metaValue": "Sushil Finance Advisory WealthBaskets | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Sushil Finance use the best of technology and automation to bring you profitable Markets, Invest and take your Financials to the next level",
        "metaType": "default"
      }
    ],
    "FundDiscoveryController": [
      {
        "metaName": "title",
        "metaValue": "Invest in Smart Beta WealthBaskets: Stock & ETF Portfolios | Sushil Finance Advisory | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Sushil Finance Advisory | Invest in WealthBaskets which reflects a theme, investment strategy, or idea with stocks and ETFs weighted according to a rigorous investment process.",
        "metaType": "default"
      }
    ],
    "FAQController": [
      {
        "metaName": "title",
        "metaValue": "FAQs | WealthBaskets | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Find answers to frequently asked questions (FAQs) about WealthDesk, How to invest in WealthBaskets, Pricing, and more.",
        "metaType": "default"
      }
    ],
    "DisclosureController": [
      {
        "metaName": "title",
        "metaValue": "Disclosure | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Privacy Policies, Terms & Conditions, and disclaimers affiliated with WealthBaskets",
        "metaType": "default"
      }
    ],
    "ContactUsController": [
      {
        "metaName": "title",
        "metaValue": "WealthDesk Support: Contact Us Page",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Get in touch with us for any questions or concerns regarding WealthBaskets",
        "metaType": "default"
      }
    ],
    "OPENQHybridEquity": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Balanced Hybrid Equity WealthBasket | Arihant Capital | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ Balanced HyBrid Equity WealthBasket,This portfolio dynamically switches between equity, debt and gold, depending upon the market situation.",
        "metaType": "default"
      }
    ],
    "OPENQMakeInIndia": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Make in India WealthBasket | Sushil Finance Advisory | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ Make in India WealthBasket portfolio identifies stocks that may benefit from the long-term theme of promoting manufacturing in India.",
        "metaType": "default"
      }
    ],
    "OPENQPharmaTop500New": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Pharma WealthBasket | Sushil Finance Advisory | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "A proprietary algorithm enabled OpenQ Pharma WealthBasket to deliver consistent returns by investing in Pharma stocks from the top 500 market cap companies",
        "metaType": "default"
      }
    ],
    "OpenQIndiaConsumptionTop500New": [
      {
        "metaName": "title",
        "metaValue": "OpenQ India Consumption WealthBasket | Sushil Finance Advisory | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ India Consumption WealthBasket that invests in top performing cyclical/non cyclical consumer stocks which are selected based on a proprietary algorithm. These stocks have generated consistent returns over 10 years of backtesting.",
        "metaType": "default"
      }
    ],
    "OpenQChemicalBasketTop500New": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Chemicals WealthBasket | Sushil Finance Advisory | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ Chemicals WealthBasket that invests in chemical stocks that are selected based on a proprietary algorithm which has shown to have generated consistent returns over last 20 years of backtest.",
        "metaType": "default"
      }
    ],
    "OpenQDefensiveMomentumTop500New": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Defensive Momentum WealthBasket | Sushil Finance Advisory | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ Defensive Momentum WealthBasket captures the risk premium from Momentum. Stocks are selected by using a proprietary algorithm over 2 business cycle of beta neutral performance.",
        "metaType": "default"
      }
    ],
    "QuantechDigitalIndiaNew": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Digital India WealthBasket | Sushil Finance Advisory | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ Digital India WealthBasket invests in stocks that will benefit the most due to digital India initiatives. Stocks are selected based on proprietary algorithm.",
        "metaType": "default"
      }
    ],
    "QuantechBankingServiceTop500New": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Banking & Investment Services WealthBasket | Sushil Finance Advisory | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ Banking & Investment Services WealthBasket invests in banks & banking services sector companies that have generated consistent returns over last 8 years and are selected based on a proprietary algorithm.",
        "metaType": "default"
      }
    ],
    "QuantechMNCNew": [
      {
        "metaName": "title",
        "metaValue": "OpenQ MNC WealthBasket | Sushil Finance Advisory | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ MNC WealthBasket Wealth Basket is selected from a pool of listed MNCs which are part of top 500 stocks and have shown to generate consistent return over long term on our proprietary algorithm",
        "metaType": "default"
      }
    ]
  },
  "abakkus": {
    "HomeController": [
      {
        "metaName": "title",
        "metaValue": "Abakkus Asset Management | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Abakkus Asset Management focuses on alpha generation and stability along with liquidity in a diversified portfolio agnostic of benchmarks.",
        "metaType": "default"
      }
    ],
    "FundDiscoveryController": [
      {
        "metaName": "title",
        "metaValue": "Abakkus Smart Portfolios WealthBaskets | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Abakkus Smart Portfolios are WealthBaskets that reflect a theme, strategy, or idea with stocks & ETFs weighted according to a rigorous investment process.",
        "metaType": "default"
      }
    ],
    "FAQController": [
      {
        "metaName": "title",
        "metaValue": "FAQs | Abakkus | WealthBaskets | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Find answers to frequently asked questions (FAQs) about WealthDesk (Abakkus Asset Management). How to invest in WealthBaskets, Pricing, and more.",
        "metaType": "default"
      }
    ],
    "DisclosureController": [
      {
        "metaName": "title",
        "metaValue": "Disclosure | Abakkus Portfolio | WealthBaskets | WealthDesk ",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Privacy Policies, Terms & Conditions, and disclaimers affiliated with WealthBaskets (Abakkus Asset Management) & WealthDesk.",
        "metaType": "default"
      }
    ],
    "AbakkusSmartFlexiCapPortfolio": [
      {
        "metaName": "title",
        "metaValue": "Abakkus Smart Flexi-Cap Portfolio | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Abakkus Smart Flexi-Cap Portfolio WealthBasket aims to generate alpha & risk adjusted returns by creating a portfolio predominantly with Top 250 companies.",
        "metaType": "default"
      }
    ],
    "AbakkusSmartBuildIndiaPortfolio": [
      {
        "metaName": "title",
        "metaValue": "Abakkus Smart Build India Portfolio | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "By investing predominantly in companies benefiting from economic development, Abakkus Smart Build India WealthBasket strives to generate alpha and risk-adjusted returns for investors.",
        "metaType": "default"
      }
    ],
    "ContactUs": [
      {
        "metaName": "title",
        "metaValue": "Contact Us | Abakkus Asset Management | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Our support team will assist with questions regarding WealthBaskets (Asset Management), Transactions, Portfolio, Rebalance and more",
        "metaType": "default"
      }
    ]
  },
  "algosmith": {
    "HomeController": [
      {
        "metaName": "title",
        "metaValue": "Algosmith SEBI Registered Investment Advisor | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Algosmith's algorithms analyze data for over a century in market cycles across the globe to help you make highly accurate stock market investments",
        "metaType": "default"
      }
    ],
    "FundDiscoveryController": [
      {
        "metaName": "title",
        "metaValue": "Invest in AlogoSmit India Smart Beta Portfolios | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Invest in AlgoSmith Portfolios which uses years of stock market expertise and technology to understand the market and advise",
        "metaType": "default"
      }
    ],
    "FAQController": [
      {
        "metaName": "title",
        "metaValue": "FAQs | AlgoSmit WealthBaskets | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Find answers to frequently asked questions (FAQs) about AlgoSmith, How to invest in WealthBaskets, Pricing, and more.",
        "metaType": "default"
      }
    ],
    "DisclosureController": [
      {
        "metaName": "title",
        "metaValue": "Disclosure | AlogoSmith WealthBaskets | WealthDesk ",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Privacy Policies, Terms & Conditions, and disclaimers affiliated with AlgoSmith WealthBaskets",
        "metaType": "default"
      }
    ],
    "ContactUsController": [
      {
        "metaName": "title",
        "metaValue": "WealthDesk Support: Contact Us | AlgoSmith",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Get in touch with us for any questions or concerns regarding AlgoSmith WealthBaskets",
        "metaType": "default"
      }
    ],
    "Turtlevalue": [
      {
        "metaName": "title",
        "metaValue": "AlgoSmith Turtle Value Portfolio | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "AlgoSmith Turtle value WealthBasket is a low volatility portfolio of value stocks selected based on our proprietary metrics. ",
        "metaType": "default"
      }
    ],
    "Frog": [
      {
        "metaName": "title",
        "metaValue": "AlgoSmith Frog Portfolio | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "AlgoSmith Frog WealthBasket uses CAN SLIM, an investment strategy that picks stocks using Quant and AI tools using both Fundamental and Technical analysis.",
        "metaType": "default"
      }
    ],
    "AlgoTurtleGrowth": [
      {
        "metaName": "title",
        "metaValue": "AlgoSmith Turtle Growth Portfolio | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "AlgoSmith's Turtle growth is a low volatility WealthBasket of growth stocks selected based on our proprietary metrics.",
        "metaType": "default"
      }
    ],
    "Elephant": [
      {
        "metaName": "title",
        "metaValue": "AlgoSmith Elephant Portfolio | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "AlgoSmith's Elephant WealthBasket is based on the MarketSmith Guru Screens that is designed to uncover stock ideas based on the winning investment strategies",
        "metaType": "default"
      }
    ],
    "AlgoDolphin": [
      {
        "metaName": "title",
        "metaValue": "AlgoSmith Algo Dolphin Portfolio | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "AlgoSmith's Dolphin WealthBasket is based on MarketSmith Indias flagship screen of leading growth stocks 'Growth50'.",
        "metaType": "default"
      }
    ]
  },
  "myalternates": {
    "HomeController": [
      {
        "metaName": "title",
        "metaValue": "My Alternates Financial Services | WealthBasketsMy Alternates SEBI Registered Investment Advisor | WealthBaskets",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "My Alternates by PMS Bazaar offers WealthBaskets which is a research backed mix of stocks or ETFs which gives you a diversified portfolio with improved performance.",
        "metaType": "default"
      }
    ],
    "FundDiscoveryController": [
      {
        "metaName": "title",
        "metaValue": "Invest in Smart Beta Portfolios | My Alternates Financial Services | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "My Alternates by PMS Bazaar, Invest in WealthBaskets which reflects a theme, investment strategy, or idea with stocks and ETFs weighted according to a rigorous investment process.",
        "metaType": "default"
      }
    ],
    "FAQController": [
      {
        "metaName": "title",
        "metaValue": "FAQs | My Alternatives Financial Services | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Find answers to frequently asked questions (FAQs) about My Alternatives, How to invest in WealthBaskets, Pricing, and more.",
        "metaType": "default"
      }
    ],
    "DisclosureController": [
      {
        "metaName": "title",
        "metaValue": "Disclosure | My Alternatives Financial Services | WealthDesk ",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Privacy Policies, Terms & Conditions, and disclaimers affiliated with My Alternatives WealthBaskets",
        "metaType": "default"
      }
    ],
    "ContactUsController": [
      {
        "metaName": "title",
        "metaValue": "My Alternatives Financial Services Support: Contact Us | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Get in touch with us for any questions or concerns regarding My Alternatives WealthBaskets or WealthDesk",
        "metaType": "default"
      }
    ],
    "OpenQDefensiveMomentumTop500New": [
      {
        "metaName": "title",
        "metaValue": "OpenQ M3 WealthBasket | My Alternates | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ M3 is a Defensive Momentum WealthBasket captures the risk premium from Momentum by using a proprietary algorithm over 2 business cycle of beta neutral performance.",
        "metaType": "default"
      }
    ],
    "AAANEXT": [
      {
        "metaName": "title",
        "metaValue": "AAA NEXT Generation | My Alternates | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "AAA NEXT Generation WealthBasket aims to capitalize on robust digital ecosystem and faster digital adoption by focusing on companies leading the change.",
        "metaType": "default"
      }
    ]
  },
  "arihantcapital": {
    "HomeController": [
      {
        "metaName": "title",
        "metaValue": "Arihant Capital Markets Ltd | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Finmo Investment Advisory offers select stocks and ETFs from medium and small cap companies that are safe, have high returns, and provide flexibility.",
        "metaType": "default"
      }
    ],
    "FundDiscoveryController": [
      {
        "metaName": "title",
        "metaValue": "Arihant Capital Market's Portfolios | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Invest in Arihant Capital Advisory WealthBaskets which reflects a theme, investment strategy, or idea with stocks and ETFs weighted according to a rigorous investment process.",
        "metaType": "default"
      }
    ],
    "FAQController": [
      {
        "metaName": "title",
        "metaValue": "FAQs | Arihant Capital WealthBaskets | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Find answers to frequently asked questions (FAQs) about WealthDesk, How to invest in WealthBaskets, Pricing, and more.",
        "metaType": "default"
      }
    ],
    "DisclosureController": [
      {
        "metaName": "title",
        "metaValue": "Disclosure | Arihant Capital Markets Ltd | WealthDesk ",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Privacy Policies, Terms & Conditions, and disclaimers affiliated with WealthBaskets",
        "metaType": "default"
      }
    ],
    "ContactUsController": [
      {
        "metaName": "title",
        "metaValue": "Arihant Capital Market Support: Contact Us | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Get in touch with us for any questions or concerns regarding WealthBaskets",
        "metaType": "default"
      }
    ],
    "OpenQHybridEquity": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Balanced Hybrid Equity WealthBasket | Arihant Capital | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ Balanced HyBrid Equity WealthBasket, This portfolio dynamically switches between equity, debt and gold, depending upon the market situation.",
        "metaType": "default"
      }
    ],
    "OpenQMakeInIndia": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Make in India Portfolio | Arihant Capital | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ Make in India WealthBasket identifies stocks that may benefit from the long term theme of promoting manufacturing in India.",
        "metaType": "default"
      }
    ],
    "OpenQPharmaTop500New": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Pharma Portfolio | Arihant Capital | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ Pharma WealthBasket invests in Pharma stocks selected from the top 500 market cap stocks through proprietary algorithm that has given consistent returns.",
        "metaType": "default"
      }
    ],
    "OpenQIndiaConsumptionTop500New": [
      {
        "metaName": "title",
        "metaValue": "OpenQ India Consumption Portfolio | Arihant Capital | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ India Consumption WealthBasket invests in top performing cyclical/non cyclical consumer stocks which are selected based on a proprietary algorithm.",
        "metaType": "default"
      }
    ],
    "OpenQChemicalBasketTop500New": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Chemicals Portfolio | Arihant Capital | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ Chemicals WealthBasket that invests in chemical stocks that are selected based on a proprietary algorithm which has shown to have generated consistent returns over last 20 years of backtest.",
        "metaType": "default"
      }
    ],
    "OpenQDefensiveMomentumTop500New": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Defensive Momentum Portfolio | Arihant Capital | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ Defensive Momentum WealthBasket captures the risk premium from Momentum by using a proprietary algorithm over 2 business cycle of beta neutral performance.",
        "metaType": "default"
      }
    ],
    "QuantechDigitalIndiaNew": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Digital India Portfolio| Arihant Capital | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ Digital India WealthBasket invests in stocks that will benefit the most due to digital India initiatives. Stocks are selected based on proprietary algorithm.",
        "metaType": "default"
      }
    ],
    "QuantechBankingServiceTop500New": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Banking & Investment Services Portfolio | Arihant Capital | WelathDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ Banking & Investment Services WealthBasket invests in banking services sector companies using a proprietary algorithms",
        "metaType": "default"
      }
    ],
    "ArihantEVs": [
      {
        "metaName": "title",
        "metaValue": "Arihant Capital Markets EVs Club Portfolio | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Arihant Capital Market's EVs Club WealthBasket focuses on Auto Mobile companies which are now trying to switch to less energy-intensive options",
        "metaType": "default"
      }
    ],
    "DiwaliPicks2021": [
      {
        "metaName": "title",
        "metaValue": "Diwali Mithai Portfolio | Arihant Capital | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "As part of Diwali 2021 stock picks, our research team has recommended stocks that one can look to buy for long term perspective.",
        "metaType": "default"
      }
    ],
    "dividendyield": [
      {
        "metaName": "title",
        "metaValue": "Arihant Capital Markets Dividend Planet Portfolio | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Arihant Capital Dividend Planet WealthBasket consists of stocks with dividend yields of at least 4% and has maintained a good Return on Equity.",
        "metaType": "default"
      }
    ],
    "ArihantInsurance": [
      {
        "metaName": "title",
        "metaValue": "Arihant Capital Markets Insurance Star Portfolio | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Arihant Capital Insurance Star WealthBasket focuses on insurance sector stocks that are expected to increase at a CAGR of 5.3% between 2019 and 2023.",
        "metaType": "default"
      }
    ],
    "Cancoffee": [
      {
        "metaName": "title",
        "metaValue": "Arihant Capital Coffee Can Portfolio | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Arihant Capital's Coffee Can WealthBasket consists of companies that have shown strong growth in sales over the years and have a high return on capital employed.",
        "metaType": "default"
      }
    ],
    "OpenQInfrastructureRealEstateTop500": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Infra & Realty Portfolio | Arihant Capital | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Invest in the infrastructure and realty companies that can benefit from infrastructure push by the government with the OpenQ Infra and Realty WealthBasket",
        "metaType": "default"
      }
    ],
    "LOTUSDEWHFT": [
      {
        "metaName": "title",
        "metaValue": "Lotusdew High Frequency Strategy Portfolio | Arihant Capital | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Lotusdew High Frequency strategy WealthBasket behaves like a long-only event based hedge fund.",
        "metaType": "default"
      }
    ],
    "PocketPortfolio": [
      {
        "metaName": "title",
        "metaValue": "Arihant Pocket Portfolio | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Arihant Pocket Portfolio WealthBasket is a Small Ticket Size portfolio that Invests in 5 stocks having a value less than Rs. 100. Combination of Small-Cap and Mid Cap Stocks based on Techno Funda Strategy for optimum returns.",
        "metaType": "default"
      }
    ],
    "LOTUSDEWBSE": [
      {
        "metaName": "title",
        "metaValue": "Lotusdew BSE Hidden Gems Portfolio | Arihant Capital | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Lotusdew BSE Hidden Gems is a high risk WealthBasket where we select companies with less than 1000 crore market cap which are listed on BSE but not on NSE.",
        "metaType": "default"
      }
    ],
    "QuantechMNCNew": [
      {
        "metaName": "title",
        "metaValue": "OpenQ MNC Portfolio| Arihant Capital Markets | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ MNC WealthBasket is selected from a pool of listed MNCs top 500 stocks and have shown to generate consistent return over long term.",
        "metaType": "default"
      }
    ]
  },
  "plindia": {
    "HomeController": [
      {
        "metaName": "title",
        "metaValue": "PI India | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Each WealthBasket reflects an investment strategy, theme or an idea with underlying stocks, ETFs accordingly weighted following a rigorous research process.",
        "metaType": "default"
      }
    ],
    "FundDiscoveryController": [
      {
        "metaName": "title",
        "metaValue": "Invest in Smart Beta WealthBaskets: Stock & ETF Portfolios | PI India | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "PI India | Invest in WealthBaskets which reflects a theme, investment strategy, or idea with stocks and ETFs weighted according to a rigorous investment process.",
        "metaType": "default"
      }
    ],
    "FAQController": [
      {
        "metaName": "title",
        "metaValue": "FAQs | WealthBaskets | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Find answers to frequently asked questions (FAQs) about WealthDesk, How to invest in WealthBaskets, Pricing, and more.",
        "metaType": "default"
      }
    ],
    "DisclosureController": [
      {
        "metaName": "title",
        "metaValue": "Disclosure | WealthDesk ",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Privacy Policies, Terms & Conditions, and disclaimers affiliated with WealthBaskets",
        "metaType": "default"
      }
    ],
    "ContactUsController": [
      {
        "metaName": "title",
        "metaValue": "WealthDesk Support: Contact Us Page",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Get in touch with us for any questions or concerns regarding WealthBaskets",
        "metaType": "default"
      }
    ],
    "WealthForWomen": [
      {
        "metaName": "title",
        "metaValue": "Wealth For Women Wealth Basket | PI India | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Wealth for Women Wealthbasket which allocates your money in a combination of Asset ETFs that include Domestic LargeCap Equity Domestic Midcap Equity International Equities Golds G Sec, Corporate Bonds, Liquid Funds.",
        "metaType": "default"
      }
    ],
    "OpenQHybridEquity": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Balanced Hybrid Equity WealthBasket | PI India | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ Balanced HyBrid Equity WealthBasket,This portfolio dynamically switches between equity, debt and gold, depending upon the market situation.",
        "metaType": "default"
      }
    ],
    "OpenQMakeInIndia": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Make in India WealthBasket | PI India | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ Make in India WealthBasket portfolio identifies stocks that may benefit from the long-term theme of promoting manufacturing in India.",
        "metaType": "default"
      }
    ],
    "OpenQPharmaTop500New": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Pharma WealthBasket | PI India | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "A proprietary algorithm enabled OpenQ Pharma WealthBasket to deliver consistent returns by investing in Pharma stocks from the top 500 market cap companies",
        "metaType": "default"
      }
    ],
    "OpenQIndiaConsumptionTop500New": [
      {
        "metaName": "title",
        "metaValue": "OpenQ India Consumption WealthBasket | PI India | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ India Consumption WealthBasket that invests in top performing cyclical/non cyclical consumer stocks which are selected based on a proprietary algorithm. These stocks have generated consistent returns over 10 years of backtesting.",
        "metaType": "default"
      }
    ],
    "OpenQChemicalBasketTop500New": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Chemicals WealthBasket | PI India | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ Chemicals WealthBasket that invests in chemical stocks that are selected based on a proprietary algorithm which has shown to have generated consistent returns over last 20 years of backtest.",
        "metaType": "default"
      }
    ],
    "OpenQDefensiveMomentumTop500New": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Defensive Momentum WealthBasket | PI India | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ Defensive Momentum WealthBasket captures the risk premium from Momentum. Stocks are selected by using a proprietary algorithm over 2 business cycle of beta neutral performance.",
        "metaType": "default"
      }
    ],
    "QuantechDigitalIndiaNew": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Digital India WealthBasket | PI India | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ Digital India WealthBasket invests in stocks that will benefit the most due to digital India initiatives. Stocks are selected based on proprietary algorithm.",
        "metaType": "default"
      }
    ],
    "QuantechBankingServiceTop500New": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Banking & Investment Services WealthBasket | PI India | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ Banking & Investment Services WealthBasket invests in banks & banking services sector companies that have generated consistent returns over last 8 years and are selected based on a proprietary algorithm.",
        "metaType": "default"
      }
    ],
    "QuantechMNCNew": [
      {
        "metaName": "title",
        "metaValue": "OpenQ MNC WealthBasket | PI India | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ MNC WealthBasket Wealth Basket is selected from a pool of listed MNCs which are part of top 500 stocks and have shown to generate consistent return over long term on our proprietary algorithm",
        "metaType": "default"
      }
    ],
    "TamoharaVIPforPL": [
      {
        "metaName": "title",
        "metaValue": "Tamohara Vaccinate India Portfolio Strategy WealthBasket | PI India | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Tamohara Vaccinate India Portfolio Strategy WealthBasket is a Multi Cap Equity Portfolio that invests in quality stocks",
        "metaType": "default"
      }
    ]
  },
  "flipitnews": {
    "HomeController": [
      {
        "metaName": "title",
        "metaValue": "FlipItNews | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Each WealthBasket reflects an investment strategy, theme or an idea with underlying stocks, ETFs accordingly weighted following a rigorous research process.",
        "metaType": "default"
      }
    ],
    "FundDiscoveryController": [
      {
        "metaName": "title",
        "metaValue": "Invest in Smart Beta WealthBaskets: Stock & ETF Portfolios | FlipItNews | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "FlipItNews | Invest in WealthBaskets which reflects a theme, investment strategy, or idea with stocks and ETFs weighted according to a rigorous investment process.",
        "metaType": "default"
      }
    ],
    "FAQController": [
      {
        "metaName": "title",
        "metaValue": "FAQs | FlipItNews | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Find answers to frequently asked questions (FAQs) about WealthDesk, How to invest in WealthBaskets, Pricing, and more.",
        "metaType": "default"
      }
    ],
    "ContactUsController": [
      {
        "metaName": "title",
        "metaValue": "WealthDesk Support: Contact Us Page | FlipItNews | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Our support team will assist with questions regarding WealthBaskets (Asset Management), Transactions, Portfolio, Rebalance and more",
        "metaType": "default"
      }
    ],
    "DisclosureController": [
      {
        "metaName": "title",
        "metaValue": "Disclosure | FlipItNews | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Privacy Policies, Terms & Conditions, and disclaimers affiliated with WealthBaskets",
        "metaType": "default"
      }
    ],
    "OpenQHybridEquity": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Balanced Hybrid Equity Portfolio | FlipItNews | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ Balanced HyBrid Equity WealthBasket dynamically switches between equity, debt and gold, depending upon the market situation.",
        "metaType": "default"
      }
    ],
    "OpenQMakeInIndia": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Make in India Portfolio | FlipItNews | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ Make in India WealthBasket identifies stocks that may benefit from the long term theme of promoting manufacturing in India.",
        "metaType": "default"
      }
    ],
    "OpenQPharmaTop500New": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Pharma Portfolio | FlipItNews | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ Pharma WealthBasket invests in Pharma stocks selected from the top 500 market cap stocks through proprietary algorithm that has given consistent returns.",
        "metaType": "default"
      }
    ],
    "OpenQIndiaConsumption": [
      {
        "metaName": "title",
        "metaValue": "OpenQ India Consumption Portfolio | FlipItNews | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ India Consumption WealthBasket invests in top performing cyclical/non cyclical consumer stocks which are selected based on a proprietary algorithm.",
        "metaType": "default"
      }
    ],
    "OpenQChemicalBasketTop500New": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Chemicals Portfolio | FlipItNews | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "The OpenQ Chemicals WealthBasket invests in chemical stocks selected using a proprietary algorithm that has produced consistent returns over the past 20 years.",
        "metaType": "default"
      }
    ],
    "OpenQDefensiveMomentumTop500New": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Defensive Momentum Portfolio | FlipItNews | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ Defensive Momentum WealthBasket captures the risk premium from Momentum by using a proprietary algorithm over 2 business cycle of beta neutral performance.",
        "metaType": "default"
      }
    ],
    "QuantechDigitalIndiaNew": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Digital India Portfolio | FlipItNews | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ Digital India WealthBasket invests in stocks that will benefit the most due to digital India initiatives. Stocks are selected based on proprietary algorithm.",
        "metaType": "default"
      }
    ],
    "QuantechBankingServiceTop500New": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Banking & Investment Services Portfolio | FlipItNews | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ Banking & Investment Services WealthBasket invests in banking services sector companies using a proprietary algorithm",
        "metaType": "default"
      }
    ],
    "QuantechMNCNew": [
      {
        "metaName": "title",
        "metaValue": "OpenQ MNC Portfolio | FlipItNews | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ MNC WealthBasket is selected from a pool of listed MNCs top 500 stocks and have shown to generate consistent return over long term.",
        "metaType": "default"
      }
    ]
  },
  "tradenet": {
    "HomeController": [
      {
        "metaName": "title",
        "metaValue": "Tradenet Wealth | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Trade Net Wealth offers investors honest and transparent investment WealthBaskets backed by strong ethics and a complete investor-centric approach.",
        "metaType": "default"
      }
    ],
    "FundDiscoveryController": [
      {
        "metaName": "title",
        "metaValue": "Invest in Smart WealthBaskets | Tradenet Wealth | WealthBaskets",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Invest in with Tradenet in WealthBaskets which reflects a theme, investment strategy, or idea with stocks and ETFs weighted according to a rigorous investment process.",
        "metaType": "default"
      }
    ],
    "FAQController": [
      {
        "metaName": "title",
        "metaValue": "FAQs | Tradenet Wealth | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Find answers to frequently asked questions (FAQs) about WealthDesk, How to invest in WealthBaskets, Pricing, and more.",
        "metaType": "default"
      }
    ],
    "DisclosureController": [
      {
        "metaName": "title",
        "metaValue": "Disclosure | Tradenet Wealth | WealthDesk ",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Privacy Policies, Terms & Conditions, and disclaimers affiliated with WealthBaskets",
        "metaType": "default"
      }
    ],
    "TamoharaTradeTrend": [
      {
        "metaName": "title",
        "metaValue": "Tamohara Trade Trend Strategy | Tradenet Wealth | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Tamohara Trade Trend Strategy WealthBasket based on aiming to invest in fundamentally good quality stocks. Suitable for investing in short term opportunities arising in the market.",
        "metaType": "default"
      }
    ]
  },
  "aifpms": {
    "HomeController": [
      {
        "metaName": "title",
        "metaValue": "AIF & PMS Experts India | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "AIF & PMS Experts India provide WealthBaskets that are maintaining transparency and facilitating the long-term creation of wealth for investors.",
        "metaType": "default"
      }
    ],
    "FundDiscoveryController": [
      {
        "metaName": "title",
        "metaValue": "Invest in Smart Beta WealthBaskets: Stock & ETF Portfolios | AIF & PMS Experts India  | WealthBaskets",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Invest in WealthBaskets which reflects a theme, investment strategy, or idea with stocks and ETFs weighted according to a rigorous investment process.",
        "metaType": "default"
      }
    ],
    "FAQController": [
      {
        "metaName": "title",
        "metaValue": "FAQs | AIF & PMS Experts India | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Find answers to frequently asked questions (FAQs) about WealthDesk, How to invest in WealthBaskets, Pricing, and more.",
        "metaType": "default"
      }
    ],
    "ContactUsController": [
      {
        "metaName": "title",
        "metaValue": "WealthDesk Support: Contact Us Page | AIF & PMS | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Our support team will assist with questions regarding WealthBaskets (Asset Management), Transactions, Portfolio, Rebalance and more",
        "metaType": "default"
      }
    ],
    "DisclosureController": [
      {
        "metaName": "title",
        "metaValue": "Disclosure | AIF & PMS Experts India | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Privacy Policies, Terms & Conditions, and disclaimers affiliated with WealthBaskets",
        "metaType": "default"
      }
    ],
    "TamoharaTruffle": [
      {
        "metaName": "title",
        "metaValue": "Tamohara Truffle Flexi Cap Strategy Portfolio | AIF & PMS Experts India | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Truffle Flexi Cap Strategy WealthBasket objective is to deliver absolute wealth creation through a concentrated, long only, public equities portfolio.",
        "metaType": "default"
      }
    ],
    "TLES": [
      {
        "metaName": "title",
        "metaValue": "Tamohara Long Term Equity Strategy Portfolio | AIF & PMS Experts India | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Tamohara Long Term Equity WealthBasket invests in not more than 20 high-quality businesses that will take advantage of the growth potential of India's economy",
        "metaType": "default"
      }
    ],
    "SIPTruffle": [
      {
        "metaName": "title",
        "metaValue": "Tamohara Stock SIP Portfolio | AIF & PMS Experts India | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Tamohara Stock SIP WealthBasket is a direct equity SIP consists of seven handpicked stocks, which have a structural opportunity to grow in India over the next decade",
        "metaType": "default"
      }
    ],
    "TAMOHARAVIP": [
      {
        "metaName": "title",
        "metaValue": "Tamohara Vaccinate India Portfolio Strategy Portfolio | AIF & PMS Experts India | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Tamohara Vaccinate India Portfolio Strategy WealthBasket is a Multi Cap Equity Portfolio that invests in quality stocks",
        "metaType": "default"
      }
    ],
    "TamoharaAgile": [
      {
        "metaName": "title",
        "metaValue": "Tamohara Agile Strategy Portfolio | AIF & PMS Experts India | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Tamohara Agile Strategy is a long only equity WealthBasket of the top 25 Stocks selected through a “Multi Factor Process” from the BSE200 Universe",
        "metaType": "default"
      }
    ],
    "TIOS": [
      {
        "metaName": "title",
        "metaValue": "Tamohara India Opportunities Strategy Portfolio | AIF & PMS Experts India | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Tamohara India Opportunities Strategy WealthBasket focuses on 15-18 high-quality businesses that have a proven business model that is proven to succeed.",
        "metaType": "default"
      }
    ],
    "Bluechip": [
      {
        "metaName": "title",
        "metaValue": "Alpha Bluechip Portfolio | AIF & PMS Experts India | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Alpha Bluechip WealthBasket invests in companies with high growth potential that deliver superior risk adjusted returns over the medium-term to long-term.",
        "metaType": "default"
      }
    ],
    "ThematicPortfolio": [
      {
        "metaName": "title",
        "metaValue": "Alpha Dynamic Thematic Portfolio | AIF & PMS Experts India | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Alpha Dynamic Thematic WealthBasket invests in stocks that fall within a particular theme. The theme selection is driven by macroeconomic conditions and sectoral trends",
        "metaType": "default"
      }
    ],
    "CoreandSatellitePortfolio": [
      {
        "metaName": "title",
        "metaValue": "Alpha Core & Satellite Portfolio | AIF & PMS Experts India | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Alpha Core & Satellite WealthBasket ensures wealth creation by investing in long-term secular growth companies and owning industry leaders that create higher ROCE.",
        "metaType": "default"
      }
    ]
  },
  "alphaportfolios": {
    "HomeController": [
      {
        "metaName": "title",
        "metaValue": "Alpha Portfolios Renaissance Investment Managers | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Alpha Portfolios Invests into good quality business that can deliver sustainable growth over the medium term to long term.",
        "metaType": "default"
      }
    ],
    "FundDiscoveryController": [
      {
        "metaName": "title",
        "metaValue": "Invest in Smart Beta Alpha Portfolios WealthBaskets | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Every Alpha Portfolio is selected & weighted periodically to deliver superior risk adjusted returns to clients consistently over medium to long term.",
        "metaType": "default"
      }
    ],
    "ContactUsController": [
      {
        "metaName": "title",
        "metaValue": "WealthDesk Support: Contact Us | Alpha Portfolios",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Get in touch with us for any questions or concerns regarding My Alternatives WealthBaskets or WealthDesk",
        "metaType": "default"
      }
    ],
    "FAQController": [
      {
        "metaName": "title",
        "metaValue": "FAQs | Alpha Portfolios WealthBaskets | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Find answers to frequently asked questions (FAQs) about Alpha Portfolios, How to invest in WealthBaskets, Pricing, and more.",
        "metaType": "default"
      }
    ],
    "DisclosureController": [
      {
        "metaName": "title",
        "metaValue": "Disclosure | Alpha Portfolios | WealthDesk ",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Privacy Policies, Terms & Conditions, and disclaimers affiliated with Alpha Portfolios WealthBaskets",
        "metaType": "default"
      }
    ],
    "MomentumPortfolio": [
      {
        "metaName": "title",
        "metaValue": "Alpha Momentum Portfolio | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Alpha Momentum WealthBasket combines a fundamental investment philosophy with a tactical strategy that aims to generate absolute returns on a timely basis.",
        "metaType": "default"
      }
    ],
    "Bluechip": [
      {
        "metaName": "title",
        "metaValue": "Alpha Bluechip Portfolio | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Alpha Bluechip WealthBasket invests in companies with high growth potential that deliver superior risk adjusted returns over the medium-term to long-term.",
        "metaType": "default"
      }
    ],
    "ThematicPortfolio": [
      {
        "metaName": "title",
        "metaValue": "Alpha Dynamic Thematic Portfolio | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Alpha Dynamic Thematic WealthBasket invests in stocks that fall within a particular theme. The theme selection is driven by macroeconomic conditions and sectoral trends",
        "metaType": "default"
      }
    ],
    "CoreandSatellitePortfolio": [
      {
        "metaName": "title",
        "metaValue": "Alpha Core & Satellite Portfolio | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Alpha Core & Satellite WealthBasket ensures wealth creation by investing in long-term secular growth companies and owning industry leaders that create higher ROCE.",
        "metaType": "default"
      }
    ]
  },
  "wrightresearch": {
    "HomeController": [
      {
        "metaName": "title",
        "metaValue": "Wright Research WealthBaskets | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Wright Research offers select stocks and ETFs from medium and small cap companies that are safe, have high returns, and provide flexibility.",
        "metaType": "default"
      }
    ],
    "FundDiscoveryController": [
      {
        "metaName": "title",
        "metaValue": "Discover Wright Research Smart Beta Portfolios | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Invest in Wright Research Wealth Baskets, Each WealthBasket reflects a theme, investment strategy, or idea with stocks and ETFs weighted according to a rigorous investment process.",
        "metaType": "default"
      }
    ],
    "FAQController": [
      {
        "metaName": "title",
        "metaValue": "Wright Research FAQs | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Find answers to frequently asked questions (FAQs) about WealthDesk, How to invest in WealthBaskets, Pricing, and more.",
        "metaType": "default"
      }
    ],
    "ContactUsController": [
      {
        "metaName": "title",
        "metaValue": "Support: Contact Us | Wright Research | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Get in touch with us for any questions or concerns regarding Wright Research WealthBaskets",
        "metaType": "default"
      }
    ],
    "DisclosureController": [
      {
        "metaName": "title",
        "metaValue": "Wright Research Disclosure | WealthDesk ",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Privacy Policies, Terms & Conditions, and disclaimers affiliated with Wright Research WealthBaskets",
        "metaType": "default"
      }
    ],
    "Smallcaps": [
      {
        "metaName": "title",
        "metaValue": "Wright Research Smallcaps Portfolio | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Wright Research's Smallcaps WealthBasket is an equity strategy that comprises a multi-stock portfolio of 20-25 high quality smallcap stocks.",
        "metaType": "default"
      }
    ],
    "WrightBalanced": [
      {
        "metaName": "title",
        "metaValue": "Wright Balanced Portfolio | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Wright Research Balanced WealthBasket is a moderate risk applied by dynamically allocating among various factors and asset classes based on the changing market regime",
        "metaType": "default"
      }
    ],
    "WrightConservation": [
      {
        "metaName": "title",
        "metaValue": "Wright Research Conservative Portfolio | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Wright Research Conservative is a low risk WealthBasket applied by dynamically allocating among various factors and asset classes based on the changing market regime.",
        "metaType": "default"
      }
    ],
    "WrightGrowth": [
      {
        "metaName": "title",
        "metaValue": "Wright Research Growth Portfolio | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Wright Research Growth is a high risk WealthBasket applied by dynamically allocating among various factors and asset classes based on the changing market regime.",
        "metaType": "default"
      }
    ],
    "Momentum": [
      {
        "metaName": "title",
        "metaValue": "Wright Research Momentum Portfolio | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "With Wright Research's Momentum WealthBasket, investors can invest in high momentum stocks while being mindful of volatility. ",
        "metaType": "default"
      }
    ]
  },
  "wealthyvia": {
    "HomeController": [
      {
        "metaName": "title",
        "metaValue": "Wealthyvia Portfolios | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Wealthyvia offers select stocks and ETFs from medium and small cap companies that are safe, have high returns, and provide flexibility.",
        "metaType": "default"
      }
    ],
    "FundDiscoveryController": [
      {
        "metaName": "title",
        "metaValue": "Invest in Smart Beta Portfolios: Stock & ETF Portfolios | Wealthyvia | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Invest in Wealthyvia WealthBasket which reflects a theme, investment strategy, or idea with stocks and ETFs weighted according to a rigorous investment process.",
        "metaType": "default"
      }
    ],
    "FAQController": [
      {
        "metaName": "title",
        "metaValue": "FAQs | Wealthyvia | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Find answers to frequently asked questions (FAQs) about WealthDesk, How to invest in WealthBaskets, Pricing, and more.",
        "metaType": "default"
      }
    ],
    "ContactUsController": [
      {
        "metaName": "title",
        "metaValue": "Wealthyvia Support: Contact Us | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Get in touch with us for any questions or concerns regarding WealthBaskets",
        "metaType": "default"
      }
    ],
    "DisclosureController": [
      {
        "metaName": "title",
        "metaValue": "Disclosure | Wealthyvia WealthDesk ",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Privacy Policies, Terms & Conditions, and disclaimers affiliated with WealthBaskets",
        "metaType": "default"
      }
    ],
    "WealthyviaSuperfocus": [
      {
        "metaName": "title",
        "metaValue": "Wealthyvia SuperFocus Portfolios | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Wealthyvia's SuperFocus WealthBasket is a tactical investment strategy that utilizes a concentrated portfolio and prudent risk management to generate a high CAGR.",
        "metaType": "default"
      }
    ]
  },
  "plutuscapital": {
    "HomeController": [
      {
        "metaName": "title",
        "metaValue": "Plutus Capital Portfolios | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Plutus Capital offers select stocks and ETFs from medium and small cap companies that are safe, have high returns, and provide flexibility.",
        "metaType": "default"
      }
    ],
    "FundDiscoveryController": [
      {
        "metaName": "title",
        "metaValue": "Invest in Plutus Capital Smart Beta Portfolios | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Plutus Capital advisory services Portfolios are made of Direct Mutual Funds, ETFs, Indian Stocks and Bonds, helps your money grow with less volatility.",
        "metaType": "default"
      }
    ],
    "FAQController": [
      {
        "metaName": "title",
        "metaValue": "FAQs | Plutus Capital WealthBasket | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Find answers to frequently asked questions (FAQs) about Plutus Capital, How to invest in WealthBaskets, Pricing, and more.",
        "metaType": "default"
      }
    ],
    "ContactUsController": [
      {
        "metaName": "title",
        "metaValue": "Plutus Capital Support: Contact Us | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Get in touch with us for any questions or concerns regarding Plutus Capital WealthBaskets",
        "metaType": "default"
      }
    ],
    "DisclosureController": [
      {
        "metaName": "title",
        "metaValue": "Disclosure | Plutus Capital WealthDesk ",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Privacy Policies, Terms & Conditions, and disclaimers affiliated with Plutus Capital WealthBaskets",
        "metaType": "default"
      }
    ],
    "Conservative": [
      {
        "metaName": "title",
        "metaValue": "Plutus Capital Conservative Strategy Portfolio | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Plutus Capital Conservative Strategy WealthBasket objective is capital preservation with income generation. This strategy allocates in a combination of PSU bonds (using Bharat Bond ETF) and high dividend-yielding stocks.",
        "metaType": "default"
      }
    ],
    "AWS": [
      {
        "metaName": "title",
        "metaValue": "Plutus Capital All Weather Strategy Portfolio | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Plutus Capital All Weather Strategy WealthBasket is an all asset strategy using our proprietary asset allocation model. The objective is to reduce portfolio volatility by allocating across Equity, Debt, Gold, and Real Estate.",
        "metaType": "default"
      }
    ],
    "IOS": [
      {
        "metaName": "title",
        "metaValue": "Plutus Capital India Opportunities Strategy Portfolio | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Plutus Capital India Opportunities Strategy portfolio consists of companies with a history of high ROCE and profit compounding.",
        "metaType": "default"
      }
    ]
  },
  "jarvisinvest": {
    "HomeController": [
      {
        "metaName": "title",
        "metaValue": "Jarvis Investment management Portfolios | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Jarvis Invest offers select stocks and ETFs from medium and small cap companies that are safe, have high returns, and provide flexibility.",
        "metaType": "default"
      }
    ],
    "FundDiscoveryController": [
      {
        "metaName": "title",
        "metaValue": "Invest in Jarvis Investment Smart Beta Portfolios | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "JARVIS Invest WealthBaskets are designed to eliminate the emotional aspect of investing using Artificial Intelligence",
        "metaType": "default"
      }
    ],
    "FAQController": [
      {
        "metaName": "title",
        "metaValue": "FAQs | Jarvis Invest WealthBaskets | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Find answers to frequently asked questions (FAQs) about WealthDesk, How to invest in WealthBaskets, Pricing, and more.",
        "metaType": "default"
      }
    ],
    "ContactUsController": [
      {
        "metaName": "title",
        "metaValue": "Jarvis Invest Support: Contact Us | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Get in touch with us for any questions or concerns regarding Jarvis Invest WealthBaskets",
        "metaType": "default"
      }
    ],
    "DisclosureController": [
      {
        "metaName": "title",
        "metaValue": "Jarvis Invest Disclosure | WealthDesk ",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Privacy Policies, Terms & Conditions, and disclaimers affiliated with Jarvis InvestWealthBaskets",
        "metaType": "default"
      }
    ],
    "JARVISAGGRESSIVE": [
      {
        "metaName": "title",
        "metaValue": "Jarvis Invest Aggressive Portfolio Portfolio | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Jarvis Aggressive WealthBasket uses AI and Predictive Analytics to analyze many qualitative factors concurrently while having a high degree of risk and volatility",
        "metaType": "default"
      }
    ],
    "JARVISINVEST": [
      {
        "metaName": "title",
        "metaValue": "Jarvis Invest Conservative Portfolio Portfolio | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Jarvis Conservative WealthBasket uses AI and Predictive Analytics to analyze many qualitative factors concurrently while having a very low risk and volatility.",
        "metaType": "default"
      }
    ],
    "JARVIS": [
      {
        "metaName": "title",
        "metaValue": "Jarvis Invest Moderate Portfolio Portfolio | Wealthdesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "The Jarvis Moderate WealthBasket analyzes numerous qualitative factors simultaneously, and it is designed to manage risk and volatility.",
        "metaType": "default"
      }
    ]
  },
  "valuestocks": {
    "HomeController": [
      {
        "metaName": "title",
        "metaValue": "Explore Best WealthBaskets from Value Stocks India | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Choose the right Value Stock Portfolio that best suits your risk profile to invest in Value Stocks.",
        "metaType": "default"
      }
    ],
    "FundDiscoveryController": [
      {
        "metaName": "title",
        "metaValue": "Discover Value Stocks India Portfolios | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Invest in best quality Value Stocks WealthBasket which have different investment strategies based on predictive analytics and powered by Artificial Intelligence",
        "metaType": "default"
      }
    ],
    "FAQController": [
      {
        "metaName": "title",
        "metaValue": "Value Stocks FAQs | WealthBaskets | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Find answers to frequently asked questions (FAQs) about Value Stocks WealthBaskets, How to invest in WealthBaskets, Pricing, and more.",
        "metaType": "default"
      }
    ],
    "ContactUsController": [
      {
        "metaName": "title",
        "metaValue": "Value Stocks Support: Contact Us | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Get in touch with us for any questions or concerns regarding WealthBaskets or transactions related queries from Value Stocks",
        "metaType": "default"
      }
    ],
    "DisclosureController": [
      {
        "metaName": "title",
        "metaValue": "Disclosure | Value Stocks India | WealthDesk ",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Value Stocks Privacy Policies, Terms & Conditions, and disclaimers affiliated with WealthBaskets",
        "metaType": "default"
      }
    ],
    "register_client": [
      {
        "metaName": "title",
        "metaValue": "Login to Invest in Value Stocks WealthBaskets | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Login or register to start investing in well researched Value Stocks automated portfolio WealthBaskets from WealthDesk",
        "metaType": "default"
      }
    ],
    "Largecap100": [
      {
        "metaName": "title",
        "metaValue": "Value Stocks Largecap 100 Growth Strategy Quarterly Portfolio | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Value Stocks Largecap 100 Growth Strategy Quarterly WealthBasket is based on research of Quality Business Score and Alpha Generator Score powered by technology",
        "metaType": "default"
      }
    ],
    "VSSmallcapLowPE": [
      {
        "metaName": "title",
        "metaValue": "Value Stocks Smallcap Low PE Strategy Quarterly Portfolio | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Value Stocks Smallcap Low PE Strategy Quarterly WealthBasket identifies the best quality Small Cap stocks focusing on the parameter, Quarterly EPS and Sales growth",
        "metaType": "default"
      }
    ],
    "VSMidcapPrice": [
      {
        "metaName": "title",
        "metaValue": "Value Stocks Midcap Price Momentum Strategy Quarterly Portfolio | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Value Stocks Midcap Price Momentum Strategy Quarterly WealthBasket is for Aggressive Investors, who are ready to take risks by investing directly in Equity Markets",
        "metaType": "default"
      }
    ],
    "Diwali2020": [
      {
        "metaName": "title",
        "metaValue": "Best Diwali picks from Value Stocks Portfolio | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Value Stocks Best Diwali WealthBasket picks portfolio stocks have high ROE, high EPS, and Sales Growth, this strategy has beaten Nifty most of the time in the last 2 yrs",
        "metaType": "default"
      }
    ],
    "Midcapgrowthstrategy": [
      {
        "metaName": "title",
        "metaValue": "Value Stocks Mid Cap Growth Strategy Portfolio | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Value Stocks Mid Cap Growth Strategy WealthBasket has the best quality midcap stocks based on a proprietary predictive analytics model.",
        "metaType": "default"
      }
    ],
    "VSMulticapGrowth": [
      {
        "metaName": "title",
        "metaValue": "Value Stocks Multicap Growth Strategy Quarterly Portfolio | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Value Stocks Multicap Growth Strategy Quarterly WealthBasket gives a combination of quality Large, Mid and Small Cap stocks primarily based on growth parameters.",
        "metaType": "default"
      }
    ]
  },
  "VSMulticapGrowth": [
    {
      "metaName": "title",
      "metaValue": "Value Stocks Multicap Growth Strategy Quarterly Portfolio | WealthDesk",
      "metaType": "title"
    },
    {
      "metaName": "description",
      "metaValue": "Value Stocks Multicap Growth Strategy Quarterly WealthBasket gives a combination of quality Large, Mid and Small Cap stocks primarily based on growth parameters.",
      "metaType": "default"
    }
  ],
  "Smallcapgrowthstrategy": [
    {
      "metaName": "title",
      "metaValue": "Value Stocks Small Cap Growth Strategy | WealthDesk",
      "metaType": "title"
    },
    {
      "metaName": "description",
      "metaValue": "Value Stocks Small Cap Growth Strategy WealthBasket has best quality small cap stocks based on a proprietary predictive analytics model.",
      "metaType": "default"
    }
  ],
  "VSSmallcapPrice": [
    {
      "metaName": "title",
      "metaValue": "Value Stocks Smallcap Price Momentum Strategy Quarterly Portfolio | WealthDesk",
      "metaType": "title"
    },
    {
      "metaName": "description",
      "metaValue": "Value Stocks Smallcap Price Momentum Strategy Quarterly WealthBasket identifies the best quality Small Cap stocks focusing on a parameter, Quarterly EPS and Sales growth.",
      "metaType": "default"
    }
  ],
  "VSBestMF": [
    {
      "metaName": "title",
      "metaValue": "Value Stocks Top Stock as per MF buying Portfolio | WealthDesk",
      "metaType": "title"
    },
    {
      "metaName": "description",
      "metaValue": "Value Stocks Top Stock as per MF buying strategy WealthBasket identifies the best stocks based on the buying and selling activities of Mutual Fund, Foreign Investors and Institutions.",
      "metaType": "default"
    }
  ],
  "Largecapgrowthstrategy": [
    {
      "metaName": "title",
      "metaValue": "Value Stocks Large Cap Growth Strategy Portfolio | WealthDesk",
      "metaType": "title"
    },
    {
      "metaName": "description",
      "metaValue": "Value Stocks Large Cap Growth Strategy WealthBasket has quality large cap stocks based on a proprietary predictive analytics model.",
      "metaType": "default"
    }
  ],
  "prudentequity": {
    "HomeController": [
      {
        "metaName": "title",
        "metaValue": "Prudent Equity Advisors | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Prudent Equity is an independent investment advisory firm that only recommends securities meeting strict investment criteria and having a significant margin of safety.",
        "metaType": "default"
      }
    ],
    "FundDiscoveryController": [
      {
        "metaName": "title",
        "metaValue": "Prudent Equity Portfolios | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "The Prudent Equity WealthBaskets are a mix of ETFs or Stocks that are suitable for long and short-term investments based on a theme or strategy",
        "metaType": "default"
      }
    ],
    "FAQController": [
      {
        "metaName": "title",
        "metaValue": "FAQs | Prudent Equity | WealthBaskets | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Find answers to frequently asked questions (FAQs) about WealthDesk, How to invest in WealthBaskets, Pricing, and more.",
        "metaType": "default"
      }
    ],
    "ContactUsController": [
      {
        "metaName": "title",
        "metaValue": "WealthDesk Support: Contact Us | Prudent Equity Advisors",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Get in touch with us for any questions or concerns regarding Prudent Equity WealthBaskets",
        "metaType": "default"
      }
    ],
    "DisclosureController": [
      {
        "metaName": "title",
        "metaValue": "Disclosure | Prudent Equity | WealthDesk ",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Privacy Policies, Terms & Conditions, and disclaimers affiliated with Prudent Equity WealthBaskets",
        "metaType": "default"
      }
    ],
    "Flexi": [
      {
        "metaName": "title",
        "metaValue": "Prudent Equity Flexi Cap Portfolio | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Prudent Equity Flexi Cap WealthBasket is a curated vessel of ETFs and stocks built to provide long term capital appreciation in equity markets",
        "metaType": "default"
      }
    ]
  },
  "alfaccurate": {
    "HomeController": [
      {
        "metaName": "title",
        "metaValue": "AlfAccurate Advisors | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Alf Accurate Advisor focus on companies that have proven management teams, operating in a good growth market with a strong product portfolio.",
        "metaType": "default"
      }
    ],
    "FundDiscoveryController": [
      {
        "metaName": "title",
        "metaValue": "AlfAccurate Portfolios | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "AlfAccurate WealthBaskets follows proprietary 3M (Market size,Market Share, Margin of Safety) approach which has delivered superior risk-adjusted returns year after year",
        "metaType": "default"
      }
    ],
    "FAQController": [
      {
        "metaName": "title",
        "metaValue": "FAQs | Alfaccurate Advisors | WealthBaskets | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Find answers to frequently asked questions (FAQs) about WealthDesk, How to invest in WealthBaskets, Pricing, and more.",
        "metaType": "default"
      }
    ],
    "ContactUsController": [
      {
        "metaName": "title",
        "metaValue": "WealthDesk Support: Contact Us | Alfaccurate Advisors",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Get in touch with us for any questions or concerns regarding Alf Accurate Advisors WealthBaskets",
        "metaType": "default"
      }
    ],
    "DisclosureController": [
      {
        "metaName": "title",
        "metaValue": "Disclosure | Alfaccurate Advisors pvt ltd | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Privacy Policies, Terms & Conditions, and disclaimers affiliated with Alfaccurate Advisors WealthBaskets",
        "metaType": "default"
      }
    ],
    "AAANEXT": [
      {
        "metaName": "title",
        "metaValue": "AAA NEXT Generation Portfolio | AlfAccurate Advisors | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "AAA NEXT Generation WealthBasket aims to capitalize on robust digital ecosystem and faster digital adoption by focusing on companies leading the change.",
        "metaType": "default"
      }
    ]
  },
  "phillipcapital": {
    "HomeController": [
      {
        "metaName": "title",
        "metaValue": "Phillip Capital India | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Phillip Capital follow a stringent fundamental research driven approach with strict adherence to discipline and clear defined No-Go areas. We believe in buying quality and growth oriented companies at a reasonable price.",
        "metaType": "default"
      }
    ],
    "FundDiscoveryController": [
      {
        "metaName": "title",
        "metaValue": "Phillip Capital Portfolios | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Phillip Capital WealthBaskets look at various financial parameters to weed out unwanted stocks and then based on bottom-up approach, cherry pick stocks based on our research.",
        "metaType": "default"
      }
    ],
    "FAQController": [
      {
        "metaName": "title",
        "metaValue": "FAQs | Phillip Capital | WealthBaskets | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Find answers to frequently asked questions (FAQs) about WealthDesk, How to invest in WealthBaskets, Pricing, and more.",
        "metaType": "default"
      }
    ],
    "ContactUsController": [
      {
        "metaName": "title",
        "metaValue": "WealthDesk Support: Contact Us | Phillip Capital Advisors",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Get in touch with us for any questions or concerns regarding Phillip Capital WealthBaskets",
        "metaType": "default"
      }
    ],
    "DisclosureController": [
      {
        "metaName": "title",
        "metaValue": "Disclosure | Phillip Capital India pvt ltd | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Privacy Policies, Terms & Conditions, and disclaimers affiliated with Phillip Capital WealthBaskets",
        "metaType": "default"
      }
    ],
    "ChampionWealthbasket": [
      {
        "metaName": "title",
        "metaValue": "Champion Portfolio | Phillip Capital | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Phillip Capital Champion WealthBasket, the objective of this portfolio is to generate superior returns over long-term by investing in 10-15 cherry picked securities across market cap that fall under below themes",
        "metaType": "default"
      }
    ]
  },
  "finkasturi": {
    "HomeController": [
      {
        "metaName": "title",
        "metaValue": "Fin Kasturi SEBI Registered Investment Advisor | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Fin Katuri is a SEBI Registered Investment Advisors that offer Investment Advisory services for achieving investors financial goals.",
        "metaType": "default"
      }
    ],
    "FundDiscoveryController": [
      {
        "metaName": "title",
        "metaValue": "Fin Katuri Portfolios | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "FinKasturi WealthBaskets offer Investment Advisory services to institutions and individuals to meet their investment objectives.",
        "metaType": "default"
      }
    ],
    "FAQController": [
      {
        "metaName": "title",
        "metaValue": "FAQs | Fin Katuri | WealthBaskets | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Find answers to frequently asked questions (FAQs) about WealthDesk, How to invest in WealthBaskets, Pricing, and more.",
        "metaType": "default"
      }
    ],
    "ContactUsController": [
      {
        "metaName": "title",
        "metaValue": "WealthDesk Support: Contact Us | FinKasturi Advisors",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Get in touch with us for any questions or concerns regarding Fin Katuri WealthBaskets",
        "metaType": "default"
      }
    ],
    "DisclosureController": [
      {
        "metaName": "title",
        "metaValue": "Disclosure | Fin Katuri | WealthDesk ",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Privacy Policies, Terms & Conditions, and disclaimers affiliated with FinKaturi WealthBaskets",
        "metaType": "default"
      }
    ],
    "KEOP": [
      {
        "metaName": "title",
        "metaValue": "Kasturi Equity Opportunity Portfolio | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Kasturi Equity Opportunity Portfolio WealthBasket is a multi-cap portfolio, comprises meticulously selected 20 stocks based on free cash flow generation, return ratios, asset turnover, leverage ratios",
        "metaType": "default"
      }
    ]
  },
  "investorai": {
    "HomeController": [
      {
        "metaName": "title",
        "metaValue": "Investor AI | Bridgeweave NG LLP | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "InvestorAi mission is to make complex quantitative research accessible to the general public, and to facilitate universal access to equity markets and wealth creation.",
        "metaType": "default"
      }
    ],
    "FundDiscoveryController": [
      {
        "metaName": "title",
        "metaValue": "Investor AI FTM Portfolios | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Investor AI takes the best insights for Indian stocks and combine them into balanced WealthBaskets.",
        "metaType": "default"
      }
    ],
    "FAQController": [
      {
        "metaName": "title",
        "metaValue": "FAQs | Investor AI | WealthBaskets | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Find answers to frequently asked questions (FAQs) about WealthDesk, How to invest in WealthBaskets, Pricing, and more.",
        "metaType": "default"
      }
    ],
    "ContactUsController": [
      {
        "metaName": "title",
        "metaValue": "Support: Contact Us | Investor AI | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Get in touch with us for any questions or concerns regarding Investor AI WealthBaskets",
        "metaType": "default"
      }
    ],
    "DisclosureController": [
      {
        "metaName": "title",
        "metaValue": "Disclosure | Investor AI | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Privacy Policies, Terms & Conditions, and disclaimers affiliated with Investor AI WealthBaskets",
        "metaType": "default"
      }
    ],
    "FtMMomentumIndia": [
      {
        "metaName": "title",
        "metaValue": "FtM - Trailblazers Portfolio | Investor AI | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Trailblazers WealthBasket is constructed with a balance of cyclical and defensive stocks with sector diversification to deliver a basket of 16 stocks with strong risk adjusted returns.",
        "metaType": "default"
      }
    ],
    "FtMValueIndia": [
      {
        "metaName": "title",
        "metaValue": "FtM - Hidden Gems | Investor AI | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "FtM - Hidden Gems WealthBasket has a algorithm that shortlists stocks which score well on factors such as capital structure, forward P/E, 60 day relative return, 2 year beta and 1 year standard deviation.",
        "metaType": "default"
      }
    ]
  },
  "jamawealth": {
    "HomeController": [
      {
        "metaName": "title",
        "metaValue": "Jama Wealth Equity Advisoy | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Jama Wealth Equity Advisory follows a simple Investment Philosophy called Roots & Wings. A team of industry experts having 30+ years experience in advisory & research carefully selects stock portfolios.",
        "metaType": "default"
      }
    ],
    "FundDiscoveryController": [
      {
        "metaName": "title",
        "metaValue": "Jama Wealth Equity Advisoy Portfolios | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Jama Wealth WealthBaskets use deep technology in portfolio design, execution and tracking that make investing safe, smart and convenient for you.",
        "metaType": "default"
      }
    ],
    "FAQController": [
      {
        "metaName": "title",
        "metaValue": "FAQs | JamaWealth Equity Advisory | WealthBaskets | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Find answers to frequently asked questions (FAQs) about WealthDesk, How to invest in WealthBaskets, Pricing, and more.",
        "metaType": "default"
      }
    ],
    "ContactUsController": [
      {
        "metaName": "title",
        "metaValue": "WealthDesk Support: Contact Us | JamaWealth Equity Advisors",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Get in touch with us for any questions or concerns regarding JamaWealth Equity Advisory WealthBaskets",
        "metaType": "default"
      }
    ],
    "DisclosureController": [
      {
        "metaName": "title",
        "metaValue": "Disclosure | JamaWealth Advisory | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Privacy Policies, Terms & Conditions, and disclaimers affiliated with JamaWealth Equity Advisory WealthBaskets",
        "metaType": "default"
      }
    ],
    "PEARLFOCUS": [
      {
        "metaName": "title",
        "metaValue": "Pearl Focus Portofolio | JamaWealth Equity Advisory | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Pearl Focus WealthBasket picks large-cap equities that meet stringent criteria on balance sheet strength and great growth track record/prospects.",
        "metaType": "default"
      }
    ]
  },
  "smartbox": {
    "HomeController": [
      {
        "metaName": "title",
        "metaValue": "SmartBox Advisors | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "SmartBox Advisors provide Ethical and Unbiased Investment Advisory Services to enable investors to efficiently invest in asset classes with right knowledge and information.",
        "metaType": "default"
      }
    ],
    "FundDiscoveryController": [
      {
        "metaName": "title",
        "metaValue": "SmartBox Advisors Portfolios | WealthBaskets | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "SmartBox Advisors WealthBaskets are curated with technological development, analytical research and expertise",
        "metaType": "default"
      }
    ],
    "FAQController": [
      {
        "metaName": "title",
        "metaValue": "FAQs | SmartBox Advisors | WealthBaskets | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Find answers to frequently asked questions (FAQs) about WealthDesk, How to invest in WealthBaskets, Pricing, and more.",
        "metaType": "default"
      }
    ],
    "ContactUsController": [
      {
        "metaName": "title",
        "metaValue": "Support: Contact Us | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Get in touch with us for any questions or concerns regarding SmartBox Advisors WealthBaskets",
        "metaType": "default"
      }
    ],
    "DisclosureController": [
      {
        "metaName": "title",
        "metaValue": "Disclosure | SmartBox Advisors | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Privacy Policies, Terms & Conditions, and disclaimers affiliated with SmartBox Advisors WealthBaskets",
        "metaType": "default"
      }
    ],
    "LowallStrategyFull": [
      {
        "metaName": "title",
        "metaValue": "LoWall Portfolio | SmartBox Advisors | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "SmartBox Lowall WealthBasket is a diversified portfolio that Invests in 25-30 companies selected from NIFTY 100 which have low volatility compared to benchmark",
        "metaType": "default"
      }
    ],
    "HighwallStrategyFull": [
      {
        "metaName": "title",
        "metaValue": "HighWall Portfolio | SmartBox Advisors | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "SmartBox HighWall WealthBasket is a diversified portfolio that Invests in 45-50 companies selected from NIFTY 500 which has given positive alpha compared to benchmark.",
        "metaType": "default"
      }
    ],
    "FlowStartegyMarchSeries": [
      {
        "metaName": "title",
        "metaValue": "FlowW Fund Portfolio | SmartBox Advisors | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "SmartBox FlowW Fund WealthBasket actively managing the units of the SBI Nifty 50 ETF to reflect the market momentum by taking advantage on market dips and realize profits as market rises.",
        "metaType": "default"
      }
    ]
  },
  "jrlcapital": {
    "HomeController": [
      {
        "metaName": "title",
        "metaValue": "JRL Money | JRL Capital | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "JRL Capital diversified portfolio combines a mixture of stocks or ETFs that combine to produce better performance through research.",
        "metaType": "default"
      }
    ],
    "FundDiscoveryController": [
      {
        "metaName": "title",
        "metaValue": "Invest in Smart Beta Portfolios | JRL Capital | WealthBaskets",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "JRL Capital | Invest in WealthBaskets which reflects a theme, investment strategy, or idea with stocks and ETFs weighted according to a rigorous investment process.",
        "metaType": "default"
      }
    ],
    "FAQController": [
      {
        "metaName": "title",
        "metaValue": "FAQs | JRL Capital | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Find answers to frequently asked questions (FAQs) about JRL Capital, How to invest in WealthBaskets, Pricing, and more.",
        "metaType": "default"
      }
    ],
    "ContactUsController": [
      {
        "metaName": "title",
        "metaValue": "Support: Contact Us | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Get in touch with us for any questions or concerns regarding JRL Capital WealthBaskets",
        "metaType": "default"
      }
    ],
    "DisclosureController": [
      {
        "metaName": "title",
        "metaValue": "Disclosure | JRL Capital | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Privacy Policies, Terms & Conditions, and disclaimers affiliated with JRL Capital WealthBaskets",
        "metaType": "default"
      }
    ],
    "TamoharaTruffle": [
      {
        "metaName": "title",
        "metaValue": "Tamohara Truffle Flexi Cap Strategy | JRL Capital | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Truffle Flexi Cap Strategy WealthBasket objective is to deliver absolute wealth creation through a concentrated, long only, public equities portfolio.",
        "metaType": "default"
      }
    ],
    "TLES": [
      {
        "metaName": "title",
        "metaValue": "Tamohara Long Term Equity Strategy | JRL Capital | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Tamohara Long Term Equity WealthBasket invests in not more than 20 high-quality businesses that will take advantage of the growth potential of India's economy",
        "metaType": "default"
      }
    ],
    "SIPTruffle": [
      {
        "metaName": "title",
        "metaValue": "Tamohara Stock SIP | JRL Capital | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Tamohara Stock SIP WealthBasket is a direct equity SIP consists of seven handpicked stocks, which have a structural opportunity to grow in India over the next decade",
        "metaType": "default"
      }
    ]
  },
  "lotusdew": {
    "HomeController": [
      {
        "metaName": "title",
        "metaValue": "Lotusdew Wealth and Investment Advisors Pvt Ltd | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Lotusdew uses proprietary data and process, to extract dominant conviction in the market by analyzing investment behavior of professional investors globally, and use that to screen stocks. ",
        "metaType": "default"
      }
    ],
    "FundDiscoveryController": [
      {
        "metaName": "title",
        "metaValue": "Invest in LotusDew Portfolios | WealthBaskets | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "LotusDew Wealthbaskets create an event-based, long only hedge fund like strategy that aims to benefit from events like M&A, policy announcements etc",
        "metaType": "default"
      }
    ],
    "FAQController": [
      {
        "metaName": "title",
        "metaValue": "FAQs | Lotusdew | WealthBaskets | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Find answers to frequently asked questions (FAQs) about WealthDesk, How to invest in WealthBaskets, Pricing, and more.",
        "metaType": "default"
      }
    ],
    "ContactUsController": [
      {
        "metaName": "title",
        "metaValue": "Support: Contact Us | WealthDesk  ",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Get in touch with us for any questions or concerns regarding Lotusdew WealthBaskets",
        "metaType": "default"
      }
    ],
    "DisclosureController": [
      {
        "metaName": "title",
        "metaValue": "Disclosure | Lotusdew | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Privacy Policies, Terms & Conditions, and disclaimers affiliated with Lotusdew WealthBaskets",
        "metaType": "default"
      }
    ],
    "LOTUSDEWHFT": [
      {
        "metaName": "title",
        "metaValue": "Lotusdew High Frequency Strategy Portfolio | Wealthdesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Lotusdew High Frequency strategy WealthBasket behaves like a long-only event based hedge fund.",
        "metaType": "default"
      }
    ],
    "LOTUSDEWBSE": [
      {
        "metaName": "title",
        "metaValue": "Lotusdew BSE Hidden Gems Portfolio | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Lotusdew BSE Hidden Gems WealthBasket selects the companies with less than 1000 crore market cap which are listed on BSE that have the potential to grow.",
        "metaType": "default"
      }
    ]
  },
  "xumitcapital": {
    "HomeController": [
      {
        "metaName": "title",
        "metaValue": "Xumit Capital | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Xumit Capital is an equity investing advisory firm that works closely with retail investors in India and has over a decade and a half of experience managing equity portfolios",
        "metaType": "default"
      }
    ],
    "FundDiscoveryController": [
      {
        "metaName": "title",
        "metaValue": "Invest in Xumit Capital Portfolios | WealthBaskets | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Xumit Capital WealthBaskets has a investment style that represents the philosophy called the Core & Satellite investing strategies.",
        "metaType": "default"
      }
    ],
    "FAQController": [
      {
        "metaName": "title",
        "metaValue": "FAQs | Xumit Capital | WealthBaskets | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Find answers to frequently asked questions (FAQs) about WealthDesk, How to invest in WealthBaskets, Pricing, and more.  ",
        "metaType": "default"
      }
    ],
    "ContactUsController": [
      {
        "metaName": "title",
        "metaValue": "Support: Contact Us | WealthDesk  ",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Get in touch with us for any questions or concerns regarding Xumit Capital WealthBaskets",
        "metaType": "default"
      }
    ],
    "DisclosureController": [
      {
        "metaName": "title",
        "metaValue": "Disclosure | Xumit Capital | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Privacy Policies, Terms & Conditions, and disclaimers affiliated with Xumit Capital WealthBaskets",
        "metaType": "default"
      }
    ],
    "XCMagicFormula": [
      {
        "metaName": "title",
        "metaValue": "XC Magic Formula Portfolio | Xumit Capital | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Xumit Capital's Magic Formula WealthBasket screens over 1000 stocks for quality and value on a trailing twelve-month (TTM) basis and picks 30 stocks for the portfolio.",
        "metaType": "default"
      }
    ],
    "XCMomentum": [
      {
        "metaName": "title",
        "metaValue": "XC Momentum Portfolio | Xumit Capital | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Xumit Capital's Momentum WealthBasket identifies 15 to 20 stocks from trending sectors that are well diversified and positioned between 52 weeks highs and lows.",
        "metaType": "default"
      }
    ],
    "XCEVolvingMobility": [
      {
        "metaName": "title",
        "metaValue": "XC EV-olving Mobility Portfolio | Xumit Capital | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Xumit Capital's EV-olving Mobility WealthBasket strategy is to focus on the electric revolution in India, which is gaining momentum at a rate that has never been seen before.",
        "metaType": "default"
      }
    ],
    "XCMultiFactorPortfolio": [
      {
        "metaName": "title",
        "metaValue": "XC Multi Factor Portfolio | Xumit Capital | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Xumit Capital's Multi Factor WealthBasket strategy is based on a combination of different factors such as a measure of value (EV divided EBITDA), ROCE as a metric of quality.",
        "metaType": "default"
      }
    ]
  },
  "abm": {
    "HomeController": [
      {
        "metaName": "title",
        "metaValue": "Aditya Birla Money Limited | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Aditya Birla Money follows the GIVE framework for Investment Portfolios: G – Governance; I – Industry Attractiveness; V – Valuation; E – Earnings Quality",
        "metaType": "default"
      }
    ],
    "FundDiscoveryController": [
      {
        "metaName": "title",
        "metaValue": "Invest in Aditya Birla Money Portfolios | WealthBaskets | WealthDesk  ",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Aditya Birla Money WealthBaskets follows the GIVE framework where G – Governance, I – Industry Attractiveness, V – Valuation, E – Earnings Quality for the investment portfolios.",
        "metaType": "default"
      }
    ],
    "FAQController": [
      {
        "metaName": "title",
        "metaValue": "FAQs | Aditya Birla Money | WealthBaskets | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Find answers to frequently asked questions (FAQs) about WealthDesk, How to invest in WealthBaskets, Pricing, and more.",
        "metaType": "default"
      }
    ],
    "ContactUsController": [
      {
        "metaName": "title",
        "metaValue": "Support: Contact Us | WealthDesk  ",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Get in touch with us for any questions or concerns regarding Aditya Birla Money WealthBaskets",
        "metaType": "default"
      }
    ],
    "DisclosureController": [
      {
        "metaName": "title",
        "metaValue": "Disclosure | Aditya Birla Money | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Privacy Policies, Terms & Conditions, and disclaimers affiliated with Aditya Birla Money WealthBaskets",
        "metaType": "default"
      }
    ],
    "DualAdvantage": [
      {
        "metaName": "title",
        "metaValue": "Aditya Birla Money Dual Advantage Portfolio | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "ABM Dual Advantage WealthBasket's objective would be to generate excess returns using a dual approach of superior stock selection and tactical positioning.",
        "metaType": "default"
      }
    ],
    "ABMLSystematicINVESTING": [
      {
        "metaName": "title",
        "metaValue": "Aditya Birla Money Rule Based Strategy Portfolio | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Objective of the Rule Based Strategy WealthBasket would be to generate excess return and better risk adjusted returns for client by investing in stocks based on well defined and proven rules.",
        "metaType": "default"
      }
    ]
  },
  "rupeeting": {
    "HomeController": [
      {
        "metaName": "title",
        "metaValue": "Rupeeting | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Invest in Rupeeting portfolios that follow time-tested investment strategies, and apply expertise to invest your money at the right places",
        "metaType": "default"
      }
    ],
    "FundDiscoveryController": [
      {
        "metaName": "title",
        "metaValue": "Rupeeting Core Portfolios | WealthBaskets | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "With Rupeeting WealthBaskets, your money will grow over the long run with time-tested investment strategies.",
        "metaType": "default"
      }
    ],
    "FAQController": [
      {
        "metaName": "title",
        "metaValue": "FAQs | Rupeeting | WealthBaskets | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Find answers to frequently asked questions (FAQs) about WealthDesk, How to invest in WealthBaskets, Pricing, and more.",
        "metaType": "default"
      }
    ],
    "ContactUsController": [
      {
        "metaName": "title",
        "metaValue": "Support: Contact Us | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Get in touch with us for any questions or concerns regarding Rupeeting WealthBaskets",
        "metaType": "default"
      }
    ],
    "DisclosureController": [
      {
        "metaName": "title",
        "metaValue": "Disclosure | Rupeeting | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Privacy Policies, Terms & Conditions, and disclaimers affiliated with Rupeeting WealthBaskets",
        "metaType": "default"
      }
    ],
    "Monopolies": [
      {
        "metaName": "title",
        "metaValue": "Monopolies Portfolio | Rupeeting | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Rupeeting Monopolies WealthBasket is a long term strategy that invests in companies that dominate their respective industries and sectors.",
        "metaType": "default"
      }
    ],
    "ValueMigration": [
      {
        "metaName": "title",
        "metaValue": "Value Migration Portfolio | Rupeeting | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Ruppeting Value Migration WealthBasket is the shift of value from old business models to new, more effective designs that are able to better serve markets.",
        "metaType": "default"
      }
    ],
    "Disruptors": [
      {
        "metaName": "title",
        "metaValue": "Disruptors Portfolio | Rupeeting | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Rupeeting Disruptors WealthBasket increases the probability of sustained long-term wealth creation by investing in strong business models that exhibit traits of disruption.",
        "metaType": "default"
      }
    ],
    "RupeetingCoreConservative": [
      {
        "metaName": "title",
        "metaValue": "Rupeeting Core - Conservative Portfolio | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Rupeeting Core - Conservative WealthBasket is aDiversified and low-cost ETFs designed to weather the market and grow your wealth.",
        "metaType": "default"
      }
    ],
    "RupeetingCoreBalanced": [
      {
        "metaName": "title",
        "metaValue": "Rupeeting Core - Balanced Portfolio | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Rupeeting Core - Balanced WealthBasket is a diversified and low-cost ETFs balanced portfolio designed to weather the market and grow your wealth.",
        "metaType": "default"
      }
    ],
    "Rocketship": [
      {
        "metaName": "title",
        "metaValue": "Rocketship Portfolio | Rupeeting | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Rupeeting Rocketship WealthBasket Invests in companies that exhibit supernormal growth. Growth is all we chase here.",
        "metaType": "default"
      }
    ],
    "BreadandButter": [
      {
        "metaName": "title",
        "metaValue": "Bread and Butter Portfolio | Rupeeting | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Rupeeting Bread and Butter WealthBasket is the portfolio from a list of brands that show winner traits and balances to qualify as great investments and potential multi-baggers.",
        "metaType": "default"
      }
    ],
    "RupeetingCoreAggressive": [
      {
        "metaName": "title",
        "metaValue": "Rupeeting Core - Aggressive Portfolio | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Rupeeting Core - Aggressive WealthBasket is a diversified and low-cost ETFs designed to weather the market and grow your wealth and gives superior risk-adjusted returns",
        "metaType": "default"
      }
    ]
  },
  "finmo": {
    "HomeController": [
      {
        "metaName": "title",
        "metaValue": "Finmo SEBI Registered Investment Advisor | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Finmo Investment Advisory offers select stocks and ETFs from medium and small cap companies that are safe, have high returns, and provide flexibility.",
        "metaType": "default"
      }
    ],
    "FundDiscoveryController": [
      {
        "metaName": "title",
        "metaValue": "Invest in Finmo Smart Beta Portfolios | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Invest in FinMo Investment Advisory WealthBaskets which reflects a theme, investment strategy, or idea with stocks and ETFs weighted according to a rigorous investment process.",
        "metaType": "default"
      }
    ],
    "FAQController": [
      {
        "metaName": "title",
        "metaValue": "FAQs | Finmo Investment Advisory WealthBaskets | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Find answers to frequently asked questions (FAQs) about Finmo Advisory, How to invest in WealthBaskets, Pricing, and more.",
        "metaType": "default"
      }
    ],
    "ContactUsController": [
      {
        "metaName": "title",
        "metaValue": "WealthDesk Support: Contact Us | Finmo",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Get in touch with us for any questions or concerns regarding Finmo Advisory WealthBaskets",
        "metaType": "default"
      }
    ],
    "DisclosureController": [
      {
        "metaName": "title",
        "metaValue": "Disclosure | Finmo Investment Advisory | WealthDesk ",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Privacy Policies, Terms & Conditions, and disclaimers affiliated with Finmo Advisory WealthBaskets",
        "metaType": "default"
      }
    ],
    "RUPEERAKSHAKMonthly": [
      {
        "metaName": "title",
        "metaValue": "Finmo Advisory Rupee Rakshak Monthly Portfolio | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Finmo Investment Advisory Rupee Rakshak Monthly WealthBasket is an ideal entry level investment advisory service designed for common man to save money every month",
        "metaType": "default"
      }
    ],
    "MID5": [
      {
        "metaName": "title",
        "metaValue": "Finmo Advisory FinMoLite MID-5 Portfolio | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "FinMoLite MID-5 is a dynamic WealthBasket of 5 mid-cap stocks/ETFs to mimic the returns of the NiftyMidcap100 Index, adjusted to improve the risk profile.",
        "metaType": "default"
      }
    ],
    "RETURNPROTECTOR": [
      {
        "metaName": "title",
        "metaValue": "FinMoLITE Return Protector Portfolio | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "With the FinMoLITE Return Protector WealthBasket, investors can park their cash in a safe place if there is no opportunity or when they have reached their goal.",
        "metaType": "default"
      }
    ],
    "RUPEERAKSHAK": [
      {
        "metaName": "title",
        "metaValue": "Finmo Advisory Rupee Rakshak Portfolio | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Finmo Advisory Rupee Rakshak is a WealthBasket of Stocks & ETFs or mimics like NIFTY50 ETF, SENSEX30 ETF, BANKNIFTY ETF. This is a Buy Low Sell High Strategy",
        "metaType": "default"
      }
    ],
    "SMALL5": [
      {
        "metaName": "title",
        "metaValue": "Finmo Advisory FinMoLITE SMALL-5 Portfolio | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "FinMoLite SMALL-5 is a dynamic WealthBasket of 5 small-cap stocks/ETFs to mimic the returns of the NiftySmallcap250 Index ,adjusted to improve the risk profile.",
        "metaType": "default"
      }
    ],
    "MONTHLY": [
      {
        "metaName": "title",
        "metaValue": "Finmo Advisory FinMoLITE Monthly Portfolio | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Finmo Advisory  Rupee Rakshak Monthly WealthBasket lets you invest your accumulated monthly capital in stocks & ETFs.",
        "metaType": "default"
      }
    ],
    "GOLD": [
      {
        "metaName": "title",
        "metaValue": "Finmo Advisory FinMoLITE Gold Portfolio | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "FinMoLite Gold is a WealthBasket of Stocks & ETFs or mimics ETFs, like NIFTY50 ETF, SENSEX30 ETF, BANKNIFTY ETF, GOLD ETF.",
        "metaType": "default"
      }
    ],
    "FINMOLITE": [
      {
        "metaName": "title",
        "metaValue": "Finmo Advisory FinMoLITE BIG-5 Portfolio | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "The FinMoLite BIG-5 consists of 5 select, large-cap stocks/ETFs, aimed at mimicking the NIFTY Heavyweight Index, while adjusting for risk profile.",
        "metaType": "default"
      }
    ],
    "BANKNIFTY": [
      {
        "metaName": "title",
        "metaValue": "Finmo Advisory FinMoLITE Bank Nifty Portfolio | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "FinMoLITE Bank Nifty is a WealthBasket of ETFs or mimics ETFs, like NIFTY50 ETF, SENSEX30 ETF, BANKNIFTY ETF, GOLD ETF.",
        "metaType": "default"
      }
    ],
    "RRMONTHLYMINI": [
      {
        "metaName": "title",
        "metaValue": "Finmo Advisory FinMoLITE Monthly Mini Portfolio | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Finmo RR Monthly Mini WealthBasket helps you invest your accumulated monthly capital in stocks & ETFs.",
        "metaType": "default"
      }
    ]
  },
  "tradebulls": {
    "HomeController": [
      {
        "metaName": "title",
        "metaValue": "Login with Tradebulls | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "WealthBaskets can be purchased through Tradebulls by logging in and choosing a product that fits your risk profile.",
        "metaType": "default"
      }
    ],
    "FundDiscoveryController": [
      {
        "metaName": "title",
        "metaValue": "Invest in Smart Beta WealthBaskets: Stock & ETF Portfolios | Tradebulls | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Invest in Wealth Baskets through Tradebulls, Each WealthBasket reflects a theme, investment strategy, or idea with stocks and ETFs weighted according to a rigorous investment process.",
        "metaType": "default"
      }
    ],
    "FAQController": [
      {
        "metaName": "title",
        "metaValue": "FAQs | WealthBaskets | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Find answers to frequently asked questions (FAQs) about WealthDesk, How to invest in WealthBaskets, Pricing, and more.",
        "metaType": "default"
      }
    ],
    "ContactUsController": [
      {
        "metaName": "title",
        "metaValue": "WealthDesk Support: Contact Us Page",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Get in touch with us for any questions or concerns regarding WealthBaskets or transactions related queries from Tradebulls",
        "metaType": "default"
      }
    ],
    "DisclosureController": [
      {
        "metaName": "title",
        "metaValue": "Disclosure | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Privacy Policies, Terms & Conditions, and disclaimers affiliated with WealthBaskets",
        "metaType": "default"
      }
    ],
    "OpenQHybridEquity": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Balanced Hybrid Equity | WealthBasket | Tradebulls",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Invest in OpenQ Balanced HyBrid Equity WealthBasket with Tradebulls,This WealthBasket dynamically switches between equity, debt and gold, depending upon the market situation.",
        "metaType": "default"
      }
    ],
    "OpenQMakeInIndia": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Make in India | WealthBasket",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "With Tradebulls, you can invest in OpenQ Make in India WealthBasket. This portfolio identifies stocks that may benefit from the long-term theme of promoting manufacturing in India.",
        "metaType": "default"
      }
    ],
    "OpenQPharmaTop500New": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Pharma | WealthBasket | Tradebulls",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "A proprietary algorithm enabled OpenQ Pharma WealthBasket to deliver consistent returns by investing in Pharma stocks from the top 500 market cap companies. Invest in this WealthBasket with Tradebulls.",
        "metaType": "default"
      }
    ],
    "OpenQIndiaConsumptionTop500New": [
      {
        "metaName": "title",
        "metaValue": "OpenQ India Consumption | WealthBasket | Tradebulls",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Login with Tradebulls to invest in OpenQ India Consumption WealthBasket that invests in top performing cyclical/non cyclical consumer stocks which are selected based on a proprietary algorithm. These stocks have generated consistent returns over 10 years of backtesting.",
        "metaType": "default"
      }
    ],
    "OpenQDefensiveMomentumTop500New": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Defensive Momentum | WealthBasket | Tradebulls",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Login with Tradebulls to invest in OpenQ Defensive Momentum, This WealthBasket captures the risk premium from Momentum. Stocks are selected by using a proprietary algorithm over 2 business cycle of beta neutral performance.",
        "metaType": "default"
      }
    ]
  },
  "rmoneyindia": {
    "HomeController": [
      {
        "metaName": "title",
        "metaValue": "Login with RMoney | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Sign in with RMoney to invest in stock and ETF portfolios created by SEBI Registered Professionals on WealthDesk.",
        "metaType": "default"
      }
    ],
    "FundDiscoveryController": [
      {
        "metaName": "title",
        "metaValue": "Invest in Smart Beta Stock & ETF Portfolios | RMoney | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Invest in WealthBaskets through RMoney. Login now to invest in portfolios based on a theme, idea or sector created by SEBI Registered Professionals.",
        "metaType": "default"
      }
    ],
    "FAQController": [
      {
        "metaName": "title",
        "metaValue": "FAQs | RMoney | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Get answers to Frequently Asked Questions (FAQs) about RMoney, WealthDesk and WealthBaskets. How to invest in WealthBaskets, pricing and more.",
        "metaType": "default"
      }
    ],
    "ContactUsController": [
      {
        "metaName": "title",
        "metaValue": "WealthDesk Support: Contact Us | RMoney",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Get in touch with us for any questions or concerns regarding WealthBaskets or transactions related queries from RMoney",
        "metaType": "default"
      }
    ],
    "DisclosureController": [
      {
        "metaName": "title",
        "metaValue": "Disclosure | RMoney | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Terms and conditions, disclosures, privacy policies affiliated with WealthBaskets, WealthDesk and RMoney.",
        "metaType": "default"
      }
    ],
    "OpenQMakeInIndia": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Make in India Portfolio | RMoney | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ Make in India WealthBasket identifies stocks that may benefit from the long term theme of promoting manufacturing in India.",
        "metaType": "default"
      }
    ],
    "OpenQPharmaTop500New": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Pharma Portfolio | RMoney | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ Pharma WealthBasket invests in Pharma stocks selected from the top 500 market cap stocks through proprietary algorithm that has given consistent returns.",
        "metaType": "default"
      }
    ],
    "OpenQIndiaConsumptionTop500New": [
      {
        "metaName": "title",
        "metaValue": "OpenQ India Consumption Portfolio | RMoney | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ India Consumption WealthBasket invests in top performing cyclical/non cyclical consumer stocks which are selected based on a proprietary algorithm.",
        "metaType": "default"
      }
    ],
    "OpenQDefensiveMomentumTop500New": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Defensive Momentum Portfolio | RMoney | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ Defensive Momentum WealthBasket captures the risk premium from Momentum by using a proprietary algorithm over 2 business cycle of beta neutral performance.",
        "metaType": "default"
      }
    ],
    "OpenQInfrastructureRealEstateTop500": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Infra & Realty Portfolio | RMoney | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "As the country grows, the demand for infrastructure and realty grows. Benefit from this trend by investing in the OpenQ Infra and Realty WealthBasket",
        "metaType": "default"
      }
    ],
    "OpenQChemicalBasketTop500New": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Chemicals Portfolio | RMoney | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "The OpenQ Chemicals WealthBasket invests in chemical stocks selected using a proprietary algorithm that has produced consistent returns over the past 20 years.",
        "metaType": "default"
      }
    ],
    "QuantechDigitalIndiaNew": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Digital India Portfolio | RMoney | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ Digital India WealthBasket invests in stocks that will benefit the most due to digital India initiatives. Stocks are selected based on proprietary algorithm.",
        "metaType": "default"
      }
    ],
    "QuantechMNCNew": [
      {
        "metaName": "title",
        "metaValue": "OpenQ MNC Portfolio | RMoney | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ MNC WealthBasket is selected from a pool of listed MNCs top 500 stocks and have shown to generate consistent return over long term.",
        "metaType": "default"
      }
    ]
  },
  "northeastltd": {
    "HomeController": [
      {
        "metaName": "title",
        "metaValue": "Login with Northeast Broking Services Ltd | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Sign in with Northeast Broking Services Ltd. to invest in stock and ETF portfolios created by SEBI Registered Professionals on WealthDesk.",
        "metaType": "default"
      }
    ],
    "FundDiscoveryController": [
      {
        "metaName": "title",
        "metaValue": "Invest in Smart Beta Portfolios | Northeast Broking | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Invest in WealthBaskets through Northeast Broking. Login now to invest in portfolios based on a theme, idea or sector created by SEBI Registered Professionals.",
        "metaType": "default"
      }
    ],
    "FAQController": [
      {
        "metaName": "title",
        "metaValue": "FAQs | Norteast Broking Services | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Get answers to Frequently Asked Questions (FAQs) about Northeast Broking, WealthDesk and WealthBaskets. How to invest in WealthBaskets, pricing and more.",
        "metaType": "default"
      }
    ],
    "ContactUsController": [
      {
        "metaName": "title",
        "metaValue": "WealthDesk Support: Contact Us | Norteast Broking Limited",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Get in touch with us for any questions or concerns regarding WealthBaskets or transactions related queries from Northeast Broking",
        "metaType": "default"
      }
    ],
    "DisclosureController": [
      {
        "metaName": "title",
        "metaValue": "Disclosure | Norteast Broking Service | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Terms and conditions, disclosures, privacy policies affiliated with WealthBaskets, WealthDesk and Northeast Broking.",
        "metaType": "default"
      }
    ],
    "OpenQHybridEquity": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Balanced Hybrid Equity Portfolio | Northeast Broking | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ Balanced HyBrid Equity WealthBasket dynamically switches between equity, debt and gold, depending upon the market situation.",
        "metaType": "default"
      }
    ],
    "OpenQMakeInIndia": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Make in India Portfolio | Northeast Broking | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ Make in India WealthBasket identifies stocks that may benefit from the long term theme of promoting manufacturing in India.",
        "metaType": "default"
      }
    ],
    "OpenQPharmaTop500New": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Pharma Portfolio | Northeast Broking | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ Pharma WealthBasket invests in Pharma stocks selected from the top 500 market cap stocks through proprietary algorithm that has given consistent returns.",
        "metaType": "default"
      }
    ],
    "OpenQIndiaConsumptionTop500New": [
      {
        "metaName": "title",
        "metaValue": "OpenQ India Consumption Portfolio | Northeast Broking | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ India Consumption WealthBasket invests in top performing cyclical/non cyclical consumer stocks which are selected based on a proprietary algorithm.",
        "metaType": "default"
      }
    ],
    "OpenQChemicalBasketTop500New": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Chemicals Portfolio | Northeast Broking | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "The OpenQ Chemicals WealthBasket invests in chemical stocks selected using a proprietary algorithm that has produced consistent returns over the past 20 years.",
        "metaType": "default"
      }
    ],
    "OpenQDefensiveMomentumTop500New": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Defensive Momentum Portfolio | Northeast Broking | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ Defensive Momentum WealthBasket captures the risk premium from Momentum by using a proprietary algorithm over 2 business cycle of beta neutral performance.",
        "metaType": "default"
      }
    ],
    "QuantechDigitalIndiaNew": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Digital India Portfolio | Northeast Broking | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ Digital India WealthBasket invests in stocks that will benefit the most due to digital India initiatives. Stocks are selected based on proprietary algorithm.",
        "metaType": "default"
      }
    ],
    "QuantechBankingServiceTop500New": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Banking & Investment Services Portfolio | Northeast Broking | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ Banking & Investment Services WealthBasket invests in banking services sector companies using a proprietary algorithms",
        "metaType": "default"
      }
    ],
    "QuantechMNCNew": [
      {
        "metaName": "title",
        "metaValue": "OpenQ MNC Portfolio | Northeast Broking | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ MNC WealthBasket is selected from a pool of listed MNCs top 500 stocks and have shown to generate consistent return over long term.",
        "metaType": "default"
      }
    ]
  },
  "religare": {
    "HomeController": [
      {
        "metaName": "title",
        "metaValue": "Religare Broking Limited | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Sign in with Religare Broking to invest in stock and ETF portfolios created by SEBI Registered Professionals on WealthDesk.",
        "metaType": "default"
      }
    ],
    "FundDiscoveryController": [
      {
        "metaName": "title",
        "metaValue": "Invest in Smart Beta Portfolios | Religare Securities | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Invest in WealthBaskets with Religare Broking. Login now to invest in portfolios based on a theme, idea or sector created by SEBI Registered Professionals.",
        "metaType": "default"
      }
    ],
    "FAQController": [
      {
        "metaName": "title",
        "metaValue": "FAQs | Religare Securities | WealthBaskets | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Get answers to Frequently Asked Questions (FAQs) about Religare Broking, WealthDesk and WealthBaskets. How to invest in WealthBaskets, pricing and more.",
        "metaType": "default"
      }
    ],
    "ContactUsController": [
      {
        "metaName": "title",
        "metaValue": "Support: Contact Us | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Get in touch with us for any questions or concerns regarding Religare WealthBaskets",
        "metaType": "default"
      }
    ],
    "DisclosureController": [
      {
        "metaName": "title",
        "metaValue": "Disclosure | Religare Securities | WealthDesk ",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Terms and conditions, disclosures, privacy policies affiliated with WealthBaskets, WealthDesk and Religare Broking.",
        "metaType": "default"
      }
    ],
    "OpenQInfrastructureRealEstateTop500": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Infra & Realty Portfolio | Religare Securities | WealthDesk ",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "As the country grows, the demand for infrastructure and realty grows. Benefit from this trend by investing in the OpenQ Infra and Realty WealthBasket",
        "metaType": "default"
      }
    ],
    "OpenQMakeInIndia": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Make in India Portfolio | Religare Securities | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ Make in India WealthBasket identifies stocks that may benefit from the long term theme of promoting manufacturing in India.",
        "metaType": "default"
      }
    ],
    "OpenQPharmaTop500New": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Pharma Portfolio | Religare Securities | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ Pharma WealthBasket invests in Pharma stocks selected from the top 500 market cap stocks through proprietary algorithm that has given consistent returns.",
        "metaType": "default"
      }
    ],
    "OpenQIndiaConsumptionTop500New": [
      {
        "metaName": "title",
        "metaValue": "OpenQ India Consumption Portfolio | Religare Securities | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ India Consumption WealthBasket invests in top performing cyclical/non cyclical consumer stocks which are selected based on a proprietary algorithm.",
        "metaType": "default"
      }
    ],
    "OpenQChemicalBasketTop500New": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Chemicals Portfolio | Religare Securities | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "The OpenQ Chemicals WealthBasket invests in chemical stocks selected using a proprietary algorithm that has produced consistent returns over the past 20 years.",
        "metaType": "default"
      }
    ],
    "OpenQDefensiveMomentumTop500New": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Defensive Momentum Portfolio | Religare Securities | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ Defensive Momentum WealthBasket captures the risk premium from Momentum by using a proprietary algorithm over 2 business cycle of beta neutral performance.",
        "metaType": "default"
      }
    ],
    "QuantechDigitalIndiaNew": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Digital India Portfolio | Religare Securities | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ Digital India WealthBasket invests in stocks that will benefit the most due to digital India initiatives. Stocks are selected based on proprietary algorithm.",
        "metaType": "default"
      }
    ],
    "QuantechBankingServiceTop500New": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Banking & Investment Services Portfolio | Religare | WealthDesk ",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ Banking & Investment Services WealthBasket invests in banking services sector companies using a proprietary algorithms",
        "metaType": "default"
      }
    ],
    "QuantechMNCNew": [
      {
        "metaName": "title",
        "metaValue": "OpenQ MNC Portfolio | Religare Securities | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ MNC WealthBasket is selected from a pool of listed MNCs top 500 stocks and have shown to generate consistent return over long term.",
        "metaType": "default"
      }
    ]
  },
  "asthatrade": {
    "HomeController": [
      {
        "metaName": "title",
        "metaValue": "Login with Astha Trade | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Sign in with Astha Trade to invest in stock and ETF portfolios created by SEBI Registered Professionals on WealthDesk.",
        "metaType": "default"
      }
    ],
    "FundDiscoveryController": [
      {
        "metaName": "title",
        "metaValue": "Invest in Smart Beta Stock & ETF Portfolios | Astha Trade | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Invest in WealthBaskets through Astha Trade. Login now to invest in portfolios based on a theme, idea or sector created by SEBI Registered Professionals.",
        "metaType": "default"
      }
    ],
    "FAQController": [
      {
        "metaName": "title",
        "metaValue": "FAQs | Astha Trade | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Get answers to Frequently Asked Questions (FAQs) about Astha Trade, WealthDesk and WealthBaskets. How to invest in WealthBaskets, pricing and more.",
        "metaType": "default"
      }
    ],
    "ContactUsController": [
      {
        "metaName": "title",
        "metaValue": "WealthDesk Support: Contact Us | Astha Trade",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Get in touch with us for any questions or concerns regarding WealthBaskets or transactions related queries from Astha Trade",
        "metaType": "default"
      }
    ],
    "DisclosureController": [
      {
        "metaName": "title",
        "metaValue": "Disclosure | Astha Trade | WealthDesk ",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Terms and conditions, disclosures, privacy policies affiliated with WealthBaskets, WealthDesk and Astha Trade.",
        "metaType": "default"
      }
    ],
    "OpenQHybridEquity": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Balanced Hybrid Equity Portfolio | Astha Trade | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ Balanced HyBrid Equity WealthBasket dynamically switches between equity, debt and gold, depending upon the market situation.",
        "metaType": "default"
      }
    ],
    "OpenQMakeInIndia": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Make in India Portfolio | Astha Trade | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ Make in India WealthBasket identifies stocks that may benefit from the long term theme of promoting manufacturing in India.",
        "metaType": "default"
      }
    ],
    "OpenQPharmaTop500New": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Pharma Portfolio | Astha Trade | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ Pharma WealthBasket invests in Pharma stocks selected from the top 500 market cap stocks through proprietary algorithm that has given consistent returns.",
        "metaType": "default"
      }
    ],
    "OpenQIndiaConsumptionTop500New": [
      {
        "metaName": "title",
        "metaValue": "OpenQ India Consumption Portfolio | Astha Trade | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ India Consumption WealthBasket invests in top performing cyclical/non cyclical consumer stocks which are selected based on a proprietary algorithm.",
        "metaType": "default"
      }
    ],
    "OpenQChemicalBasketTop500New": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Chemicals Portfolio | Astha Trade | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "The OpenQ Chemicals WealthBasket invests in chemical stocks selected using a proprietary algorithm that has produced consistent returns over the past 20 years.",
        "metaType": "default"
      }
    ],
    "OpenQDefensiveMomentumTop500New": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Defensive Momentum Portfolio | Astha Trade | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ Defensive Momentum WealthBasket captures the risk premium from Momentum by using a proprietary algorithm over 2 business cycle of beta neutral performance.",
        "metaType": "default"
      }
    ],
    "QuantechDigitalIndiaNew": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Digital India Portfolio | Astha Trade | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ Digital India WealthBasket invests in stocks that will benefit the most due to digital India initiatives. Stocks are selected based on proprietary algorithm.",
        "metaType": "default"
      }
    ],
    "QuantechBankingServiceTop500New": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Banking & Investment Services Portfolio | Astha Trade | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ Banking & Investment Services WealthBasket invests in banking services sector companies using a proprietary algorithms",
        "metaType": "default"
      }
    ],
    "QuantechMNCNew": [
      {
        "metaName": "title",
        "metaValue": "OpenQ MNC Portfolio | Astha Trade | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ MNC WealthBasket is selected from a pool of listed MNCs top 500 stocks and have shown to generate consistent return over long term.",
        "metaType": "default"
      }
    ],
    "OpenQInfrastructureRealEstateTop500": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Infra & Realty Portfolio | Astha Trade | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "As the country grows, the demand for infrastructure and realty grows. Benefit from this trend by investing in the OpenQ Infra and Realty WealthBasket",
        "metaType": "default"
      }
    ]
  },
  "icicidirect": {
    "HomeController": [
      {
        "metaName": "title",
        "metaValue": "Login with ICICI Direct | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Sign in with ICICI Direct to invest in stock and ETF portfolios created by SEBI Registered Professionals on WealthDesk.",
        "metaType": "default"
      }
    ],
    "FundDiscoveryController": [
      {
        "metaName": "title",
        "metaValue": "Invest in Smart Beta Portfolios | ICICI Direct | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Invest in WealthBaskets through ICICI Direct. Login now to invest in portfolios based on a theme, idea or sector created by SEBI Registered Professionals.",
        "metaType": "default"
      }
    ],
    "FAQController": [
      {
        "metaName": "title",
        "metaValue": "FAQs | ICICI Direct | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Get answers to Frequently Asked Questions (FAQs) about ICICI Direct, WealthDesk and WealthBaskets. How to invest in WealthBaskets, pricing and more.",
        "metaType": "default"
      }
    ],
    "ContactUsController": [
      {
        "metaName": "title",
        "metaValue": "WealthDesk Support: Contact Us | ICICI Direct | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Get in touch with us for any questions or concerns regarding WealthBaskets or transactions related queries from ICICI Direct",
        "metaType": "default"
      }
    ],
    "DisclosureController": [
      {
        "metaName": "title",
        "metaValue": "Disclosure | ICICI Direct | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Terms and conditions, disclosures, privacy policies affiliated with WealthBaskets, WealthDesk and ICICI Direct.",
        "metaType": "default"
      }
    ],
    "OpenQHybridEquity": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Balanced Hybrid Equity Portfolio | ICICI Direct | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ Balanced HyBrid Equity WealthBasket dynamically switches between equity, debt and gold, depending upon the market situation.",
        "metaType": "default"
      }
    ],
    "OpenQMakeInIndia": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Make in India Portfolio | ICICI Direct | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ Make in India WealthBasket identifies stocks that may benefit from the long term theme of promoting manufacturing in India.",
        "metaType": "default"
      }
    ],
    "OpenQPharmaTop500New": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Pharma Portfolio | ICICI Direct | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ Pharma WealthBasket invests in Pharma stocks selected from the top 500 market cap stocks through proprietary algorithm that has given consistent returns.",
        "metaType": "default"
      }
    ],
    "OpenQIndiaConsumptionTop500New": [
      {
        "metaName": "title",
        "metaValue": "OpenQ India Consumption Portfolio | ICICI Direct | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ India Consumption WealthBasket invests in top performing cyclical/non cyclical consumer stocks which are selected based on a proprietary algorithm.",
        "metaType": "default"
      }
    ],
    "OpenQChemicalBasketTop500New": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Chemicals Portfolio | ICICI Direct | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "The OpenQ Chemicals WealthBasket invests in chemical stocks selected using a proprietary algorithm that has produced consistent returns over the past 20 years.",
        "metaType": "default"
      }
    ],
    "OpenQDefensiveMomentumTop500New": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Defensive Momentum Portfolio | ICICI Direct | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ Defensive Momentum WealthBasket captures the risk premium from Momentum by using a proprietary algorithm over 2 business cycle of beta neutral performance.",
        "metaType": "default"
      }
    ],
    "QuantechDigitalIndiaNew": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Digital India Portfolio | ICICI Direct | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ Digital India WealthBasket invests in stocks that will benefit the most due to digital India initiatives. Stocks are selected based on proprietary algorithm.",
        "metaType": "default"
      }
    ],
    "QuantechBankingServiceTop500New": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Banking & Investment Services Portfolio | ICICI Direct | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ Banking & Investment Services WealthBasket invests in banking services sector companies using a proprietary algorithms",
        "metaType": "default"
      }
    ],
    "QuantechMNCNew": [
      {
        "metaName": "title",
        "metaValue": "OpenQ MNC Portfolio | ICICI Direct | WealthDesk   ",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ MNC WealthBasket is selected from a pool of listed MNCs top 500 stocks and have shown to generate consistent return over long term.",
        "metaType": "default"
      }
    ],
    "TamoharaTruffle": [
      {
        "metaName": "title",
        "metaValue": "Tamohara Truffle Flexi Cap Portfolio | ICICI Direct | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Truffle Flexi Cap Strategy WealthBasket objective is to deliver absolute wealth creation through a concentrated, long only, public equities portfolio.",
        "metaType": "default"
      }
    ],
    "TLES": [
      {
        "metaName": "title",
        "metaValue": "Tamohara Long Term Equity Portfolio | ICICI Direct | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Tamohara Long Term Equity WealthBasket invests in not more than 20 high-quality businesses that will take advantage of the growth potential of India's economy",
        "metaType": "default"
      }
    ],
    "SIPTruffle": [
      {
        "metaName": "title",
        "metaValue": "Tamohara Stock SIP Portfolio | ICICI Direct | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Tamohara Stock SIP WealthBasket is a direct equity SIP consists of seven handpicked stocks, which have a structural opportunity to grow in India over the next decade",
        "metaType": "default"
      }
    ],
    "MomentumPortfolio": [
      {
        "metaName": "title",
        "metaValue": "Alpha Momentum Portfolio | Renaissance | ICICI Direct | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Alpha Momentum WealthBasket combines a fundamental investment philosophy with a tactical strategy that aims to generate absolute returns on a timely basis.",
        "metaType": "default"
      }
    ],
    "AbakkusSmartFlexiCapPortfolio": [
      {
        "metaName": "title",
        "metaValue": "Abakkus Smart Flexi-Cap Portfolio | ICICI Direct | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Abakkus Smart Flexi-Cap Portfolio WealthBasket aims to generate alpha & risk adjusted returns by creating a portfolio predominantly with Top 250 companies.",
        "metaType": "default"
      }
    ],
    "AAANEXT": [
      {
        "metaName": "title",
        "metaValue": "Alf Accurate NEXT Generation Portfolio | ICICI Direct | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "AAA NEXT Generation WealthBasket aims to capitalize on robust digital ecosystem and faster digital adoption by focusing on companies leading the change.",
        "metaType": "default"
      }
    ],
    "ThematicPortfolio": [
      {
        "metaName": "title",
        "metaValue": "Alpha Dynamic Thematic Portfolio | Renaissance | ICICI Direct | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Alpha Dynamic Thematic WealthBasket invests in stocks that fall within a particular theme. The theme selection is driven by macroeconomic conditions and sectoral trends",
        "metaType": "default"
      }
    ],
    "AbakkusSmartBuildIndiaPortfolio": [
      {
        "metaName": "title",
        "metaValue": "Abakkus Smart Build India Portfolio  | ICICI Direct | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "By investing predominantly in companies benefiting from economic development, Abakkus Smart Build India WealthBasket strives to generate alpha and risk-adjusted returns for investors.",
        "metaType": "default"
      }
    ],
    "TamoharaAgile": [
      {
        "metaName": "title",
        "metaValue": "Tamohara Agile Portfolio | ICICI Direct | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Tamohara Agile Strategy is a long only equity WealthBasket of the top 25 Stocks selected through a “Multi Factor Process” from the BSE200 Universe",
        "metaType": "default"
      }
    ],
    "CoreandSatellitePortfolio": [
      {
        "metaName": "title",
        "metaValue": "Alpha Core & Satellite Portfolio | Renaissance | ICICI Direct | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Alpha Core & Satellite WealthBasket ensures wealth creation by investing in long-term secular growth companies and owning industry leaders that create higher ROCE.",
        "metaType": "default"
      }
    ],
    "TIOS": [
      {
        "metaName": "title",
        "metaValue": "Tamohara India Opportunities Portfolio | ICICI Direct | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Tamohara India Opportunities Strategy WealthBasket focuses on 15-18 high-quality businesses that have a proven business model that is proven to succeed.",
        "metaType": "default"
      }
    ],
    "OpenQInfrastructureRealEstateTop500": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Infra & Realty Portfolio | ICICI Direct | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "As the country grows, the demand for infrastructure and realty grows. Benefit from this trend by investing in the OpenQ Infra and Realty WealthBasket",
        "metaType": "default"
      }
    ]
  },
  "upstox": {
    "HomeController": [
      {
        "metaName": "title",
        "metaValue": "Login with Upstox | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Sign in with Upstox to invest in stock and ETF portfolios created by SEBI Registered Professionals on WealthDesk.",
        "metaType": "default"
      }
    ],
    "FundDiscoveryController": [
      {
        "metaName": "title",
        "metaValue": "Invest in Smart Beta Portfolios | Upstox | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Invest in WealthBaskets through Upstox. Login now to invest in portfolios based on a theme, idea or sector created by SEBI Registered Professionals.",
        "metaType": "default"
      }
    ],
    "FAQController": [
      {
        "metaName": "title",
        "metaValue": "FAQs | Upstox | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Get answers to Frequently Asked Questions (FAQs) about Upstox, WealthDesk and WealthBaskets. How to invest in WealthBaskets, pricing and more.",
        "metaType": "default"
      }
    ],
    "ContactUsController": [
      {
        "metaName": "title",
        "metaValue": "WealthDesk Support: Contact Us | Upstox",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Get in touch with us for any questions or concerns regarding WealthBaskets or transactions related queries from Upstox",
        "metaType": "default"
      }
    ],
    "DisclosureController": [
      {
        "metaName": "title",
        "metaValue": "Disclosure | Upstox | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Terms and conditions, disclosures, privacy policies affiliated with WealthBaskets, WealthDesk and Upstox.",
        "metaType": "default"
      }
    ],
    "OpenQHybridEquity": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Balanced Hybrid Equity Portfolio | Upstox | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ Balanced HyBrid Equity WealthBasket dynamically switches between equity, debt and gold, depending upon the market situation.",
        "metaType": "default"
      }
    ],
    "OpenQMakeInIndia": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Make in India Portfolio | Upstox | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ Make in India WealthBasket identifies stocks that may benefit from the long term theme of promoting manufacturing in India.",
        "metaType": "default"
      }
    ],
    "OpenQPharmaTop500New": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Pharma Portfolio | Upstox | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ Pharma WealthBasket invests in Pharma stocks selected from the top 500 market cap stocks through proprietary algorithm that has given consistent returns.",
        "metaType": "default"
      }
    ],
    "OpenQIndiaConsumptionTop500New": [
      {
        "metaName": "title",
        "metaValue": "OpenQ India Consumption Portfolio | Upstox | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ India Consumption WealthBasket invests in top performing cyclical/non cyclical consumer stocks which are selected based on a proprietary algorithm.",
        "metaType": "default"
      }
    ],
    "OpenQChemicalBasketTop500New": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Chemicals Portfolio | Upstox | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "The OpenQ Chemicals WealthBasket invests in chemical stocks selected using a proprietary algorithm that has produced consistent returns over the past 20 years.",
        "metaType": "default"
      }
    ],
    "OpenQDefensiveMomentumTop500New": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Defensive Momentum Portfolio | Upstox | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ Defensive Momentum WealthBasket captures the risk premium from Momentum by using a proprietary algorithm over 2 business cycle of beta neutral performance.",
        "metaType": "default"
      }
    ],
    "QuantechDigitalIndiaNew": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Digital India Portfolio | Upstox | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ Digital India WealthBasket invests in stocks that will benefit the most due to digital India initiatives. Stocks are selected based on proprietary algorithm.",
        "metaType": "default"
      }
    ],
    "QuantechBankingServiceTop500New": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Banking & Investment Services Portfolio | Upstox | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ Banking & Investment Services WealthBasket invests in banking services sector companies using a proprietary algorithms",
        "metaType": "default"
      }
    ],
    "QuantechMNCNew": [
      {
        "metaName": "title",
        "metaValue": "OpenQ MNC Portfolio | Upstox | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ MNC WealthBasket is selected from a pool of listed MNCs top 500 stocks and have shown to generate consistent return over long term.",
        "metaType": "default"
      }
    ],
    "TamoharaTruffle": [
      {
        "metaName": "title",
        "metaValue": "Tamohara Truffle Flexi Cap Portfolio | Upstox | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Truffle Flexi Cap Strategy WealthBasket objective is to deliver absolute wealth creation through a concentrated, long only, public equities portfolio.",
        "metaType": "default"
      }
    ],
    "TLES": [
      {
        "metaName": "title",
        "metaValue": "Tamohara Long Term Equity Portfolio | Upstox | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Tamohara Long Term Equity WealthBasket invests in not more than 20 high-quality businesses that will take advantage of the growth potential of India's economy",
        "metaType": "default"
      }
    ],
    "SIPTruffle": [
      {
        "metaName": "title",
        "metaValue": "Tamohara Stock SIP Portfolio | Upstox | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Tamohara Stock SIP WealthBasket is a direct equity SIP consists of seven handpicked stocks, which have a structural opportunity to grow in India over the next decade",
        "metaType": "default"
      }
    ],
    "MomentumPortfolio": [
      {
        "metaName": "title",
        "metaValue": "Alpha Momentum Portfolio | Renaissance | Upstox | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Alpha Momentum WealthBasket combines a fundamental investment philosophy with a tactical strategy that aims to generate absolute returns on a timely basis.",
        "metaType": "default"
      }
    ],
    "AbakkusSmartFlexiCapPortfolio": [
      {
        "metaName": "title",
        "metaValue": "Abakkus Smart Flexi-Cap Portfolio | Upstox | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Abakkus Smart Flexi-Cap Portfolio WealthBasket aims to generate alpha & risk adjusted returns by creating a portfolio predominantly with Top 250 companies.",
        "metaType": "default"
      }
    ],
    "AAANEXT": [
      {
        "metaName": "title",
        "metaValue": "Alf Accurate NEXT Generation Portfolio | Upstox | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "AAA NEXT Generation WealthBasket aims to capitalize on robust digital ecosystem and faster digital adoption by focusing on companies leading the change.",
        "metaType": "default"
      }
    ],
    "ThematicPortfolio": [
      {
        "metaName": "title",
        "metaValue": "Alpha Dynamic Thematic Portfolio | Renaissance | Upstox | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Alpha Dynamic Thematic WealthBasket invests in stocks that fall within a particular theme. The theme selection is driven by macroeconomic conditions and sectoral trends",
        "metaType": "default"
      }
    ],
    "AbakkusSmartBuildIndiaPortfolio": [
      {
        "metaName": "title",
        "metaValue": "Abakkus Smart Build India Portfolio  | Upstox | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "By investing predominantly in companies benefiting from economic development, Abakkus Smart Build India WealthBasket strives to generate alpha and risk-adjusted returns for investors.",
        "metaType": "default"
      }
    ],
    "TamoharaAgile": [
      {
        "metaName": "title",
        "metaValue": "Tamohara Agile Portfolio | Upstox | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Tamohara Agile Strategy is a long only equity WealthBasket of the top 25 Stocks selected through a “Multi Factor Process” from the BSE200 Universe",
        "metaType": "default"
      }
    ],
    "CoreandSatellitePortfolio": [
      {
        "metaName": "title",
        "metaValue": "Alpha Core & Satellite Portfolio | Renaissance | Upstox | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Alpha Core & Satellite WealthBasket ensures wealth creation by investing in long-term secular growth companies and owning industry leaders that create higher ROCE.",
        "metaType": "default"
      }
    ],
    "TIOS": [
      {
        "metaName": "title",
        "metaValue": "Tamohara India Opportunities Portfolio | Upstox | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Tamohara India Opportunities Strategy WealthBasket focuses on 15-18 high-quality businesses that have a proven business model that is proven to succeed.",
        "metaType": "default"
      }
    ],
    "OpenQInfrastructureRealEstateTop500": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Infra & Realty Portfolio | Upstox | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "As the country grows, the demand for infrastructure and realty grows. Benefit from this trend by investing in the OpenQ Infra and Realty WealthBasket",
        "metaType": "default"
      }
    ]
  },
  "motilaloswal": {
    "HomeController": [
      {
        "metaName": "title",
        "metaValue": "Motilal Oswal Financial Services | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Sign in with Motilal Oswal to invest in stock and ETF portfolios created by SEBI Registered Professionals on WealthDesk.",
        "metaType": "default"
      }
    ],
    "FundDiscoveryController": [
      {
        "metaName": "title",
        "metaValue": "Invest in Smart Beta Stock & ETF Portfolios | Motilal Oswal | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Invest in WealthBaskets through Motilal Oswal. Login now to invest in portfolios based on a theme, idea or sector created by SEBI Registered Professionals.",
        "metaType": "default"
      }
    ],
    "FAQController": [
      {
        "metaName": "title",
        "metaValue": "FAQs | Motilal Oswal Securities | WealthBaskets | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Get answers to Frequently Asked Questions (FAQs) about Motilal Oswal, WealthDesk and WealthBaskets. How to invest in WealthBaskets, pricing and more.",
        "metaType": "default"
      }
    ],
    "ContactUsController": [
      {
        "metaName": "title",
        "metaValue": "WealthDesk Support: Contact Us | Motilal Oswal Securities",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Get in touch with us for any questions or concerns regarding WealthBaskets or transactions related queries from Motilal Oswal",
        "metaType": "default"
      }
    ],
    "broker_login": [
      {
        "metaName": "title",
        "metaValue": "Motilal Oswal Login | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Securely Login with Motilal Oswal to invest in Smart Beta WealthBaskets: Stock & ETF Portfolios",
        "metaType": "default"
      }
    ],
    "TradeETF": [
      {
        "metaName": "title",
        "metaValue": "Tradenet Trade ETF Portfolio | Motilal Oswal | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Tradenet Trade ETF WealthBasket aims to generate absolute return in the short term along with outperforming the benchmark. ",
        "metaType": "default"
      }
    ],
    "MID5": [
      {
        "metaName": "title",
        "metaValue": "FinMoLite MID-5 | Motilal Oswal | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "FinMoLite MID-5 is a dynamic WealthBasket of 5 mid-cap stocks/ETFs to mimic the returns of the NiftyMidcap100 Index, adjusted to improve the risk profile.",
        "metaType": "default"
      }
    ],
    "RETURNPROTECTOR": [
      {
        "metaName": "title",
        "metaValue": "FinMoLITE RETURN PROTECTOR Portfolio | Motilal Oswal | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "With the FinMoLITE Return Protector WealthBasket, investors can park their cash in a safe place if there is no opportunity or when they have reached their goal.",
        "metaType": "default"
      }
    ],
    "SPI": [
      {
        "metaName": "title",
        "metaValue": "SPI Portfolio | Motilal Oswal | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Motilal Oswal SPI aims to generate absolute return in the short term along with outperforming the benchmark",
        "metaType": "default"
      }
    ],
    "OpenQIndiaConsumptionTop500New": [
      {
        "metaName": "title",
        "metaValue": "OpenQ India Consumption Portfolio | Motilal Oswal | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ India Consumption WealthBasket invests in top performing cyclical/non cyclical consumer stocks which are selected based on a proprietary algorithm.",
        "metaType": "default"
      }
    ],
    "SMALL5": [
      {
        "metaName": "title",
        "metaValue": "FinMoLITE SMALL-5 Portfolio | Motilal Oswal | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "FinMoLite SMALL-5 is a dynamic WealthBasket of 5 small-cap stocks/ETFs to mimic the returns of the NiftySmallcap250 Index ,adjusted to improve the risk profile.",
        "metaType": "default"
      }
    ],
    "MONTHLY": [
      {
        "metaName": "title",
        "metaValue": "FinMoLITE MONTHLY Portfolio | Motilal Oswal | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Finmo Advisory  Rupee Rakshak Monthly WealthBasket lets you invest your accumulated monthly capital in stocks & ETFs.",
        "metaType": "default"
      }
    ],
    "GOLD": [
      {
        "metaName": "title",
        "metaValue": "FinMoLITE GOLD Portfolio | Motilal Oswal | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "FinMoLite Gold is a WealthBasket of Stocks & ETFs or mimics ETFs, like NIFTY50 ETF, SENSEX30 ETF, BANKNIFTY ETF, GOLD ETF.",
        "metaType": "default"
      }
    ],
    "FINMOLITE": [
      {
        "metaName": "title",
        "metaValue": "FinMoLITE BIG-5 Portfolio | Motilal Oswal | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "The FinMoLite BIG-5 consists of 5 select, large-cap stocks/ETFs, aimed at mimicking the NIFTY Heavyweight Index, while adjusting for risk profile.",
        "metaType": "default"
      }
    ],
    "TejiMandi": [
      {
        "metaName": "title",
        "metaValue": "Teji Mandi Portfolio | Motilal Oswal | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Teji Mandi WealthBasket is an investment portfolio that includes 10-15 highly related and well-researched companies stocks that have good sentiment/price momentum.",
        "metaType": "default"
      }
    ],
    "TradeSanchay": [
      {
        "metaName": "title",
        "metaValue": "Trade Sanchay Portfolio | Motilal Oswal | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "With Motilal Oswal, you can invest in Trade Sanchay WealthBasket portfolio. This portfolio helps investors generate absolute returns in short term while outperforming benchmarks.",
        "metaType": "default"
      }
    ],
    "MCCHAMP": [
      {
        "metaName": "title",
        "metaValue": "Multi Cap Champions Portfolio | Motilal Oswal | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Invest in Multi Cap Champions WealthBasket with Motilal Oswal. This portfolio invest in large-cap, mid-cap, and small-cap stocks which contribute to the generation of wealth.",
        "metaType": "default"
      }
    ],
    "LCCHAMP": [
      {
        "metaName": "title",
        "metaValue": "Large Cap Champions Portfolio | Motilal Oswal | WealthDeskk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Large Cap Champions WealthBasket by Rishabh Wealth Management is a Model Portfolio Of Large Cap Companies ",
        "metaType": "default"
      }
    ],
    "FinancialFreedom": [
      {
        "metaName": "title",
        "metaValue": "Financial Freedom Portfolio | Motilal Oswal | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Financial Freedom WealthBasket by Hedge Equities is an equity portfolio that identifies dynamic companies that are market leaders to provide a steady return over a long run",
        "metaType": "default"
      }
    ],
    "OpenQDefensiveMomentumTop500New": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Defensive Momentum Portfolio | Motilal Oswal | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ Defensive Momentum WealthBasket captures the risk premium from Momentum by using a proprietary algorithm over 2 business cycle of beta neutral performance.",
        "metaType": "default"
      }
    ],
    "BANKNIFTY": [
      {
        "metaName": "title",
        "metaValue": "FinMoLITE BANKNIFTY Portfolio | Motilal Oswal | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "FinMoLITE Bank Nifty is a WealthBasket of ETFs or mimics ETFs, like NIFTY50 ETF, SENSEX30 ETF, BANKNIFTY ETF, GOLD ETF.",
        "metaType": "default"
      }
    ],
    "TradeVruddhi": [
      {
        "metaName": "title",
        "metaValue": "Trade Vruddhi Portfolio | Motilal Oswal | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Trade Vruddhi WealthBasket aims to generate absolute return in the short term along with outperforming the benchmark.",
        "metaType": "default"
      }
    ],
    "TradeMidcap": [
      {
        "metaName": "title",
        "metaValue": "Trade Midcap | Motilal Oswal | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Trade Midcap WealthBasket is a pre-packaged advisory product aiming to invest in top 15 market cap wise Companies.",
        "metaType": "default"
      }
    ],
    "QuantechBankingServiceTop500New": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Banking & Investment Services Portfolio | Motilal Oswal | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ Banking & Investment Services WealthBasket invests in banking services sector companies using a proprietary algorithms",
        "metaType": "default"
      }
    ],
    "CoreandSatellitePortfolio": [
      {
        "metaName": "title",
        "metaValue": "Alpha Core & Satellite Portfolio | Motilal Oswal | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Alpha Core & Satellite WealthBasket ensures wealth creation by investing in long-term secular growth companies and owning industry leaders that create higher ROCE.",
        "metaType": "default"
      }
    ],
    "AbakkusSmartBuildIndiaPortfolio": [
      {
        "metaName": "title",
        "metaValue": "Abakkus Smart Build India Portfolio | Motilal Oswal | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "By investing predominantly in companies benefiting from economic development, Abakkus Smart Build India WealthBasket strives to generate alpha and risk-adjusted returns for investors.",
        "metaType": "default"
      }
    ],
    "AbakkusSmartFlexiCapPortfolio": [
      {
        "metaName": "title",
        "metaValue": "Abakkus Smart Flexi-Cap Portfolio | Motilal Oswal | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Abakkus Smart Flexi-Cap Portfolio WealthBasket aims to generate alpha & risk adjusted returns by creating a portfolio predominantly with Top 250 companies.",
        "metaType": "default"
      }
    ],
    "MomentumPortfolio": [
      {
        "metaName": "title",
        "metaValue": "Alpha Momentum | Motilal Oswal | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Alpha Momentum WealthBasket combines a fundamental investment philosophy with a tactical strategy that aims to generate absolute returns on a timely basis.",
        "metaType": "default"
      }
    ],
    "Bluechip": [
      {
        "metaName": "title",
        "metaValue": "Alpha Bluechip | Motilal Oswal | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Alpha Bluechip WealthBasket invests in companies with high growth potential that deliver superior risk adjusted returns over the medium-term to long-term.",
        "metaType": "default"
      }
    ],
    "OpenQInfrastructureRealEstateTop500": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Infra & Realty Portfolio | MOSL | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "As the country grows, the demand for infrastructure and realty grows. Benefit from this trend by investing in the OpenQ Infra and Realty WealthBasket",
        "metaType": "default"
      }
    ],
    "AAANEXT": [
      {
        "metaName": "title",
        "metaValue": "AAA NEXT Generation | Motilal Oswal | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "AAA NEXT Generation WealthBasket aims to capitalize on robust digital ecosystem and faster digital adoption by focusing on companies leading the change.",
        "metaType": "default"
      }
    ],
    "TradeVishaal": [
      {
        "metaName": "title",
        "metaValue": "Trade Vishaal | Motilal Oswal | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Trade Vishal WealthBasket portfolio by TradeNet offers investors the opportunity to invest in large-cap stocks selected based on a proprietary algorithm that generates wealth.",
        "metaType": "default"
      }
    ],
    "TamoharaTruffle": [
      {
        "metaName": "title",
        "metaValue": "Tamohara Truffle Flexi Cap Strategy Portfolio | Motilal Oswal | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Truffle Flexi Cap Strategy WealthBasket objective is to deliver absolute wealth creation through a concentrated, long only, public equities portfolio.",
        "metaType": "default"
      }
    ],
    "TLES": [
      {
        "metaName": "title",
        "metaValue": "Tamohara Long Term Equity Strategy Portfolio | Motilal Oswal | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Tamohara Long Term Equity WealthBasket invests in not more than 20 high-quality businesses that will take advantage of the growth potential of India's economy",
        "metaType": "default"
      }
    ],
    "SIPTruffle": [
      {
        "metaName": "title",
        "metaValue": "Tamohara Stock SIP Portfolio | Motilal Oswal | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Tamohara Stock SIP WealthBasket is a direct equity SIP consists of seven handpicked stocks, which have a structural opportunity to grow in India over the next decade",
        "metaType": "default"
      }
    ],
    "ThematicPortfolio": [
      {
        "metaName": "title",
        "metaValue": "Alpha Dynamic Thematic Portfolios | Motilal Oswal | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Alpha Dynamic Thematic WealthBasket invests in stocks that fall within a particular theme. The theme selection is driven by macroeconomic conditions and sectoral trends",
        "metaType": "default"
      }
    ]
  },
  "zerodha": {
    "HomeController": [
      {
        "metaName": "title",
        "metaValue": "Login with Zerodha Kite | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Sign in with Zerodha to invest in stock and ETF portfolios created by SEBI Registered Professionals on WealthDesk.",
        "metaType": "default"
      }
    ],
    "FundDiscoveryController": [
      {
        "metaName": "title",
        "metaValue": "Invest in Smart Beta Portfolios | Zerodha | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Invest in WealthBaskets through Zerodha. Login now to invest in portfolios based on a theme, idea or sector created by SEBI Registered Professionals.",
        "metaType": "default"
      }
    ],
    "FAQController": [
      {
        "metaName": "title",
        "metaValue": "FAQs | Zerodha | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Get answers to Frequently Asked Questions (FAQs) about Zerodha, WealthDesk and WealthBaskets. How to invest in WealthBaskets, pricing and more.",
        "metaType": "default"
      }
    ],
    "ContactUsController": [
      {
        "metaName": "title",
        "metaValue": "WealthDesk Support: Contact Us | Zerodha | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Get in touch with us for any questions or concerns regarding WealthBaskets or transactions related queries from Zerodha",
        "metaType": "default"
      }
    ],
    "DisclosureController": [
      {
        "metaName": "title",
        "metaValue": "Disclosure | Zerodha | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Terms and conditions, disclosures, privacy policies affiliated with WealthBaskets, WealthDesk and Zerodha.",
        "metaType": "default"
      }
    ],
    "OpenQHybridEquity": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Balanced Hybrid Equity Portfolio | Zerodha Kite | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Invest in OpenQ Balanced HyBrid Equity WealthBasket with Zerodha,This WealthBasket dynamically switches between equity, debt and gold, depending upon the market situation.",
        "metaType": "default"
      }
    ],
    "OpenQMakeInIndia": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Make in India Portfolio | Zerodha Kite | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ Make in India WealthBasket identifies stocks that may benefit from the long term theme of promoting manufacturing in India.",
        "metaType": "default"
      }
    ],
    "OpenQPharmaTop500New": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Pharma Portfolio | Zerodha Kite | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ Pharma WealthBasket invests in Pharma stocks selected from the top 500 market cap stocks through proprietary algorithm that has given consistent returns.",
        "metaType": "default"
      }
    ],
    "OpenQIndiaConsumptionTop500New": [
      {
        "metaName": "title",
        "metaValue": "OpenQ India Consumption Portfolio | Zerodha Kite | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ India Consumption WealthBasket invests in top performing cyclical/non cyclical consumer stocks which are selected based on a proprietary algorithm.",
        "metaType": "default"
      }
    ],
    "OpenQChemicalBasketTop500New": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Chemicals Portfolio | Zerodha Kite | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "The OpenQ Chemicals WealthBasket invests in chemical stocks selected using a proprietary algorithm that has produced consistent returns over the past 20 years.",
        "metaType": "default"
      }
    ],
    "OpenQDefensiveMomentumTop500New": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Defensive Momentum Portfolio | Zerodha Kite | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ Defensive Momentum WealthBasket captures the risk premium from Momentum by using a proprietary algorithm over 2 business cycle of beta neutral performance.",
        "metaType": "default"
      }
    ],
    "QuantechDigitalIndiaNew": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Digital India Portfolio | Zerodha Kite | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ Digital India WealthBasket invests in stocks that will benefit the most due to digital India initiatives. Stocks are selected based on proprietary algorithm.",
        "metaType": "default"
      }
    ],
    "QuantechBankingServiceTop500New": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Banking & Investment Services Portfolio | Zerodha Kite | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ Banking & Investment Services WealthBasket invests in banking services sector companies using a proprietary algorithms",
        "metaType": "default"
      }
    ],
    "QuantechMNCNew": [
      {
        "metaName": "title",
        "metaValue": "OpenQ MNC Portfolio | Zerodha Kite | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ MNC WealthBasket is selected from a pool of listed MNCs top 500 stocks and have shown to generate consistent return over long term.",
        "metaType": "default"
      }
    ],
    "TamoharaTruffle": [
      {
        "metaName": "title",
        "metaValue": "Tamohara Truffle Flexi Cap Portfolio | Zerodha Kite | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Truffle Flexi Cap Strategy WealthBasket objective is to deliver absolute wealth creation through a concentrated, long only, public equities portfolio.",
        "metaType": "default"
      }
    ],
    "TLES": [
      {
        "metaName": "title",
        "metaValue": "Tamohara Long Term Equity Portfolio | Zerodha Kite | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Tamohara Long Term Equity WealthBasket invests in not more than 20 high-quality businesses that will take advantage of the growth potential of India's economy",
        "metaType": "default"
      }
    ],
    "SIPTruffle": [
      {
        "metaName": "title",
        "metaValue": "Tamohara Stock SIP Portfolio | Zerodha Kite | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Tamohara Stock SIP WealthBasket is a direct equity SIP consists of seven handpicked stocks, which have a structural opportunity to grow in India over the next decade",
        "metaType": "default"
      }
    ],
    "TamoharaAgile": [
      {
        "metaName": "title",
        "metaValue": "Tamohara Agile Portfolio | Zerodha Kite | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Tamohara Agile Strategy is a long only equity WealthBasket of the top 25 Stocks selected through a “Multi Factor Process” from the BSE200 Universe",
        "metaType": "default"
      }
    ],
    "TIOS": [
      {
        "metaName": "title",
        "metaValue": "Tamohara India Opportunities Portfolio | Zerodha Kite | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Tamohara India Opportunities Strategy WealthBasket focuses on 15-18 high-quality businesses that have a proven business model that is proven to succeed.",
        "metaType": "default"
      }
    ],
    "AbakkusSmartBuildIndiaPortfolio": [
      {
        "metaName": "title",
        "metaValue": "Abakkus Smart Build India Portfolio | Zerodha Kite | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "By investing predominantly in companies benefiting from economic development, Abakkus Smart Build India WealthBasket strives to generate alpha and risk-adjusted returns for investors.",
        "metaType": "default"
      }
    ],
    "AbakkusSmartFlexiCapPortfolio": [
      {
        "metaName": "title",
        "metaValue": "Abakkus Smart Flexi-Cap Portfolio | Zerodha Kite | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Abakkus Smart Flexi-Cap Portfolio WealthBasket aims to generate alpha & risk adjusted returns by creating a portfolio predominantly with Top 250 companies.",
        "metaType": "default"
      }
    ],
    "MomentumPortfolio": [
      {
        "metaName": "title",
        "metaValue": "Alpha Momentum Portfolio | Renaissance | Zerodha Kite | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Alpha Momentum WealthBasket combines a fundamental investment philosophy with a tactical strategy that aims to generate absolute returns on a timely basis.",
        "metaType": "default"
      }
    ],
    "CoreandSatellitePortfolio": [
      {
        "metaName": "title",
        "metaValue": "Alpha Core & Satellite Portfolio | Renaissance | Zerodha Kite | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Alpha Core & Satellite WealthBasket ensures wealth creation by investing in long-term secular growth companies and owning industry leaders that create higher ROCE.",
        "metaType": "default"
      }
    ],
    "ThematicPortfolio": [
      {
        "metaName": "title",
        "metaValue": "Alpha Dynamic Thematic Portfolio | Renaissance | Zerodha Kite | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Alpha Dynamic Thematic WealthBasket invests in stocks that fall within a particular theme. The theme selection is driven by macroeconomic conditions and sectoral trends",
        "metaType": "default"
      }
    ],
    "AAANEXT": [
      {
        "metaName": "title",
        "metaValue": "Alf Accurate NEXT Generation Portfolio | Zerodha Kite | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "AAA NEXT Generation WealthBasket aims to capitalize on robust digital ecosystem and faster digital adoption by focusing on companies leading the change.",
        "metaType": "default"
      }
    ],
    "OpenQInfrastructureRealEstateTop500": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Infra & Realty Portfolio | Zerodha | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "As the country grows, the demand for infrastructure and realty grows. Benefit from this trend by investing in the OpenQ Infra and Realty WealthBasket",
        "metaType": "default"
      }
    ]
  },
  "bpwealth": {
    "HomeController": [
      {
        "metaName": "title",
        "metaValue": "BP Equities Pvt Ltd Advisory Funds,powered by WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Sign in with BP Wealth to invest in stock and ETF portfolios created by SEBI Registered Professionals on WealthDesk.",
        "metaType": "default"
      }
    ],
    "FundDiscoveryController": [
      {
        "metaName": "title",
        "metaValue": "Invest in Stock & ETF Portfolios | BP Wealth Pvt Ltd | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Invest in WealthBaskets through BP Wealth. Login now to invest in portfolios based on a theme, idea or sector created by SEBI Registered Professionals.",
        "metaType": "default"
      }
    ],
    "FAQController": [
      {
        "metaName": "title",
        "metaValue": "FAQs | BP Wealth Pvt Ltd | WealthDeskk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Get answers to Frequently Asked Questions (FAQs) about BP Wealth, WealthDesk and WealthBaskets. How to invest in WealthBaskets, pricing and more.",
        "metaType": "default"
      }
    ],
    "ContactUsController": [
      {
        "metaName": "title",
        "metaValue": "WealthDesk Support: Contact Us | BP Wealth Management",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Get in touch with us for any questions or concerns regarding WealthBaskets or transactions related queries from BP Wealth",
        "metaType": "default"
      }
    ],
    "broker_login": [
      {
        "metaName": "title",
        "metaValue": "BP Wealth Login | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Login securely with BP Wealth to invest in Smart Beta WealthBaskets: Stock & ETF Portfolios",
        "metaType": "default"
      }
    ],
    "DisclosureController": [
      {
        "metaName": "title",
        "metaValue": "Disclosure | BP Wealth Management | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Terms and conditions, disclosures, privacy policies affiliated with WealthBaskets, WealthDesk and BP Wealth.",
        "metaType": "default"
      }
    ],
    "QuantechMNCNew": [
      {
        "metaName": "title",
        "metaValue": "MNC Box by Quantech Capital | BP Wealth | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ MNC WealthBasket is selected from a pool of listed MNCs top 500 stocks and have shown to generate consistent return over long term.",
        "metaType": "default"
      }
    ],
    "OpenQHybridEquity": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Balanced Edge Box | BP Wealth | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ Balanced HyBrid Equity WealthBasket dynamically switches between equity, debt and gold, depending upon the market situation.",
        "metaType": "default"
      }
    ],
    "OpenQMakeInIndia": [
      {
        "metaName": "title",
        "metaValue": "Bharat Box by Quantech Capital | BP Wealth | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ Make in India WealthBasket identifies stocks that may benefit from the long term theme of promoting manufacturing in India.",
        "metaType": "default"
      }
    ],
    "TechnoFunda": [
      {
        "metaName": "title",
        "metaValue": "Techno Funda | BP Wealth Management | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "BP Wealth Techno Funda WealthBasket aims to generate an absolute return in the short term along with outperforming the benchmark",
        "metaType": "default"
      }
    ],
    "OpenQIndiaConsumptionTop500New": [
      {
        "metaName": "title",
        "metaValue": "FMCG Box by Quantech Capital | BP Wealth | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ India Consumption WealthBasket invests in top performing cyclical/non cyclical consumer stocks which are selected based on a proprietary algorithm.",
        "metaType": "default"
      }
    ],
    "QuantechBankingServiceTop500New": [
      {
        "metaName": "title",
        "metaValue": "Money Box by Quantech Capital | BP Wealth | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ Banking & Investment Services WealthBasket invests in banking services sector companies using a proprietary algorithms",
        "metaType": "default"
      }
    ],
    "OpenQChemicalBasketTop500New": [
      {
        "metaName": "title",
        "metaValue": "Chemical Box by Quantech Capital | BP Wealth | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "The OpenQ Chemicals WealthBasket invests in chemical stocks selected using a proprietary algorithm that has produced consistent returns over the past 20 years.",
        "metaType": "default"
      }
    ],
    "OpenQPharmaTop500New": [
      {
        "metaName": "title",
        "metaValue": "Pharma Box by Quantech Capital | BP Wealth | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ Pharma WealthBasket invests in Pharma stocks selected from the top 500 market cap stocks through proprietary algorithm that has given consistent returns.",
        "metaType": "default"
      }
    ],
    "OpenQDefensiveMomentumTop500New": [
      {
        "metaName": "title",
        "metaValue": "Momentum 500 Box by OpenQ | BP Wealth | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ Defensive Momentum WealthBasket captures the risk premium from Momentum by using a proprietary algorithm over 2 business cycle of beta neutral performance.",
        "metaType": "default"
      }
    ],
    "Stockideanote": [
      {
        "metaName": "title",
        "metaValue": "Growth Box | BP Wealth Management | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "In BP Wealth's Growth WealthBasket, one stock idea a week is recommended with an upside potential of 15-20% during the next 9 to 12 months.",
        "metaType": "default"
      }
    ],
    "QuantechDigitalIndiaNew": [
      {
        "metaName": "title",
        "metaValue": "Digital Box by OpenQ | BP Wealth Management | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ Digital India WealthBasket invests in stocks that will benefit the most due to digital India initiatives. Stocks are selected based on proprietary algorithm.",
        "metaType": "default"
      }
    ],
    "PSU": [
      {
        "metaName": "title",
        "metaValue": "Public Sector Box | BP Wealth Management | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "BP Wealth Public Sector Box is designed to generate long-term capital by investing primarily in shares of Public Sector Undertakings (Government) companies.",
        "metaType": "default"
      }
    ],
    "RUPEERAKSHAKMonthly": [
      {
        "metaName": "title",
        "metaValue": "Finmo RUPEE RAKSHAK MONTHLY | BP Wealth | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Log in with BP Wealth to invest in Rupee Rakshak Monthly WealthBasket by Finmo Advisory, where you can invest your accumulated monthly capital in stocks & ETFs.",
        "metaType": "default"
      }
    ],
    "RUPEERAKSHAK": [
      {
        "metaName": "title",
        "metaValue": "Finmo RUPEE RAKSHAK | BP Wealth | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Login with BP Wealth to invest in Finmo Advisory Rupee Rakshak WealthBasket which has Stocks & ETFs or mimics like NIFTY50 ETF, SENSEX30 ETF, BANKNIFTY ETF. This is a Buy Low Sell High Strategy",
        "metaType": "default"
      }
    ],
    "COREGOLD": [
      {
        "metaName": "title",
        "metaValue": "Core Box | BP Wealth Managementh | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "BP Wealth Core WealthBasket invests in fundamentally strong large-cap, mid-cap and small-cap companies having a good track record with strong management capabilities.",
        "metaType": "default"
      }
    ],
    "RRMONTHLYMINI": [
      {
        "metaName": "title",
        "metaValue": "Finmo RR MONTHLY MINI | BP Wealth | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Log in with BP Wealth to invest in Finmo RR Monthly Mini WealthBasket, which helps you invest your accumulated monthly capital in stocks & ETFs.",
        "metaType": "default"
      }
    ],
    "InsuranceBox": [
      {
        "metaName": "title",
        "metaValue": "Insurance Box | BP Wealth Management | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "BP Wealth Insurance WealthBasket caters to growth in the Insurance sector in India. It includes both life and general insurance.",
        "metaType": "default"
      }
    ],
    "OpenQInfrastructureRealEstateTop500": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Infra & Realty Portfolio | BP Wealth | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "As the country grows, the demand for infrastructure and realty grows. Benefit from this trend by investing in the OpenQ Infra and Realty WealthBasket",
        "metaType": "default"
      }
    ]
  },
  "jmfinancialservices": {
    "HomeController": [
      {
        "metaName": "title",
        "metaValue": "JM Financial Services and Advisory | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Sign in with JM Financial to invest in stock and ETF portfolios created by SEBI Registered Professionals on WealthDesk.",
        "metaType": "default"
      }
    ],
    "FundDiscoveryController": [
      {
        "metaName": "title",
        "metaValue": "Invest in Smart Beta Stock & ETF Portfolios | JM Financial Services | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Invest in WealthBaskets through JM Financial. Login now to invest in portfolios based on a theme, idea or sector created by SEBI Registered Professionals.",
        "metaType": "default"
      }
    ],
    "FAQController": [
      {
        "metaName": "title",
        "metaValue": "FAQs | JM Financial Services and Advisory | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Get answers to Frequently Asked Questions (FAQs) about JM Financial, WealthDesk and WealthBaskets. How to invest in WealthBaskets, pricing and more.",
        "metaType": "default"
      }
    ],
    "ContactUsController": [
      {
        "metaName": "title",
        "metaValue": "Contact Us | JM Financial Services | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Terms and conditions, disclosures, privacy policies affiliated with WealthBaskets, WealthDesk and JM Financial.",
        "metaType": "default"
      }
    ],
    "DisclosureController": [
      {
        "metaName": "title",
        "metaValue": "Disclosure | JM Financial Services and Advisory | WealthDesk ",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Privacy Policies, Terms & Conditions, and disclaimers affiliated with WealthBaskets",
        "metaType": "default"
      }
    ],
    "OpenQHybridEquity": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Balanced Hybrid Equity Portfolio | JMFL | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ Balanced HyBrid Equity WealthBasket dynamically switches between equity, debt and gold, depending upon the market situation.",
        "metaType": "default"
      }
    ],
    "OpenQMakeInIndia": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Make in India Portfolio | JMFL | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ Make in India WealthBasket identifies stocks that may benefit from the long term theme of promoting manufacturing in India.",
        "metaType": "default"
      }
    ],
    "OpenQPharmaTop500New": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Pharma Portfolio | JMFL | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ Pharma WealthBasket invests in Pharma stocks selected from the top 500 market cap stocks through proprietary algorithm that has given consistent returns.",
        "metaType": "default"
      }
    ],
    "OpenQIndiaConsumptionTop500New": [
      {
        "metaName": "title",
        "metaValue": "OpenQ India Consumption Portfolio | JMFL | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ India Consumption WealthBasket invests in top performing cyclical/non cyclical consumer stocks which are selected based on a proprietary algorithm.",
        "metaType": "default"
      }
    ],
    "OpenQChemicalBasketTop500New": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Chemicals Portfolio | JMFL | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "The OpenQ Chemicals WealthBasket invests in chemical stocks selected using a proprietary algorithm that has produced consistent returns over the past 20 years.",
        "metaType": "default"
      }
    ],
    "OpenQDefensiveMomentumTop500New": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Defensive Momentum Portfolio | JM Financial | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ Defensive Momentum WealthBasket captures the risk premium from Momentum by using a proprietary algorithm over 2 business cycle of beta neutral performance.",
        "metaType": "default"
      }
    ],
    "QuantechDigitalIndiaNew": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Digital India Portfolio | JM Financial Services and Advisory | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ Digital India WealthBasket invests in stocks that will benefit the most due to digital India initiatives. Stocks are selected based on proprietary algorithm.",
        "metaType": "default"
      }
    ],
    "QuantechBankingServiceTop500New": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Banking & Investment Services Portfolio | JMFL | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ Banking & Investment Services WealthBasket invests in banking services sector companies using a proprietary algorithms",
        "metaType": "default"
      }
    ],
    "QuantechMNCNew": [
      {
        "metaName": "title",
        "metaValue": "OpenQ MNC Portfolio | JM Financial Services and Advisory | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ MNC WealthBasket is selected from a pool of listed MNCs top 500 stocks and have shown to generate consistent return over long term.",
        "metaType": "default"
      }
    ],
    "JMFLCOREVALUE": [
      {
        "metaName": "title",
        "metaValue": "JMFL Core Value SIP Portfolio | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "JMFL Core Value SIP WealthBasket Invests in a disciplined manner irrespective of the state of the market takes the ambiguity of market timing away",
        "metaType": "default"
      }
    ],
    "JMFLThematicCovidbeneficiary": [
      {
        "metaName": "title",
        "metaValue": "JMFL Thematic Covid Beneficiary Portfolio | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "JMFL Thematic Covid Beneficiary WealthBasket is comprised of pharmaceutical companies that stand to benefit both near and long term from the ongoing covid led crisis",
        "metaType": "default"
      }
    ],
    "JMAGGRESSIVEMODELPORT": [
      {
        "metaName": "title",
        "metaValue": "JM Active Model Portfolio | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "JM Active Model portfolio is a WealthBasket that designed for long term investment for clients with a bit high risk high reward mindset",
        "metaType": "default"
      }
    ],
    "JMFLACTIVESTRATEGY": [
      {
        "metaName": "title",
        "metaValue": "JMFL Select Focus Portfolio | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "JMFL Select Focus WealthBasket aims to identify opportunities by using our skillset to time market volatility properly, which can generate short-term returns.",
        "metaType": "default"
      }
    ],
    "JMFLPASSIVESTRATEGY": [
      {
        "metaName": "title",
        "metaValue": "JMFL Alpha Idea Portfolio | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "With JMFL Alpha Idea WealthBasket our approach is to blend alpha generation strategies along with risk mitigation which is critical for long-term wealth creation",
        "metaType": "default"
      }
    ],
    "JMFLCOREGROWTH": [
      {
        "metaName": "title",
        "metaValue": "JMFL Core Growth-SIP Portfolio | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "JMFL Core Growth-SIP WealthBasket is a bottom-up, growth focused portfolio with large cap preference",
        "metaType": "default"
      }
    ],
    "JMFSMIDCAPRESEARCH": [
      {
        "metaName": "title",
        "metaValue": "JMFS Momentum Portfolio | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "JMFS Momentum  WealthBasket Portfolio has Fundamentally Strong Ideas With Attractive Valuations",
        "metaType": "default"
      }
    ],
    "ThematicPublicsectorbasket": [
      {
        "metaName": "title",
        "metaValue": "JMFL Public Sector Enterprises Portfolio | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "JMFL Public Sector Enterprises WealthBasket aims to invest in companies where Government stake is more than 51% (GOI, State, POI etc) under the promoter category",
        "metaType": "default"
      }
    ],
    "JMMODERATEMODELPORTFOLIO": [
      {
        "metaName": "title",
        "metaValue": "JMFL Model Portfolio - Moderate | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "JM Moderate Model portfolio is designed for long term investment for clients with a bit high balanced risk reward expectations.",
        "metaType": "default"
      }
    ],
    "JMFLDEFENSIVEMODELPORT": [
      {
        "metaName": "title",
        "metaValue": "JMFL Model Portfolio - Passive | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "JM Passive model portfolio is designed for long term investment for clients with a bit conservative risk profile.",
        "metaType": "default"
      }
    ],
    "JMFLNEXTGROWTH": [
      {
        "metaName": "title",
        "metaValue": "JMFL Next Growth - SIP Portfolio | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "JMFL Next Growth WealthBasket is a bottom-up, growth focused portfolio with objective to identify mid-cap companies that are likely to emerge as industry leaders",
        "metaType": "default"
      }
    ],
    "JMFLBLENDEDPLAN": [
      {
        "metaName": "title",
        "metaValue": "JMFL Pick of the week Portfolio | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Pick of the Week ideas is our research WealthBasket suitable for Medium term investors with reasonable risk appetite.",
        "metaType": "default"
      }
    ],
    "JMFLNEXTVALUE": [
      {
        "metaName": "title",
        "metaValue": "JMFL Next Value - SIP Portfolio | WealthDesk  ",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "JMFL Next Value WealthBasket is a bottom-up value focused portfolio with objective to identify mid-cap companies that are likely to emerge as industry leaders.",
        "metaType": "default"
      }
    ]
  },
  "anandrathi": {
    "HomeController": [
      {
        "metaName": "title",
        "metaValue": "Anand Rathi Wealth Management | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Sign in with Anand Rathi to invest in stock and ETF portfolios created by SEBI Registered Professionals on WealthDesk.",
        "metaType": "default"
      }
    ],
    "FundDiscoveryController": [
      {
        "metaName": "title",
        "metaValue": "Invest in Smart Beta WealthBaskets: Stock & ETF Portfolios | Anand Rathi | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Invest in WealthBaskets through Anand Rathi. Login now to invest in portfolios based on a theme, idea or sector created by SEBI Registered Professionals.",
        "metaType": "default"
      }
    ],
    "OpenQHybridEquity": [
      {
        "metaName": "title",
        "metaValue": "OpenQ Balanced Hybrid Equity WealthBasket | Anand Rathi | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "OpenQ Balanced HyBrid Equity WealthBasket,This portfolio dynamically switches between equity, debt and gold, depending upon the market situation.",
        "metaType": "default"
      }
    ],
    "TRUSTPETHRUST": [
      {
        "metaName": "title",
        "metaValue": "Anand Rathi Trust pe Trust Portfolio | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Anand Rathi Trust pe Trust WealthBasket invests in most Reliable & Trusted Brand of India along with High Corporate Governance",
        "metaType": "default"
      }
    ],
    "TECHEDGEUNLOCKDOWNBASKET": [
      {
        "metaName": "title",
        "metaValue": "Anand Rathi Tech Edge: Electric Vehicles Portfolio | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "The Anand Rathi Tech Edge Electric is a Technical WealthBasket of 3-5 stocks selected on technical parameters, with a timeframe of 3-6 months.",
        "metaType": "default"
      }
    ],
    "ASPIRINGMIDDLECLASS": [
      {
        "metaName": "title",
        "metaValue": "Anand Rathi Aspiring Middle Class Portfolio | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Aspiring Middle Class WealthBasket consists of varied companies that will benefit from the growth in the Indian middle class disposable income & spending.",
        "metaType": "default"
      }
    ],
    "VISTARSEVIKAS": [
      {
        "metaName": "title",
        "metaValue": "Anand Rathi Vistar Se Vikas Portfolio | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Anand Rathi Vistar Se Vikas WealthBasket comprises of Companies doing Capex along with stocks which are  beneficial of Green shoots in Private Investments from corporate sector",
        "metaType": "default"
      }
    ],
    "HEALINGHEALTH": [
      {
        "metaName": "title",
        "metaValue": "Anand Rathi Healing Health Portfolio | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Anand Rathi Healing Health WealthBasket consists of growing pharmaceutical companies",
        "metaType": "default"
      }
    ],
    "VELOCITYBASKETPVTBANKS": [
      {
        "metaName": "title",
        "metaValue": "VELOCITY BASKET : PVT BANKS WealthBasket | Anand Rathi | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "VELOCITY is a Technical and Derivative Basket comprising of 3-4 stock recommendations. The stock selection is based upon Technical and Derivative parameters, considering the overall momentum of the market valid for a period of 15 days.",
        "metaType": "default"
      }
    ],
    "TECHEDGESARKARIBANKS": [
      {
        "metaName": "title",
        "metaValue": "Anand Rathi Tech Edge: Sarkari Banks Portfolio | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Anand Rathi Tech Edge: Sarkari Banks WealthBasket of 3-5 stocks selected on technical parameters, with a timeframe of 3-6 months.",
        "metaType": "default"
      }
    ],
    "SUNSEEARN": [
      {
        "metaName": "title",
        "metaValue": "Anand Rathi Sun se Earn Portfolio | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Invest in Anand Rathi SUN SE EARN WealthBesket, this is a Multi Cap Long Term Investment portfolio focuses on Consumer durables Industry",
        "metaType": "default"
      }
    ],
    "HOMEANGELS": [
      {
        "metaName": "title",
        "metaValue": "Anand Rathi Home Angels Portfolio | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Anand Rathi Home Angels WealthBasket, this is a multicap longterm portfolio focuses on real-estate sector",
        "metaType": "default"
      }
    ],
    "MODELPORTFOLIOAGGRESSIVE": [
      {
        "metaName": "title",
        "metaValue": "MODEL PORTFOLIO AGGRESSIVE WealthBasket | Anand Rathi | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Login with Anand Rathi to invest in MODEL PORTFOLIO AGGRESSIVE WealthBesket, this portfolio construction is based on Aggressive style Investing with a proper Balance between Large Cap and Mid/Small cap stocks.",
        "metaType": "default"
      }
    ],
    "MODELPORTFOLIOMODERATE": [
      {
        "metaName": "title",
        "metaValue": "Anand Rathi Model Portfolio Aggressive | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "This WealthBasket construction is based on Aggressive style Investing with a proper Balance between Large Cap and Mid/Small cap stocks.",
        "metaType": "default"
      }
    ],
    "BONDWITHTHEBEST": [
      {
        "metaName": "title",
        "metaValue": "BOND WITH THE BEST WealthBasket | Anand Rathi | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "BOND WITH THE BEST WealthBasket is a blend of Market Leaders from Various Sectors, the companies which enjoys the large Sales Volumes & Increasing Market Share even in Volatile Markets. Sustainable Stock to beat the Volatility.",
        "metaType": "default"
      }
    ],
    "MODELPORTFOLIOCONSERVATIVE": [
      {
        "metaName": "title",
        "metaValue": "Anand Rathi Model Portfolio Moderate | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "This WealthBasket construction is based on Moderate style Investing with a proper Balance between Large Cap and Mid/Small cap stocks.",
        "metaType": "default"
      }
    ],
    "ALPHATECH6": [
      {
        "metaName": "title",
        "metaValue": "ALPHA TECH BASKET WealthBasket | Anand Rathi | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "ALPHA TECH is a basket comprises of stocks from a diversified platform. It consists of 4 stock recommendations based on technical ideas with a time perspective of a month.",
        "metaType": "default"
      }
    ],
    "KHETKHALIYAN": [
      {
        "metaName": "title",
        "metaValue": "Anand Rathi Khet Khalihan Portfolio | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Anand Rathi Khet Khalihan WealthBasket is a well-researched Investment Bakset Comprising of the best agriculture stocks",
        "metaType": "default"
      }
    ],
    "ROZANAESSENTIALS": [
      {
        "metaName": "title",
        "metaValue": "Anand Rathi Rozana Essentials Portfolio | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Anand Rathi Rozana Essentials WealthBasket have curated basket of essentials - handpicked stocks which will be be favored by the Current State of Affairs.",
        "metaType": "default"
      }
    ],
    "MINICEMENTPACK": [
      {
        "metaName": "title",
        "metaValue": "MINI CEMENT PACK WealthBasket | Anand Rathi | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Login with Anand Rathi to invest in MINI CEMENT PACK WealthBesket, this is a Multi Cap Long Term Investment Basket.",
        "metaType": "default"
      }
    ],
    "POTENTIALPSU": [
      {
        "metaName": "title",
        "metaValue": "Anand Rathi Potential PSU Portfolio | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Anand Rathi POTENTIAL PSU WealthBesket, this basket eases the hassle by offering  well researched PSU from different Sectors of the Industry",
        "metaType": "default"
      }
    ],
    "EARNINGSTARS": [
      {
        "metaName": "title",
        "metaValue": "EARNING STARS WealthBasket | Anand Rathi | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Login with Anand Rathi to invest in EARNING STARS WealthBesket, This Basket Comprises of Companies that have delivered exceptional results in the last quarter and are expected to do well in coming quarters too.",
        "metaType": "default"
      }
    ],
    "HARVESTINGHEROs": [
      {
        "metaName": "title",
        "metaValue": "HARVESTING HERO's Portfolio | Anand Rathi | WealthDesk  ",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Anand Rathi's HARVESTING HERO's WealthBasket consists of Agrichem stocks which allow investors to efficiently track and invest in the Agrochemical and Fertilizer sector.",
        "metaType": "default"
      }
    ],
    "CREDITseBENEFIT": [
      {
        "metaName": "title",
        "metaValue": "CREDIT se BENEFIT Portfolio | Anand Rathi | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Anand Rathi's CREDIT se BENEFIT WealthBasket comprises of private banks and financial services companies which allow investors to efficiently track and invest in the BFSI sector.",
        "metaType": "default"
      }
    ],
    "NearDearBrands": [
      {
        "metaName": "title",
        "metaValue": "Near & Dear Brands Portfolio | Anand Rathi | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Anand Rathi's Near & Dear Brands WealthBasket consists of near and dear established brands which has high brand visibility & serves an integral part of aspiring middle class.",
        "metaType": "default"
      }
    ],
    "UBHARTESITAARE": [
      {
        "metaName": "title",
        "metaValue": "UBHARTE SITAARE (RISING STARS) Portfolio | Anand Rathi | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "UBHARTE SITAARE WealthBasket consists of Rising Star companies with established brands, sound management, higher growth potential and possibilities of evolving into large caps and offer exposure to wide variety of industries.",
        "metaType": "default"
      }
    ],
    "REVERSALOFFORTUNES": [
      {
        "metaName": "title",
        "metaValue": "REVERSAL OF FORTUNES (TURN AROUND THEME) Portfolio | Anand Rathi | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "REVERSAL OF FORTUNES WealthBasket consists of companies with established brands, higher growth potential with Turnaround business and offer exposure to wide variety of industries.",
        "metaType": "default"
      }
    ],
    "BEATTHEHEAT": [
      {
        "metaName": "title",
        "metaValue": "BEAT THE HEAT Portfolio | Anand Rathi | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Anand Rathi's BEAT THE HEAT WealthBasket comprises companies with sound business, have shown growth over the years & are potential beneficiaries of Summer Season.",
        "metaType": "default"
      }
    ],
    "CRUDEkaCONTRAPLAY": [
      {
        "metaName": "title",
        "metaValue": "CRUDE ka CONTRA PLAY Portfolio | Anand Rathi | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Anand Rathi's CRUDE ka CONTRA PLAY WealthBasket consists of Companies driving Indias transition to electric vehicles transports new era and also crude contra play.",
        "metaType": "default"
      }
    ],
    "GLOBALtoLOCAL": [
      {
        "metaName": "title",
        "metaValue": "GLOBAL to LOCAL Portfolio | Anand Rathi | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Anand Rathi's GLOBAL to LOCAL WealthBasket consist of the stocks which has good domestic presence & has potential to grow.",
        "metaType": "default"
      }
    ],
    "TECHEDGECEMENTBASKET": [
      {
        "metaName": "title",
        "metaValue": "TECH EDGE : CEMENT BASKET Portfolio | Anand Rathi | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Anand Rathi's TECH EDGE : CEMENT WEALTH BASKET'S Stock Selection is done on Technical Parameters focusing on gains of more than 20%, Risk Reward 1:2.",
        "metaType": "default"
      }
    ],
    "SECTORALSHARKS": [
      {
        "metaName": "title",
        "metaValue": "SECTORAL SHARKS Portfolio | Anand Rathi | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "SECTORAL SHARKS WealthBasket has companies building a strong business moat, runway of opportunities ahead and are leaders of these sectors which can grow at a faster pace and shall create higher value for the Investors.",
        "metaType": "default"
      }
    ],
    "BUDGETPICKS2022": [
      {
        "metaName": "title",
        "metaValue": "BUDGET PICKS 2022 Portfolio | Anand Rathi | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Anand Rathi's BUDGET PICKS 2022 WealthBasket is specially curated focusing the Budget Session. Handpicked Stocks from various Industries that directly or indirectly benefitted from the Budget 2022.",
        "metaType": "default"
      }
    ],
    "KAPDESEKAMAI": [
      {
        "metaName": "title",
        "metaValue": "KAPDE SE KAMAI Portfolio | Anand Rathi | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Anand Rathi's KAPDE SE KAMAI WealthBasket has textiles industry stocks with consumerism and disposable income on the rise, the retail sector has experienced a rapid growth in the past decade with the entry of several international players.",
        "metaType": "default"
      }
    ],
    "MARVELLOUSMIDCAPSFOR2022": [
      {
        "metaName": "title",
        "metaValue": "MARVELLOUS MIDCAPS FOR 2022 | Anand Rathi | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Anand Rathi's MARVELLOUS MIDCAPS FOR 2022 WealthBasket consists of mid-cap companies with established brands, higher growth potential and offer exposure to wide variety of industries.",
        "metaType": "default"
      }
    ],
    "BESTBUYCONVICTION": [
      {
        "metaName": "title",
        "metaValue": "BEST BUY CONVICTION Portfolio | Anand Rathi | WealthDesk  ",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Anand Rathi's BEST BUY CONVICTION WealthBasket consists of Multi Cap companies with sizeable market share in their own sectors. ",
        "metaType": "default"
      }
    ],
    "CHEMICALKAKAMAAL": [
      {
        "metaName": "title",
        "metaValue": "CHEMICAL KA KAMAAL Portfolio | Anand Rathi | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Anand Rathi's CHEMICAL KA KAMAAL WealthBasket comprises of companies into chemicals Industries that are used in a wide range of industries like automobiles, pharma, textiles, food processing, Agro chemicals etc.",
        "metaType": "default"
      }
    ],
    "HOMEDECOR": [
      {
        "metaName": "title",
        "metaValue": "HOME DECOR Portfolio | Anand Rathi | WealthDesk ",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Anand Rathi's HOME DECOR WealthBasket comprises of stocks focused on Home Decor Theme which are fundamentally strong with great past performance and which have high growth potential.",
        "metaType": "default"
      }
    ],
    "GIANTWHEEL": [
      {
        "metaName": "title",
        "metaValue": "GIANT WHEEL (BLUECHIPS) Portfolio | Anand Rathi | WealthDesk  ",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Anand Rathi's GIANT WHEEL WealthBasket consists of Giant Leaders which will outperform the market in the longer term & current fall in the market can be utilized to buy this stocks.",
        "metaType": "default"
      }
    ],
    "UNNATI": [
      {
        "metaName": "title",
        "metaValue": "UNNATI (Better Lifestyle) Portfolio | Anand Rathi | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Anand Rathi's UNNATI (Better Lifestyle) WealthBasket comprises of sectors such as Housing Finance, Auto, Hospitality and Retail fashion which will benefit from Better Lifestyle Consumption Theme. ",
        "metaType": "default"
      }
    ],
    "PARTYTIME": [
      {
        "metaName": "title",
        "metaValue": "PARTY TIME (CONSUMPTION THEME) Portfolio | Anand Rathi | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Anand Rathi's PARTY TIME WealthBasket comprises of selection of potential beneficiaries of a rebound in leisure, food and hospitality industries due to higher festive demand ahead.",
        "metaType": "default"
      }
    ],
    "BETTERTOMORROW": [
      {
        "metaName": "title",
        "metaValue": "BETTER TOMORROW Portfolio | Anand Rathi | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Anand Rathi's BETTER TOMORROW WealthBasket consist of 4 companies (Multicap) where in Management has provided Strong Commentary or Guidance post Q2 Earnings & Expected to deliver robust earnings expected in H2 FY22 & FY23.",
        "metaType": "default"
      }
    ],
    "TezzRaftaar": [
      {
        "metaName": "title",
        "metaValue": "Tezz Raftaar (Auto Theme) Portfolio | Anand Rathi | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Anand Rathi's Tezz Raftaar WealthBasket comprises automobiles and Auto ancillary companies that allow investors to efficiently  invest in the automobile sector & capture the momentum.",
        "metaType": "default"
      }
    ],
    "BHARATNIRMAN": [
      {
        "metaName": "title",
        "metaValue": "BHARAT NIRMAN Portfolio | Anand Rathi | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Anand Rathi's BHARAT NIRMAN WealthBasket comprises of construction. engineering & Steel companies to allow investors to efficiently track and invest in the infra sector.",
        "metaType": "default"
      }
    ],
    "PARAMSHAKTI": [
      {
        "metaName": "title",
        "metaValue": "PARAM SHAKTI (Ultimate Leaders) Portfolio | Anand Rathi | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Anand Rathi's PARAM SHAKTI WealthBasket has companies building a strong business moat, runway of opportunities ahead and are leaders of these sectors which can grow at a faster pace and shall create higher value for the Investors.",
        "metaType": "default"
      }
    ],
    "DiwaliTechnicalPicks2021": [
      {
        "metaName": "title",
        "metaValue": "Diwali Technical Picks : 2021 Portfolio | Anand Rathi | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Anand Rathi's Diwali Technical Picks : 2021 WealthBasket comprises of 6 stock recommendations & the stock selection are purely based upon Technical and Derivative parameters, considering the overall momentum in the market.",
        "metaType": "default"
      }
    ],
    "DIWALIDHAMAKAFUNDAMENTAL": [
      {
        "metaName": "title",
        "metaValue": "DIWALI DHAMAKA (FUNDAMENTAL) Portfolio | Anand Rathi | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Anand Rathi's DIWALI DHAMAKA WealthBasket comprises of 6 stock recommendations & the stock selection are purely based upon Fundamental Analysis with Medium to Long-term Investment Time Frame.",
        "metaType": "default"
      }
    ],
    "MAKEFORTHEWORLD": [
      {
        "metaName": "title",
        "metaValue": "MAKE FOR THE WORLD Portfolio | Anand Rathi | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Anand Rathi's MAKE FOR THE WORLD WealthBasket consists of listed Multinationals having global presence, strong fundamentals, good growth prospects and competitive advantage, proven business models which have the capability to generate higher returns.",
        "metaType": "default"
      }
    ],
    "ENTRYBARRIERBIZ": [
      {
        "metaName": "title",
        "metaValue": "ENTRY BARRIER BIZ Portfolio | Anand Rathi | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Anand Rathi's ENTRY BARRIER BIZ WealthBasket comprises of companies with Dominant business in their respective sectors along with High Entry barrier.",
        "metaType": "default"
      }
    ],
    "GROWTHATREASONABLEPRICE": [
      {
        "metaName": "title",
        "metaValue": "GROWTH AT REASONABLE PRICE (GARP) Portfolio | Anand Rathi | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Anand Rathi's GROWTH AT REASONABLE PRICE WealthBasket is a strategy that aims to highlight companies that are growing but still reasonably priced by the market. It is a combination of value and growth investing.",
        "metaType": "default"
      }
    ],
    "GROWTHCHEMISTRY": [
      {
        "metaName": "title",
        "metaValue": "GROWTH CHEMISTRY (CHEMICALS) Portfolio | Anand Rathi | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Anand Rathi's GROWTH CHEMISTRY WealthBasket comprises of stocks from chemicals and specialty chemicals industry.",
        "metaType": "default"
      }
    ],
    "IndiasIndustrialProduction": [
      {
        "metaName": "title",
        "metaValue": "IIP - India's Industrial Production Portfolio | Anand Rathi | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Anand Rathi's India's Industrial Production WealthBasket comprises of companies from manufacturing sector of India.",
        "metaType": "default"
      }
    ],
    "RotiKapdaAurMakaan": [
      {
        "metaName": "title",
        "metaValue": "Roti Kapdaa & Makaan Portfolio | Anand Rathi | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Anand Rathi's Roti Kapdaa & Makaan WealthBasket focuses on Food, Clothing & Real Estate Sector.",
        "metaType": "default"
      }
    ],
    "SARKARISTARS": [
      {
        "metaName": "title",
        "metaValue": "SARKARI STARS Portfolio | Anand Rathi | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Anand Rathi's SARKARI STARS WealthBasket consists of carefully handpicked dominant public sector unit stocks across a diversified industries ranging from Insurance to Steel to Ports & Railways, which is an ideal long term strategy to stay invested in.",
        "metaType": "default"
      }
    ],
    "TEQUITY": [
      {
        "metaName": "title",
        "metaValue": "TEQUITY (TECHNOLOGY) Portfolio | Anand Rathi | WealthDesk",
        "metaType": "title"
      },
      {
        "metaName": "description",
        "metaValue": "Anand Rathi's TEQUITY WealthBasket is a Super Portfolio of Indian Technology companies enabling global enterprises to accomplish their digital transformation.",
        "metaType": "default"
      }
    ],
    "nirmalbang": {
      "HomeController": [
        {
          "metaName": "title",
          "metaValue": "Nirmal Bang Advisory WealthBaskets, Powered by WealthDesk",
          "metaType": "title"
        },
        {
          "metaName": "description",
          "metaValue": "Nirmal Bang brings you the profitable investment options for you, using the best of technology and automation.",
          "metaType": "default"
        },
        {
          "metaName": "suggestedtitle",
          "metaValue": "Nirmal Bang | WealthDesk",
          "metaType": "default"
        },
        {
          "metaName": "suggesteddescription",
          "metaValue": "Nirmal Bang users can purchase WealthBaskets online by logging in and choosing one that is right for their risk profile.",
          "metaType": "default"
        }
      ]
    },
    "paytmmoney": {
      "HomeController": [
        {
          "metaName": "title",
          "metaValue": "WealthDesk",
          "metaType": "title"
        },
        {
          "metaName": "suggestedtitle",
          "metaValue": "Paytm Money | WealthDesk",
          "metaType": "default"
        }
      ],
      "weekendinvesting": {
        "HomeController": [
          {
            "metaName": "title",
            "metaValue": "weekendinvesting Sebi Registered Investment Advisor",
            "metaType": "title"
          },
          {
            "metaName": "description",
            "metaValue": "weekendinvesting Sebi Registered Investment Advisor that offers smart beta portfolios and other investment tools like portfolio scanner and optimiser.",
            "metaType": "default"
          },
          {
            "metaName": "suggestedtitle",
            "metaValue": "Weekend Investing WealthBaskets | WealthDesk",
            "metaType": "default"
          },
          {
            "metaName": "suggesteddescription",
            "metaValue": "WeekendInvesting is a SEBI registered Investment Advisory of DIY products based on structured Momentum investing principles.",
            "metaType": "default"
          }
        ]
      },
      "yesinvest": {
        "HomeController": [
          {
            "metaName": "title",
            "metaValue": "Yes Bank Securities | WealthDesk",
            "metaType": "title"
          },
          {
            "metaName": "description",
            "metaValue": "Sign in with Yes Securities to invest in stock and ETF portfolios created by SEBI Registered Professionals on WealthDesk.",
            "metaType": "default"
          }
        ],
        "FundDiscoveryController": [
          {
            "metaName": "title",
            "metaValue": "Invest in Smart Beta Stock & ETF Portfolios | Yes Securities | WealthDesk",
            "metaType": "title"
          },
          {
            "metaName": "description",
            "metaValue": "Invest in WealthBaskets through Yes Securities. Login now to invest in portfolios based on a theme, idea or sector created by SEBI Registered Professionals.",
            "metaType": "default"
          }
        ],
        "FAQController": [
          {
            "metaName": "title",
            "metaValue": "FAQs | Yes Securities | WealthDesk",
            "metaType": "title"
          },
          {
            "metaName": "description",
            "metaValue": "Get answers to Frequently Asked Questions (FAQs) about Yes Securities, WealthDesk and WealthBaskets. How to invest in WealthBaskets, pricing and more.",
            "metaType": "default"
          }
        ],
        "ContactUsController": [
          {
            "metaName": "title",
            "metaValue": "WealthDesk Support: Contact Us | Yes Securities",
            "metaType": "title"
          },
          {
            "metaName": "description",
            "metaValue": "Get in touch with us for any questions or concerns regarding WealthBaskets or transactions related queries from Yes Securities",
            "metaType": "default"
          }
        ],
        "DisclosureController": [
          {
            "metaName": "title",
            "metaValue": "Disclosure | Yes Securities | WealthDesk",
            "metaType": "title"
          },
          {
            "metaName": "description",
            "metaValue": "Terms and conditions, disclosures, privacy policies affiliated with WealthBaskets, WealthDesk and Yes Securities.",
            "metaType": "default"
          }
        ],
        "FlexicapETF": [
          {
            "metaName": "title",
            "metaValue": "Yes Securities Flexi Cap ETF Portfolio | WealthDesk",
            "metaType": "title"
          },
          {
            "metaName": "description",
            "metaValue": "Yes Securities Flexi Cap ETF WealthBasket strategy is a healthy mix of largecaps and midcaps invests in top 250 marketcap companies using ETFs.",
            "metaType": "default"
          }
        ],
        "SectoralETF": [
          {
            "metaName": "title",
            "metaValue": "Yes Securities Sectoral ETF Portfolio | WealthDesk",
            "metaType": "title"
          },
          {
            "metaName": "description",
            "metaValue": "Yes Securities Sectoral ETF WealthBasket Strategy invests in BFSI and IT sectors which are major contributors both towards headline indices as well as towards the GDP",
            "metaType": "default"
          }
        ],
        "AllWeatherlite": [
          {
            "metaName": "title",
            "metaValue": "Yes Securities All Weather Basket - Lite Portfolio | WealthDesk",
            "metaType": "title"
          },
          {
            "metaName": "description",
            "metaValue": "Yes Securities All Weather Basket - Lite Wealthbasket is ideal for all types of market conditions as it endeavors to generate steady returns to help meet long-term investment goals. ",
            "metaType": "default"
          }
        ],
        "ValueBuys": [
          {
            "metaName": "title",
            "metaValue": "Yes Securities Flexi Cap ETF Portfolio | WealthDesk",
            "metaType": "title"
          },
          {
            "metaName": "description",
            "metaValue": "Yes Securities Flexi Cap ETF WealthBasket strategy is a healthy mix of largecaps and midcaps invests in top 250 marketcap companies using ETFs.",
            "metaType": "default"
          }
        ],
        "AllWeather": [
          {
            "metaName": "title",
            "metaValue": "Yes Securities All Weather Basket Portfolio | WealthDesk",
            "metaType": "title"
          },
          {
            "metaName": "description",
            "metaValue": "All Weather WealthBasket adopts the strategy to help build wealth over a long-term period by diversifying risk across asset classes",
            "metaType": "default"
          }
        ],
        "WealthMultipliers": [
          {
            "metaName": "title",
            "metaValue": "Yes Securities Wealth Multipliers Portfolio | WealthDesk",
            "metaType": "title"
          },
          {
            "metaName": "description",
            "metaValue": "Yes Securities Wealth Multipliers WealthBasket consists Growth stocks that tend to grow at a faster rate than the average stock in the market and consequently, generating returns",
            "metaType": "default"
          }
        ],
        "ValueandSOP": [
          {
            "metaName": "title",
            "metaValue": "Yes Securities Value Investing & Special Opportunities Portfolio ",
            "metaType": "title"
          },
          {
            "metaName": "description",
            "metaValue": "Value Investing & Special Opportunities WealthBasket is for Benjamin Graham (Value Investing) fans, comprising the Conservative Club High Margin of safety minimizes downside risk for the portfolio",
            "metaType": "default"
          }
        ],
        "TurnaroundWondersw": [
          {
            "metaName": "title",
            "metaValue": "Yes Securities Turnaround Wonders Portfolio | WealthDeskk",
            "metaType": "title"
          },
          {
            "metaName": "description",
            "metaValue": "Yes Securities Turnaround Wonders WealthBasket is focused on identifying and investing in companies that are close to their inflection points in their businesses.",
            "metaType": "default"
          }
        ],
        "Millenials": [
          {
            "metaName": "title",
            "metaValue": "Yes Securities Millennials Portfolio | WealthDesk",
            "metaType": "title"
          },
          {
            "metaName": "description",
            "metaValue": "Yes Securities Millennials WealthBasket designed to benefit from the spending, consumption and investment habits of millennials",
            "metaType": "default"
          }
        ],
        "EconomicMoat": [
          {
            "metaName": "title",
            "metaValue": "Yes Securities Economic Moat Portfolio | WealthDesk",
            "metaType": "title"
          },
          {
            "metaName": "description",
            "metaValue": "Economic Moat WealthBasket has companies with strong economic moats that can not only withstand economic headwinds but also compound their earnings over the long run.",
            "metaType": "default"
          }
        ],
        "Tradersdelight": [
          {
            "metaName": "title",
            "metaValue": "Yes Securities Traders Delight Portfolio | WealthDesk",
            "metaType": "title"
          },
          {
            "metaName": "description",
            "metaValue": "Yes Securities Traders Delight WealthBasket designed to identify stocks across various sectors, that are displaying price momentum which can generate alpha in trending markets.",
            "metaType": "default"
          }
        ],
        "MarketGurus": [
          {
            "metaName": "title",
            "metaValue": "Yes Securities Best of Market Gurus Portfolio | WealthDesk",
            "metaType": "title"
          },
          {
            "metaName": "description",
            "metaValue": "Yes Securities Best of Market Gurus WealthBasket has selected stocks from the portfolios of prominent veteran investors, reaps the reward of trusting the intellect of investors with proven mettle.",
            "metaType": "default"
          }
        ],
        "8Rockstars": [
          {
            "metaName": "title",
            "metaValue": "Yes Securities 8 Rock-stars Portfolio | WealthDesk",
            "metaType": "title"
          },
          {
            "metaName": "description",
            "metaValue": "Yes Securities 8 Rock-stars WealthBasket has 8 high conviction investment ideas for those pursuing significant alpha Concentrated portfolio leads to fewer investments, but high conviction ideas that endeavors to generate better returns",
            "metaType": "default"
          }
        ],
        "ClassicEquity": [
          {
            "metaName": "title",
            "metaValue": "Yes Securities Classic Equity Portfolio | WealthDesk",
            "metaType": "title"
          },
          {
            "metaName": "description",
            "metaValue": "Yes Securities Classic Equity WealthBasket consists of high quality stocks that have the potential to compound handsomely over 3-5 years",
            "metaType": "default"
          }
        ]
      },
      "axisdirect": {
        "FundDiscoveryController": [
          {
            "metaName": "title",
            "metaValue": "Axis Direct Portfolios | WealthBaskets | WealthDesk",
            "metaType": "title"
          },
          {
            "metaName": "description",
            "metaValue": "Sign in with Axis Direct to invest in stock and ETF portfolios created by SEBI Registered Professionals on WealthDesk.",
            "metaType": "default"
          }
        ],
        "FAQController": [
          {
            "metaName": "title",
            "metaValue": "FAQs | Axis Direct | WealthBaskets | WealthDesk",
            "metaType": "title"
          },
          {
            "metaName": "description",
            "metaValue": "Get answers to Frequently Asked Questions (FAQs) about Axis Direct, WealthDesk and WealthBaskets. How to invest in WealthBaskets, pricing and more.",
            "metaType": "default"
          }
        ],
        "ContactUsController": [
          {
            "metaName": "title",
            "metaValue": "WealthDesk Support: Contact Us | Axis Direct",
            "metaType": "title"
          },
          {
            "metaName": "description",
            "metaValue": "Get in touch with us for any questions or concerns regarding Axis Direct WealthBaskets",
            "metaType": "default"
          }
        ],
        "DisclosureController": [
          {
            "metaName": "title",
            "metaValue": "Disclosure | Axis Direct | WealthDesk ",
            "metaType": "title"
          },
          {
            "metaName": "description",
            "metaValue": "Terms and conditions, disclosures, privacy policies affiliated with WealthBaskets, WealthDesk and Axis Direct.",
            "metaType": "default"
          }
        ],
        "BalancedAI": [
          {
            "metaName": "title",
            "metaValue": "Balanced AI Portfolio | Axis Direct | WealthDesk",
            "metaType": "title"
          },
          {
            "metaName": "description",
            "metaValue": "Balanced AI WealthBasket focusses on multi-factor strategy approach that is suitable for all evolving market environments to get optimum potential returns while significantly reducing risk in the long term.",
            "metaType": "default"
          }
        ],
        "AggressiveAI": [
          {
            "metaName": "title",
            "metaValue": "Aggressive AI Portfolio | Axis Direcct | WealthDesk",
            "metaType": "title"
          },
          {
            "metaName": "description",
            "metaValue": "Aggressive AI WealthBasket strategy applies unique approach to deliver alpha by applying equal exposure to ‘Core' and ‘Satellite' factors. ",
            "metaType": "default"
          }
        ]
      },
      "adityabirlamoney": {
        "HomeController": [
          {
            "metaName": "title",
            "metaValue": "Aditya Birla Money Limited | WealthBaskets | WealthDesk",
            "metaType": "title"
          },
          {
            "metaName": "description",
            "metaValue": "Sign in with Aditya Birla Capital to invest in stock and ETF portfolios created by SEBI Registered Professionals on WealthDesk.",
            "metaType": "default"
          }
        ],
        "FundDiscoveryController": [
          {
            "metaName": "title",
            "metaValue": "Invest in Premium Portfolios | Aditya Birla Money Limited | WealthDesk",
            "metaType": "title"
          },
          {
            "metaName": "description",
            "metaValue": "Invest in WealthBaskets with Aditya Birla Capital. Login now to invest in portfolios based on a theme, idea or sector created by SEBI Registered Professionals.",
            "metaType": "default"
          }
        ],
        "FAQController": [
          {
            "metaName": "title",
            "metaValue": "FAQs | Aditya Birla | WealthBaskets | WealthDesk",
            "metaType": "title"
          },
          {
            "metaName": "description",
            "metaValue": "Find answers to frequently asked questions (FAQs) about WealthDesk (Aditya Birla Money Limited). How to invest in WealthBaskets, Pricing, and more.",
            "metaType": "default"
          }
        ],
        "ContactUsController": [
          {
            "metaName": "title",
            "metaValue": "WealthDesk Support: Contact Us | Aditya Birla Money",
            "metaType": "title"
          },
          {
            "metaName": "description",
            "metaValue": "Get in touch with us for any questions or concerns regarding Aditya Birla WealthBaskets",
            "metaType": "default"
          }
        ],
        "DisclosureController": [
          {
            "metaName": "title",
            "metaValue": "Disclosure | Aditya Birla | WealthDesk",
            "metaType": "title"
          },
          {
            "metaName": "description",
            "metaValue": "Privacy Policies, Terms & Conditions, and disclaimers affiliated with WealthBaskets, WealthDesk and Aditya Birla Money Limited.",
            "metaType": "default"
          }
        ],
        "ABMINDIAGROWTH": [
          {
            "metaName": "title",
            "metaValue": "Aditya Birla Money India Growth Portfolio | WealthDesk",
            "metaType": "title"
          },
          {
            "metaName": "description",
            "metaValue": "ABM India Growth portfolio WealthBasket objective is to give investors an opportunity to invest in long term sustainable domestic growth opportunities through a concentrated portfolio.",
            "metaType": "default"
          }
        ],
        "ABMNEWAGEPORTFOLIO": [
          {
            "metaName": "title",
            "metaValue": "Aditya Birla Money Emerging Opportunities Portfolio | WealthDesk",
            "metaType": "title"
          },
          {
            "metaName": "description",
            "metaValue": "ABM Emerging opportunities portfolio WealthBasket objective is to capture emerging trends in the investment landscape; the portfolio has a judicious mix of industry leaders and disrupters.",
            "metaType": "default"
          }
        ],
        "Focusedfive": [
          {
            "metaName": "title",
            "metaValue": "Aditya Birla Money FocusedFive Portfolio | WealthDesk",
            "metaType": "title"
          },
          {
            "metaName": "description",
            "metaValue": "ABM FocusedFive WealthBasket objective is to generate excess returns by building a concentrated portfolio and following the dual approach of superior stock selection and tactical positioning.",
            "metaType": "default"
          }
        ],
        "AbakkusSmartFlexiCapPortfolio": [
          {
            "metaName": "title",
            "metaValue": "Abakkus Smart Flexi-Cap Portfolio | Aditya Birla | WealthDesk",
            "metaType": "title"
          },
          {
            "metaName": "description",
            "metaValue": "Abakkus Smart Flexi-Cap Portfolio WealthBasket aims to generate alpha & risk adjusted returns by creating a portfolio predominantly with Top 250 companies.",
            "metaType": "default"
          }
        ],
        "MomentumPortfolio": [
          {
            "metaName": "title",
            "metaValue": "Alpha Momentum Portfolio | Aditya Birla | WealthDesk",
            "metaType": "title"
          },
          {
            "metaName": "description",
            "metaValue": "Alpha Momentum WealthBasket combines a fundamental investment philosophy with a tactical strategy that aims to generate absolute returns on a timely basis.",
            "metaType": "default"
          }
        ],
        "Bluechip": [
          {
            "metaName": "title",
            "metaValue": "Alpha Bluechip Portfolio | Aditya Birla |WealthDesk",
            "metaType": "title"
          },
          {
            "metaName": "description",
            "metaValue": "Alpha Bluechip WealthBasket invests in companies with high growth potential that deliver superior risk adjusted returns over the medium-term to long-term.",
            "metaType": "default"
          }
        ],
        "OpenQShubhArambhConservativeMonthlyRebal": [
          {
            "metaName": "title",
            "metaValue": "Evergreen Multi-asset Conservative | Aditya Birla | WealthDesk",
            "metaType": "title"
          },
          {
            "metaName": "description",
            "metaValue": "Evergreen Multi-asset Conservative WealthBasket is suitable for low risk investors, this portfolio invests in equity, debt and gold depending upon the relative attractiveness of the asset.",
            "metaType": "default"
          }
        ],
        "SIPTruffle": [
          {
            "metaName": "title",
            "metaValue": "Tamohara Stock SIP Portfolio | Aditya Birla | WealthDesk",
            "metaType": "title"
          },
          {
            "metaName": "description",
            "metaValue": "Tamohara Stock SIP WealthBasket is a direct equity SIP consists of seven handpicked stocks, which have a structural opportunity to grow in India over the next decade.",
            "metaType": "default"
          }
        ]
      },
      "iiflsecurities": {
        "HomeController": [
          {
            "metaName": "title",
            "metaValue": "IIFL Securities Easy Investing on WealthDesk",
            "metaType": "title"
          },
          {
            "metaName": "description",
            "metaValue": "IIFL Securities enables you to invest in WealthBaskets created and managed by SEBI Registered Professional on WealthDesk.",
            "metaType": "default"
          }
        ],
        "FundDiscoveryController": [
          {
            "metaName": "title",
            "metaValue": "Invest in Premium WealthBasket Portfolios | IIFL Securities | WealthBaskets",
            "metaType": "title"
          },
          {
            "metaName": "description",
            "metaValue": "Invest in portfolios created by SEBI Registered Professionals with WealthDesk. Log in with your IIFL Securities account to start investing in WealthBaskets.",
            "metaType": "default"
          }
        ],
        "FAQController": [
          {
            "metaName": "title",
            "metaValue": "FAQs | IIFL Securities | WealthBaskets | WealthDesk",
            "metaType": "title"
          },
          {
            "metaName": "description",
            "metaValue": "Get answers to Frequently Asked Questions (FAQs) about IIFL Securities, WealthDesk and WealthBaskets. How to invest in WealthBaskets, pricing and more.",
            "metaType": "default"
          }
        ],
        "DisclosureController": [
          {
            "metaName": "title",
            "metaValue": "Disclosure | WealthBaskets | WealthDesk",
            "metaType": "title"
          },
          {
            "metaName": "description",
            "metaValue": "Terms and conditions, disclosures, privacy policies affiliated with WealthBaskets, WealthDesk and IIFL Securities.",
            "metaType": "default"
          }
        ],
        "AbakkusSmartFlexiCapPortfolio": [
          {
            "metaName": "title",
            "metaValue": "Abakkus Smart Flexi-Cap Portfolio | IIFL Securities | WealthDesk",
            "metaType": "title"
          },
          {
            "metaName": "description",
            "metaValue": "Abakkus Smart Flexi-Cap Portfolio WealthBasket aims to generate alpha & risk adjusted returns by creating a portfolio predominantly with Top 250 companies.",
            "metaType": "default"
          }
        ],
        "CoreandSatellitePortfolio": [
          {
            "metaName": "title",
            "metaValue": "Alpha Core & Satellite Portfolio | IIFL Securities | WealthDesk",
            "metaType": "title"
          },
          {
            "metaName": "description",
            "metaValue": "Alpha Core & Satellite WealthBasket ensures wealth creation by investing in long-term secular growth companies and owning industry leaders that create higher ROCE.",
            "metaType": "default"
          }
        ],
        "ThemanticPortfolio": [
          {
            "metaName": "title",
            "metaValue": "Alpha Dynamic Thematic Portfolios | IIFL Securities | WealthDesk",
            "metaType": "title"
          },
          {
            "metaName": "description",
            "metaValue": "Alpha Dynamic Thematic WealthBasket invests in stocks that fall within a particular theme. The theme selection is driven by macroeconomic conditions and sectoral trends",
            "metaType": "default"
          }
        ]
      }
    }
  }
}

app.value('seotags', {
  TAGS: TAGS
})

function plaintext(text) {
  if (text) {
    var normalText = String(text).replace(/<[^>]+>/gm, '');
    return String(normalText).replaceAll('&nbsp;', ' ').replaceAll('&amp;', '&');
  }
  return '';
}